/* eslint-disable */
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Blob: { input: unknown; output: unknown };
  Date: { input: string; output: string };
  DateTime: { input: string; output: string };
  JSONObject: { input: Record<string, unknown>; output: Record<string, unknown> };
  Long: { input: number; output: number };
  PhoneNumber: { input: string; output: string };
  TimeIntervalInMillis: { input: number; output: number };
  TimestampInMillis: { input: number; output: number };
};

export type AiVideoTags = {
  potential_cellphone_usage?: Maybe<Scalars['Boolean']['output']>;
  seatbelt_detection?: Maybe<SeatbeltDetection>;
};

export type AccessPoints = {
  /** The wifi list for the fleet. */
  access_points?: Maybe<Array<Maybe<WifiSetting>>>;
};

export type AcessibleFleets = {
  associated_at?: Maybe<Scalars['String']['output']>;
  fleet_id?: Maybe<Scalars['String']['output']>;
  groups_restriction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  role?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type ActivationTask = {
  category: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ActivationTaskInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ActivitiesSummary = {
  completed: ExecutionDigestSummary;
  not_completed: ExecutionDigestSummary;
  total: Scalars['Int']['output'];
  waiting: ExecutionDigestSummary;
};

export type ActivitiesSummaryInput = {
  devices_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  drivers_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  end_time?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  routes_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  start_time?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  text_filter?: InputMaybe<Scalars['String']['input']>;
  vehicles_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Activity = {
  additional_info?: Maybe<Scalars['String']['output']>;
  arrival_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  completion_status?: Maybe<ActivityCompletionStatus>;
  created_at: Scalars['TimestampInMillis']['output'];
  destination: Destination;
  device_id?: Maybe<Scalars['String']['output']>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  driver_name?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  executed_duration?: Maybe<Scalars['TimeIntervalInMillis']['output']>;
  executed_end_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  fleet_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  load_size?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  planned_distance_in_meters?: Maybe<Scalars['Int']['output']>;
  planned_duration?: Maybe<Scalars['TimeIntervalInMillis']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  proof_of_conclusion?: Maybe<OldProofOfConclusion>;
  route_id?: Maybe<Scalars['ID']['output']>;
  route_name?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  time_windows?: Maybe<Array<TimeWindow>>;
  type: ActivityType;
  updated_at: Scalars['TimestampInMillis']['output'];
  vehicle_id?: Maybe<Scalars['ID']['output']>;
  visit_status: ActivityVisitStatus;
  waiting_time?: Maybe<Scalars['TimeIntervalInMillis']['output']>;
};

export type ActivityCompletionStatus = 'COMPLETED' | 'NOT_COMPLETED' | 'PARTIALLY_COMPLETED' | 'PLANNED';

export type ActivityReport = {
  completion_status?: Maybe<ActivityCompletionStatus>;
  destination: Destination;
  driver?: Maybe<Driver>;
  duration: PlannedVsExecutedDurationTimeInMillis;
  end_time: PlannedVsExecutedTimestampInMillis;
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  observations?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  start_time: PlannedVsExecutedTimestampInMillis;
  time_windows?: Maybe<Array<TimeWindow>>;
  type: ActivityType;
  vehicle?: Maybe<VehicleDto>;
  visit_status: ActivityVisitStatus;
};

export type ActivityRouteRelation = 'ACTIVITIES_WITHIN_ROUTE' | 'ACTIVITIES_WITHOUT_ROUTE' | 'ALL_ACTIVITIES';

export type ActivityType = 'END' | 'START' | 'STOP';

export type ActivityUpdate = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input_activity?: InputMaybe<InputActivity>;
  type?: InputMaybe<ActivityType>;
};

export type ActivityVehicleAssociationInput = {
  device_id?: InputMaybe<Scalars['String']['input']>;
  driver_id?: InputMaybe<Scalars['ID']['input']>;
  driver_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  vehicle_id?: InputMaybe<Scalars['ID']['input']>;
};

export type ActivityVisitStatus = 'NOT_VISITED' | 'ON_SITE' | 'PENDING' | 'VISITED';

export type AdasEvents = {
  forward_collision_warning: SensibilityConfiguration;
  min_speed_trigger_in_km_per_h: Scalars['Int']['output'];
  /** Distância insegura. Null when the fleet never set it apart: it then follows forward_collision_warning */
  tail_gating?: Maybe<SensibilityConfiguration>;
};

export type AdasEventsInput = {
  forward_collision_warning: SensibilityConfigurationInput;
  min_speed_trigger_in_km_per_h: Scalars['Int']['input'];
  tail_gating?: InputMaybe<SensibilityConfigurationInput>;
};

export type AddDriver = {
  cpf?: InputMaybe<Scalars['String']['input']>;
  driver_license?: InputMaybe<Scalars['String']['input']>;
  first_license_acquirement_date?: InputMaybe<Scalars['Date']['input']>;
  license_category?: InputMaybe<Scalars['String']['input']>;
  license_expiration_date?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_image_base64?: InputMaybe<Scalars['String']['input']>;
  registry_id?: InputMaybe<Scalars['String']['input']>;
};

export type AddressInformation = {
  additionalInformation?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AggregatedSpeedEventsSummary = {
  highEvents: Scalars['Int']['output'];
  higherEvents: Scalars['Int']['output'];
  mediumEvents: Scalars['Int']['output'];
  totalEvents: Scalars['Int']['output'];
};

export type ApplyGroupRecommendationInput = {
  name: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds: Array<Scalars['ID']['input']>;
};

/** How archived videos are treated when listing media */
export type ArchivedMediaFilter =
  /** Hide archived videos */
  | 'EXCLUDE'
  /** Archived and not archived videos */
  | 'INCLUDE'
  /** Only archived videos, the most recently archived first */
  | 'ONLY';

export type AssociatedContact = {
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type AssociationConfig = {
  entire_fleet_association_config?: Maybe<EntireFleetAssociationConfig>;
};

export type AssociationConfigInput = {
  entire_fleet_association_config: EntireFleetAssociationConfigInput;
};

export type AudioCoachingDevicesInfo = {
  /** The status of the camera audio. */
  audio_status: AudioStatus;
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['output'];
  /** Last time that the camera changed from config in RFC 3339 format */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AudioCoachingDevicesInfoPage = {
  content?: Maybe<Array<Maybe<AudioCoachingDevicesInfo>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type AudioFileResponse = {
  /** Public HTTPS URL to download the audio file from S3. */
  audioUrl: Scalars['String']['output'];
};

export type AudioStatus =
  | 'HIGH'
  | 'LOW'
  | 'MEDIUM'
  | 'OFF'
  /** ON is deprecated and should be replaced with LOW, MEDIUM or HIGH */
  | 'ON';

export type AvgFuelConsumptionAndCostPerKmResponse = {
  avgCostPerKm: Scalars['Float']['output'];
  avgFuelConsumption: Scalars['Float']['output'];
  chartGroup?: Maybe<Scalars['String']['output']>;
  endInterval: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  startInterval: Scalars['String']['output'];
};

export type BatchCreateDriverItemInput = {
  cpf?: InputMaybe<Scalars['String']['input']>;
  driver_license?: InputMaybe<Scalars['String']['input']>;
  first_license_acquirement_date?: InputMaybe<Scalars['Date']['input']>;
  license_category?: InputMaybe<Scalars['String']['input']>;
  license_expiration_date?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  registry_id?: InputMaybe<Scalars['String']['input']>;
};

export type BatchCreateDriversInput = {
  drivers: Array<BatchCreateDriverItemInput>;
};

export type BatchCreateIdentificationTokenItemInput = {
  driverId?: InputMaybe<Scalars['ID']['input']>;
  tokenId: Scalars['String']['input'];
};

export type BatchCreateIdentificationTokensInput = {
  items: Array<BatchCreateIdentificationTokenItemInput>;
};

export type BatchCreateVehicleInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  branding?: InputMaybe<BrandingInput>;
  fuel?: InputMaybe<FuelInput>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  licensePlate: Scalars['String']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  speedInKmh?: InputMaybe<Scalars['Int']['input']>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BatchSuggestionInput = {
  plates?: InputMaybe<Array<Scalars['String']['input']>>;
  vins?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BatchSuggestionsResponse = {
  results: Array<VehicleSuggestionEntry>;
};

export type Billet = {
  barCode?: Maybe<Scalars['String']['output']>;
  boletoLink?: Maybe<Scalars['String']['output']>;
  cardCode?: Maybe<Scalars['String']['output']>;
  cardName?: Maybe<Scalars['String']['output']>;
  dataEmissao?: Maybe<Scalars['String']['output']>;
  dataVencimento?: Maybe<Scalars['String']['output']>;
  datePayment?: Maybe<Scalars['String']['output']>;
  diaProRata?: Maybe<Scalars['String']['output']>;
  digitableLine?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  idCompany?: Maybe<Scalars['Long']['output']>;
  idContract?: Maybe<Scalars['String']['output']>;
  idDoc?: Maybe<Scalars['String']['output']>;
  nfeDataEmissao?: Maybe<Scalars['String']['output']>;
  nfeHoraEmissao?: Maybe<Scalars['String']['output']>;
  nfeIdContract?: Maybe<Scalars['String']['output']>;
  nfeLink?: Maybe<Scalars['String']['output']>;
  nfeTitleValue?: Maybe<Scalars['String']['output']>;
  nrDocEntry?: Maybe<Scalars['String']['output']>;
  nrDocumento?: Maybe<Scalars['String']['output']>;
  nrNfse?: Maybe<Scalars['String']['output']>;
  nrNoteEntry?: Maybe<Scalars['String']['output']>;
  payedValue?: Maybe<Scalars['String']['output']>;
  runnedAt?: Maybe<Scalars['Int']['output']>;
  seqCode?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  titleValue?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export type Branding = {
  brand?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type BrandingInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type CacheControlScope = 'PRIVATE' | 'PUBLIC';

export type CameraConfigurationInfo = {
  /** The status of the camera audio. */
  audio_status?: Maybe<AudioStatus>;
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['output'];
  /** The duty type of the vehicle. */
  duty_type?: Maybe<DutyType>;
  /** Recording resolution of the camera */
  recording_resolution?: Maybe<RecordingResolution>;
  /** The desired speed limit to audio warning */
  speed_limit_warning_in_kmph?: Maybe<Scalars['Float']['output']>;
  /** Last time that the camera changed from config in RFC 3339 format */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CameraConfigurationInfoPage = {
  content?: Maybe<Array<Maybe<CameraConfigurationInfo>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type CameraConfigurationUpdateInput = {
  /** The status of the camera audio. */
  audio_status?: InputMaybe<AudioStatus>;
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['input'];
  /** The duty type of the vehicle. */
  duty_type?: InputMaybe<DutyType>;
  /** Recording resolution of the camera */
  recording_resolution?: InputMaybe<RecordingResolution>;
  /** The desired speed limit to audio warning */
  speed_limit_warning_in_kmph?: InputMaybe<Scalars['Float']['input']>;
};

export type CameraEventsConfiguration = {
  entire_fleet_camera_events_configuration: EventsConfiguration;
};

export type CancelOperationalSituationInput = {
  id: Scalars['ID']['input'];
};

export type Category = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CategoryCost = {
  cost: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/**
 * Move de 1 a 100 tratativas para o mesmo status, tudo ou nada. RESOLVED exige `note` (1 a 500
 * caracteres) e `assigneeUserId` de um usuário da frota; o responsável só é aceito ao resolver.
 */
export type ChangeChecklistNonConformityStatusInput = {
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
  expectedVersions?: InputMaybe<Array<ChecklistNonConformityVersionInput>>;
  ids: Array<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  targetStatus: ChecklistNonConformityStatus;
};

export type CheckContent = {
  checked?: Maybe<Scalars['Boolean']['output']>;
};

export type Checklist = {
  completed_count?: Maybe<Scalars['Int']['output']>;
  /**
   * Compliance of the response as a whole, rolled up from its questions by ryuk.
   * Nullable on purpose: older ryuk versions do not send it, and templates never carry one.
   */
  compliance_status?: Maybe<ChecklistComplianceStatus>;
  context?: Maybe<Context>;
  created_at: Scalars['Float']['output'];
  created_by: Scalars['String']['output'];
  fields: Array<Field>;
  groups: Array<ChecklistConfiguredGroup>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  non_conform_field_count?: Maybe<Scalars['Int']['output']>;
  pending_photos_field_count?: Maybe<Scalars['Int']['output']>;
  /**
   * True when the response still has a field that requires photos and has not received them yet.
   * Nullable on purpose: ryuk only started sending it in #215, so older versions resolve to null.
   */
  photos_pending?: Maybe<Scalars['Boolean']['output']>;
  template: Scalars['Boolean']['output'];
  template_active?: Maybe<Scalars['Boolean']['output']>;
  template_created_at?: Maybe<Scalars['Float']['output']>;
  template_created_by?: Maybe<Scalars['String']['output']>;
  template_id?: Maybe<Scalars['String']['output']>;
  vehicle_group_ids?: Maybe<Array<Scalars['ID']['output']>>;
  vehicle_ids?: Maybe<Array<Scalars['ID']['output']>>;
  vehicles: Array<ChecklistConfiguredVehicle>;
  version: Scalars['Int']['output'];
};

/**
 * Whether picking an option counts as conform. Set by the manager on the template and copied into
 * each answer when it is created.
 */
export type ChecklistCompliance = 'CONFORM' | 'NON_CONFORM';

/**
 * Compliance of a response as a whole. NOT_APPLICABLE covers a response whose template marks no
 * option, including every response answered before compliance existed.
 */
export type ChecklistComplianceStatus = 'CONFORM' | 'NON_CONFORM' | 'NOT_APPLICABLE';

export type ChecklistConfiguredGroup = {
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
};

export type ChecklistConfiguredVehicle = {
  group_id?: Maybe<Scalars['ID']['output']>;
  group_path: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ChecklistNonConformitiesFilter = {
  /** Só as tratativas que têm ocorrência nesta resposta. */
  checklistId?: InputMaybe<Scalars['ID']['input']>;
  driverNames?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Busca no título da pergunta, na placa e no nome do motorista. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Padrão 25. */
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ChecklistNonConformitySort>;
  /** Início do período, sobre a última reprovação. */
  startDate?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  statuses?: InputMaybe<Array<ChecklistNonConformityStatus>>;
  templateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Tratativa (na interface) de um item não conforme de checklist: uma pergunta de um modelo que reprovou
 * num veículo, acompanhada até alguém tratar. Reprovações seguidas da mesma pergunta no mesmo veículo
 * viram ocorrências da mesma tratativa enquanto ela está ativa.
 */
export type ChecklistNonConformity = {
  /** Quem foi indicado como responsável ao resolver. Nulo se o usuário não existe mais na frota. */
  assignee?: Maybe<FleetUser>;
  checklistTemplate: ChecklistNonConformityTemplate;
  /** Motorista da última reprovação, pelo nome: o checklist não guarda id de motorista. */
  driverName?: Maybe<Scalars['String']['output']>;
  firstDetectedAt: Scalars['TimestampInMillis']['output'];
  /** Trilha imutável, da entrada mais nova para a mais antiga. */
  history?: Maybe<Array<ChecklistNonConformityHistoryEntry>>;
  id: Scalars['ID']['output'];
  /** Resposta da última reprovação, para abrir o checklist completo. */
  lastChecklistId: Scalars['ID']['output'];
  lastDetectedAt: Scalars['TimestampInMillis']['output'];
  /** Placa registrada na última reprovação. */
  licensePlate?: Maybe<Scalars['String']['output']>;
  occurrenceCount: Scalars['Int']['output'];
  /** Respostas que reprovaram, da mais nova para a mais antiga. */
  occurrences?: Maybe<Array<ChecklistNonConformityOccurrence>>;
  /** Identidade estável da pergunta no modelo, a mesma de `Field.questionKey`. */
  questionKey: Scalars['ID']['output'];
  /** Título da pergunta na última reprovação. */
  questionTitle: Scalars['String']['output'];
  /** Observação da última mudança de status para RESOLVED ou DISMISSED. */
  resolutionNote?: Maybe<Scalars['String']['output']>;
  status: ChecklistNonConformityStatus;
  statusChangedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  /** Quem fez a última mudança de status. Nulo quando foi o sistema ou o usuário não existe mais. */
  statusChangedBy?: Maybe<FleetUser>;
  /** O veículo hoje. Nulo se ele foi excluído; a placa da reprovação continua em `licensePlate`. */
  vehicle?: Maybe<VehicleDto>;
  vehicleId: Scalars['ID']['output'];
  /** Envie em `expectedVersions` para que a mudança de status recuse um estado que outra pessoa já alterou. */
  version: Scalars['Int']['output'];
};

export type ChecklistNonConformityHistoryEntry = {
  actor?: Maybe<FleetUser>;
  /** Nome de quem agiu no momento do registro. Nulo quando foi o sistema. */
  actorName?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<FleetUser>;
  /** Resposta que causou a entrada, quando foi uma reprovação, retirada ou auto-resolução. */
  checklistId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['TimestampInMillis']['output'];
  fromStatus?: Maybe<ChecklistNonConformityStatus>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  toStatus?: Maybe<ChecklistNonConformityStatus>;
  type: ChecklistNonConformityHistoryEntryType;
};

export type ChecklistNonConformityHistoryEntryType =
  /** Primeira reprovação: abriu a tratativa. */
  | 'DETECTED'
  /** Nova reprovação da mesma pergunta no mesmo veículo enquanto a tratativa estava ativa. */
  | 'OCCURRENCE_ADDED'
  /** A resposta foi editada para conforme ou apagada, e deixou de sustentar a tratativa. */
  | 'OCCURRENCE_WITHDRAWN'
  | 'STATUS_CHANGED';

export type ChecklistNonConformityOccurrence = {
  checklistId: Scalars['ID']['output'];
  detectedAt: Scalars['TimestampInMillis']['output'];
  driverName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Preenchido quando a resposta foi editada para conforme ou apagada. */
  withdrawnAt?: Maybe<Scalars['TimestampInMillis']['output']>;
};

export type ChecklistNonConformityPageInfo = {
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ChecklistNonConformityPaginated = {
  content: Array<ChecklistNonConformity>;
  page: ChecklistNonConformityPageInfo;
};

export type ChecklistNonConformitySort = {
  column?: ChecklistNonConformitySortColumn;
  order?: Order;
};

export type ChecklistNonConformitySortColumn = 'FIRST_DETECTED_AT' | 'LAST_DETECTED_AT' | 'OCCURRENCE_COUNT' | 'QUESTION_TITLE' | 'STATUS';

/**
 * Onde a tratativa está. AUTO_RESOLVED só o sistema aplica, quando a resposta seguinte do mesmo veículo
 * vem conforme; RESOLVED e AUTO_RESOLVED são finais e DISMISSED é o único estado que pode ser reaberto.
 */
export type ChecklistNonConformityStatus = 'AUTO_RESOLVED' | 'DISMISSED' | 'IN_TREATMENT' | 'OPEN' | 'RESOLVED';

/** Contagem por status para os mesmos filtros da fila. */
export type ChecklistNonConformitySummary = {
  autoResolved: Scalars['Int']['output'];
  dismissed: Scalars['Int']['output'];
  inTreatment: Scalars['Int']['output'];
  open: Scalars['Int']['output'];
  resolved: Scalars['Int']['output'];
};

/** O modelo de checklist em que a pergunta reprovou. O nome continua disponível mesmo com o modelo apagado. */
export type ChecklistNonConformityTemplate = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ChecklistNonConformityVersionInput = {
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

export type ChecklistVehicle = {
  alias?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  device_id: Scalars['String']['output'];
  /** @deprecated Snapshot from the driver app; stays null when the vehicle joined its group after the association opened (BUG-2708). Use `Context.group_path` instead. */
  group_id?: Maybe<Scalars['String']['output']>;
  license_plate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type ChecklistsNames = {
  names: Array<Maybe<Scalars['String']['output']>>;
};

export type ChecklistsPage = {
  page: PaginatedChecklists;
};

export type ClientInformation = {
  additionalInformation?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  installationDoneByClient?: Maybe<Scalars['Boolean']['output']>;
  installationProblem?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  responsibleForTrackingScheduling?: Maybe<Scalars['String']['output']>;
  secondaryPhone?: Maybe<Scalars['String']['output']>;
};

export type CoachingEvidence = {
  files?: Maybe<Array<Maybe<CoachingEvidenceFile>>>;
  id?: Maybe<Scalars['ID']['output']>;
  media?: Maybe<MediaResponse>;
  media_id?: Maybe<Scalars['ID']['output']>;
  safety_occurrences?: Maybe<Array<Maybe<SafetyOccurrence>>>;
  type?: Maybe<CoachingEvidenceType>;
};

export type CoachingEvidenceFile = {
  created_at?: Maybe<Scalars['DateTime']['output']>;
  file_timestamp?: Maybe<Scalars['Int']['output']>;
  file_type: CoachingFileType;
  file_url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type CoachingEvidenceType = 'MEDIA';

export type CoachingFeedback = {
  coaching_evidences?: Maybe<Array<Maybe<CoachingEvidence>>>;
  created_at: Scalars['DateTime']['output'];
  created_by_user?: Maybe<FleetUser>;
  driver?: Maybe<Driver>;
  feedback_action?: Maybe<CoachingFeedbackAction>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  note_author?: Maybe<FleetUser>;
  note_created_at?: Maybe<Scalars['DateTime']['output']>;
  status: CoachingFeedbackStatus;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by_user?: Maybe<FleetUser>;
};

export type CoachingFeedbackAction = 'DISMISSAL' | 'GUIDANCE' | 'NO_ACTION' | 'SUSPENSION' | 'WARNING';

export type CoachingFeedbackInput = {
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  fromUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mediaId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  safetyOccurrenceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<CoachingFeedbackStatus>>>;
  toUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CoachingFeedbackPage = {
  content?: Maybe<Array<Maybe<CoachingFeedback>>>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  number_of_elements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total_elements: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type CoachingFeedbackStatus = 'ADDING_EVIDENCES' | 'APPLYING' | 'FINISHED';

export type CoachingFileType = 'CUSTOM_UPLOAD' | 'THUMBNAIL' | 'VIDEO_FRAME';

export type CoblerInformation = {
  contactResponsible?: Maybe<Scalars['String']['output']>;
  responsible?: Maybe<Scalars['String']['output']>;
  schedulingResponsible?: Maybe<Scalars['String']['output']>;
  technicianResponsible?: Maybe<Scalars['String']['output']>;
};

export type ColumnMapEntryInput = {
  key: Scalars['String']['input'];
  value: ColumnMapInput;
};

export type ColumnMapInput = {
  name: Scalars['String']['input'];
  position: Scalars['String']['input'];
};

export type CompletionData = {
  fleetSize?: Maybe<Scalars['Int']['output']>;
  openTicketsToInstall?: Maybe<Scalars['Int']['output']>;
  vehicleInstalledCount?: Maybe<Scalars['Int']['output']>;
};

export type ConditionCategory =
  | 'DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD_NORMAL'
  | 'DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD_NORMAL_UNAVAILABLE'
  | 'DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD_UNAVAILABLE'
  | 'GEOFENCE_IN'
  | 'GEOFENCE_IN_OUT'
  | 'GEOFENCE_OUT'
  | 'IDLE_ENGINE_3_MINUTES'
  | 'IDLE_ENGINE_5_MINUTES'
  | 'IDLE_ENGINE_10_MINUTES'
  | 'IDLE_ENGINE_15_MINUTES'
  | 'IDLE_ENGINE_30_MINUTES';

export type ConferenceEventResponse = {
  actorId?: Maybe<Scalars['ID']['output']>;
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt: Scalars['TimestampInMillis']['output'];
  payload?: Maybe<Scalars['JSONObject']['output']>;
};

export type ConferenceReviewResponse = {
  createdAt: Scalars['TimestampInMillis']['output'];
  id: Scalars['ID']['output'];
  observation?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  reviewedBy?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<ConferenceReviewStatus>;
};

export type ConferenceReviewStatus = 'MARKED_SUSPICIOUS' | 'REVIEWED';

/**
 * O mesmo pacote retornado tanto pela consulta quanto pelas duas mutations de
 * revisão (BE-14/BE-15, ADR-008) -- marcar ou reabrir já devolve o drawer
 * inteiro atualizado, sem round-trip extra.
 */
export type ConferenceTransactionResponse = {
  /**
   * Estado da conferência, calculado pelo frentista na leitura (ADR-011): AWAITING_EVALUATION,
   * NO_DIVERGENCE, NEEDS_REVIEW, REVIEWED ou MARKED_SUSPICIOUS. É String e não enum de propósito, como
   * `ruleEvaluations.result` e `events.eventType`: um estado novo do frentista não pode derrubar a query.
   */
  conferenceStatus: Scalars['String']['output'];
  evaluatedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  events: Array<ConferenceEventResponse>;
  review?: Maybe<ConferenceReviewResponse>;
  ruleEvaluations: Array<RuleEvaluationResponse>;
  transaction: FuelTransactionResponse;
};

export type ContactInformation = {
  bestContactTime?: Maybe<Scalars['String']['output']>;
  bestWayToContact?: Maybe<Scalars['String']['output']>;
  contactMethod?: Maybe<Scalars['String']['output']>;
  contactMethodForResponsibleForInstallation?: Maybe<Scalars['String']['output']>;
};

export type Context = {
  address?: Maybe<Scalars['String']['output']>;
  app_version: Scalars['String']['output'];
  /**
   * Vehicle's group path, resolved server-side by ryuk (see BUG-2708). Prefer over
   * `vehicle.group_id`. `0/` means the fleet root (not the same as null); null means ryuk had
   * nothing to resolve from.
   */
  group_path?: Maybe<Scalars['String']['output']>;
  vehicle?: Maybe<ChecklistVehicle>;
};

export type Coordinate = {
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CoordinateInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CreateCheckpointManualInput = {
  odometerInKm: Scalars['Long']['input'];
  odometerReferenceDate: Scalars['String']['input'];
  vehicleId: Scalars['ID']['input'];
};

export type CreateFleetAudioMessageInput = {
  /** The text content to be converted to audio using text-to-speech. */
  message: Scalars['String']['input'];
  /** Optional name/identifier for the audio message. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFuelTransactionInput = {
  costCenterDescription?: InputMaybe<Scalars['String']['input']>;
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  fuelType: Scalars['String']['input'];
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  licensePlate: Scalars['String']['input'];
  merchant?: InputMaybe<MerchantCreateInput>;
  odometerInKm: Scalars['Float']['input'];
  quantityInLiters: Scalars['Float']['input'];
  totalCost: Scalars['Float']['input'];
  transactionTime: Scalars['String']['input'];
};

export type CreateMaintenanceHistoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  occurrenceAt: Scalars['DateTime']['input'];
  odometerInKms?: InputMaybe<Scalars['Float']['input']>;
  /** Parada que originou o registro, quando ele vem da sugestão. */
  operationalSituationId?: InputMaybe<Scalars['ID']['input']>;
  parts?: InputMaybe<Array<InputMaybe<MaintenancePartInput>>>;
  reminderId?: InputMaybe<Scalars['ID']['input']>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
  types: Array<InputMaybe<Scalars['String']['input']>>;
  vehicleId: Scalars['ID']['input'];
};

export type CreateMaintenancePartsInput = {
  description: Scalars['String']['input'];
};

export type CreateManualOdometerResponse = {
  manualOdometer: ManualOdometer;
  vehicle: VehicleDto;
};

export type CreateMediaRequest = {
  /** Device identifier. A string between 10 and 15 characters. */
  device_id?: InputMaybe<Scalars['String']['input']>;
  /**
   * Enable email notification when the requested media is available.
   * If empty will be considered as false.
   */
  enable_email_notification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Desired media end Unix timestamp in millis. */
  end_time: Scalars['TimestampInMillis']['input'];
  /**
   * Allow a full timelapse media of the selected period.
   * If empty it will be considered false.
   */
  is_timelapse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Desired media start Unix timestamp in millis. */
  start_time: Scalars['TimestampInMillis']['input'];
  /**
   * Fleet policy trigger that originated the request.
   * Only set when the media is requested from an alert; the request origin itself
   * is derived downstream, not sent by the client.
   */
  triggerId?: InputMaybe<Scalars['ID']['input']>;
  /** Trip identifier. */
  trip_id?: InputMaybe<Scalars['String']['input']>;
  /** Vehicle identifier. An UUID */
  vehicle_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateMediaResponse = {
  /** Device identifier. A string between 10 and 15 characters. */
  device_id?: Maybe<Scalars['String']['output']>;
  /** List of emails that will be notified when the request is completed. */
  emails_to_notify?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Desired media end Unix timestamp in millis. */
  end_time: Scalars['TimestampInMillis']['output'];
  /** MediaId from the created media. */
  media_id?: Maybe<Scalars['ID']['output']>;
  /** Desired media start Unix timestamp in millis. */
  start_time: Scalars['TimestampInMillis']['output'];
  /** Vehicle identifier. An UUID */
  vehicle_id?: Maybe<Scalars['ID']['output']>;
};

export type CreateOperationalSituationInput = {
  /** Não é aceito para RESERVE de dispositivo, porque a flag legada isSpare não seria reposta na expiração. */
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Lembrete de manutenção que originou a situação, quando ela vem da sugestão. */
  reminderId?: InputMaybe<Scalars['ID']['input']>;
  situation: OperationalSituationType;
  /** Default: agora. Não pode ser no futuro. */
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  targetId: Scalars['String']['input'];
  targetType: OperationalSituationTargetType;
};

export type CreateReminderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  recurrenceInDays?: InputMaybe<Scalars['Int']['input']>;
  recurrenceInKm?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title: ReminderTitleInput;
  vehicles: Array<CreateReminderVehicleInput>;
};

export type CreateReminderVehicleInput = {
  id: Scalars['ID']['input'];
  nextRecurrenceDate?: InputMaybe<Scalars['DateTime']['input']>;
  nextRecurrenceInKm?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateVehicleInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  branding?: InputMaybe<BrandingInput>;
  driverId?: InputMaybe<Scalars['ID']['input']>;
  fuel?: InputMaybe<FuelInput>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  installedDeviceId?: InputMaybe<Scalars['String']['input']>;
  licensePlate: Scalars['String']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  speedInKmh?: InputMaybe<Scalars['Int']['input']>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateVehiclesBatchInput = {
  vehicles: Array<BatchCreateVehicleInput>;
};

export type CrmOrder = {
  associatedContact?: Maybe<AssociatedContact>;
  createdAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  deviceTotalQuantity?: Maybe<DeviceTotalQuantity>;
  fleetId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  orderClass?: Maybe<Scalars['String']['output']>;
  pipeline?: Maybe<Scalars['String']['output']>;
  responsibleName?: Maybe<Scalars['String']['output']>;
  tickets?: Maybe<Array<Maybe<ITicket>>>;
};

export type CustomDashboard = {
  description: Scalars['String']['output'];
  externalDashboardId: Scalars['String']['output'];
  filters: Array<CustomDashboardFilter>;
  fleets: Array<CustomDashboardFleet>;
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CustomDashboardFilter = {
  filterKey: Scalars['String']['output'];
  filterName: Scalars['String']['output'];
};

export type CustomDashboardFleet = {
  fleetId: Scalars['ID']['output'];
  groupsRestrictions: Array<Scalars['String']['output']>;
};

export type DateInformation = {
  installedDate?: Maybe<Scalars['String']['output']>;
  preferredDay1?: Maybe<Scalars['String']['output']>;
  preferredDay2?: Maybe<Scalars['String']['output']>;
  preferredDay3?: Maybe<Scalars['String']['output']>;
  preferredHour1?: Maybe<Scalars['String']['output']>;
  preferredHour2?: Maybe<Scalars['String']['output']>;
  preferredHour3?: Maybe<Scalars['String']['output']>;
  scheduledDay?: Maybe<Scalars['String']['output']>;
  scheduledHour?: Maybe<Scalars['String']['output']>;
};

export type DateRange = {
  end: Scalars['Float']['input'];
  start: Scalars['Float']['input'];
};

export type DeleteActivitiesIds = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DeleteChecklist = {
  id: Scalars['ID']['input'];
};

export type DeleteDriver = {
  id: Scalars['ID']['input'];
};

export type DeleteFuelTransactionsInput = {
  transactionIds: Array<Scalars['ID']['input']>;
};

export type DeleteMaintenanceHistoryInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMaintenancePartsInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMaintenanceReminderInput = {
  id: Scalars['ID']['input'];
};

export type DeleteRoutesInput = {
  ids: Array<Scalars['ID']['input']>;
  propagation_type?: InputMaybe<Scalars['String']['input']>;
};

export type Destination = {
  city?: Maybe<Scalars['String']['output']>;
  coordinate: Coordinate;
  country?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_address?: Maybe<Scalars['String']['output']>;
  street_complement?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
};

export type DestinationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  coordinate: CoordinateInput;
  country?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_address?: InputMaybe<Scalars['String']['input']>;
  street_complement?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
};

export type Device = {
  activeObservationPeriodTrigger?: Maybe<Trigger>;
  associatedAt: Scalars['DateTime']['output'];
  capabilities: DeviceCapabilities;
  cobliId: Scalars['String']['output'];
  deviceModel?: Maybe<Scalars['String']['output']>;
  disablerStatus?: Maybe<DisablerStatus>;
  fleetId: Scalars['ID']['output'];
  generalStatus: DeviceGeneralStatus;
  generalType: DeviceGeneralType;
  healthStatus: DeviceHealthStatusType;
  id: Scalars['String']['output'];
  isNew: Scalars['Boolean']['output'];
  /** @deprecated Use operationalSituation: uma situação RESERVE ativa significa reserva */
  isSpare: Scalars['Boolean']['output'];
  lastLocation?: Maybe<LastLocation>;
  lastMovingStateTime?: Maybe<Scalars['String']['output']>;
  operationalSituation?: Maybe<OperationalSituation>;
  sdCardHealthStatus?: Maybe<DeviceSdCardHealthStatus>;
  statusSummary: DeviceStatusSummary;
  tracking?: Maybe<DeviceTracking>;
  type: DeviceType;
  vehicle?: Maybe<VehicleDto>;
  vehicleDissociatedAt?: Maybe<Scalars['DateTime']['output']>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
};

export type DeviceCapabilities = {
  reportsVehicleCan: Scalars['Boolean']['output'];
};

export type DeviceCause = {
  cause: DeviceCauseKey;
  status: DeviceStatusType;
};

export type DeviceCauseKey =
  | 'DAMAGED'
  | 'DISCONNECTED'
  | 'IN_DEVOLUTION'
  | 'LOSING_DATA'
  | 'NORMAL'
  | 'NO_SIGNAL'
  | 'NO_SUFFICIENT_DATA'
  | 'SD_CARD_PROBLEM'
  | 'SYNCING'
  | 'UNAVAILABLE';

export type DeviceConfiguration = {
  actual_parameters?: Maybe<Array<Parameter>>;
  device: DeviceDetails;
  id: Scalars['String']['output'];
  target_parameters?: Maybe<Array<Parameter>>;
};

export type DeviceDeliveryTime = {
  deviceId: Scalars['String']['output'];
  mediaType: MediaType;
  p50Ms: Scalars['Float']['output'];
  /** Número de solicitações concluídas que sustentam a mediana. */
  sampleSize: Scalars['Int']['output'];
};

export type DeviceDestination = {
  address?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type DeviceDetails = {
  associated_at: Scalars['DateTime']['output'];
  chip_number: Scalars['String']['output'];
  chip_operator: Scalars['String']['output'];
  cobli_id: Scalars['String']['output'];
  fleet_id: Scalars['ID']['output'];
  icc_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imei: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DeviceFields = {
  cobliId: Scalars['String']['output'];
  lastLocation: LastLocation;
  type: Scalars['String']['output'];
};

export type DeviceGeneralStatus = 'DAMAGED' | 'DISCONNECTED' | 'IN_DEVOLUTION' | 'LOSING_DATA' | 'NORMAL' | 'NO_SIGNAL' | 'NO_SUFFICIENT_DATA' | 'SYNCING' | 'UNAVAILABLE';

export type DeviceGeneralType =
  | 'BLOCKER'
  | 'CAN'
  | 'CAN_IBUTTON'
  | 'CAN_IBUTTON_IMMOBILIZER'
  | 'DASHCAM'
  | 'FAKE'
  | 'IBUTTON'
  | 'IBUTTON_IMMOBILIZER'
  | 'IMMOBILIZER'
  | 'INSTALLED'
  | 'MULTICAM'
  | 'PLUG_AND_PLAY'
  | 'PLUG_AND_PLAY_IBUTTON'
  | 'REMOVABLE'
  | 'UNKNOWN';

export type DeviceHealthStatusType = 'DAMAGED' | 'DEVICE_WITHOUT_FLEET' | 'DISCONNECTED' | 'NORMAL' | 'NO_SIGNAL' | 'NO_SUFFICIENT_DATA' | 'SYNCING' | 'UNAVAILABLE' | 'UNKNOWN';

export type DeviceParameterStatus = {
  device: Device;
  parameter_name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type DeviceParameterValue = {
  device: Device;
  value?: Maybe<Scalars['String']['output']>;
};

export type DeviceSdCardHealthStatus = 'OK' | 'SD_CARD_PROBLEM';

export type DeviceShippingInformation = {
  quantidadeChaveiroString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesBloqueadorString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosClienteString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosCobliCamGeracao2ProString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosCobliCamGeracao2String?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosCobliCamString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosIdentificadorString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosImobilizadorString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoMotosOuMaquinariosClienteString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoMotosOuMaquinariosString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioRemovivelLevesOuPesadosBuzzerString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioRemovivelLevesOuPesadosIdentificadorString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioRemovivelLevesString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioRemovivelPesadosString?: Maybe<Scalars['Int']['output']>;
};

export type DeviceStatusSubscription = {
  active: Scalars['Boolean']['output'];
  fleet_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  user_id: Scalars['ID']['output'];
  vehicle_group_ids?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  vehicle_ids?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type DeviceStatusSubscriptionInput = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  vehicle_group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vehicle_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type DeviceStatusSummary = {
  causes: Array<DeviceCause>;
  status: DeviceStatusType;
};

export type DeviceStatusType = 'CHECK' | 'CRITICAL' | 'HEALTHY';

export type DeviceTotalQuantity = {
  camera?: Maybe<Scalars['Int']['output']>;
  identifiers?: Maybe<Scalars['Int']['output']>;
  immobilizer?: Maybe<Scalars['Int']['output']>;
  installed?: Maybe<Scalars['Int']['output']>;
  redeCan?: Maybe<Scalars['Int']['output']>;
  removable?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type DeviceTracking = {
  conclusionTime?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<DeviceDestination>;
  tempGeofenceId?: Maybe<Scalars['String']['output']>;
};

export type DeviceType =
  | 'Blocker'
  | 'Buzzer'
  | 'Can'
  | 'CanIbutton'
  | 'CanIbuttonImmobillizer'
  | 'Dashcam'
  | 'Immobilizer'
  | 'Multicam'
  | 'OBD'
  | 'OBD_Removable'
  | 'PlugAndPlayBuzzer'
  | 'Solar'
  | 'Unknown'
  | 'iButton'
  | 'iButtonImmobilizer';

export type DeviceVehicle = {
  alias?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  cobliId?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type DevolutionClientInformation = {
  clientCnpj?: Maybe<Scalars['String']['output']>;
};

export type DevolutionDeviceInformation = {
  devolutionDevicesCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  devolutionDevicesEsn?: Maybe<Scalars['String']['output']>;
  devolutionDevicesIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  heavyDevolutionRemovableQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionInstalledBuzzerQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionInstalledCoblicamQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionInstalledIdentifierQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionInstalledImmobilizerQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionInstalledQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionRemovableBuzzerQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionRemovableIdentifierQuantity?: Maybe<Scalars['Int']['output']>;
  lightDevolutionInstalledBlockerQuantity?: Maybe<Scalars['Int']['output']>;
  lightDevolutionRemovableQuantity?: Maybe<Scalars['Int']['output']>;
  motorcycleOrMachineryDevolutionInstalledClientQuantity?: Maybe<Scalars['Int']['output']>;
  motorcycleOrMachineryDevolutionInstalledQuantity?: Maybe<Scalars['Int']['output']>;
};

export type DevolutionDeviceTickets = {
  cobliId?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['String']['output'];
  devolutionTickets: Tickets;
  fleetId: Scalars['String']['output'];
};

export type DevolutionInformation = {
  clientInformation?: Maybe<DevolutionClientInformation>;
  deviceInformation?: Maybe<DevolutionDeviceInformation>;
  devolutionDeadline?: Maybe<Scalars['String']['output']>;
  fleetId?: Maybe<Scalars['String']['output']>;
  fleetName?: Maybe<Scalars['String']['output']>;
  penaltyPrice?: Maybe<Scalars['Float']['output']>;
  shippingInformation?: Maybe<DevolutionShippingInformation>;
  supplyDevolucaoTipo?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DevolutionShippingInformation = {
  devolutionArrivalOfDevicesAtCobli?: Maybe<Scalars['String']['output']>;
  devolutionPostageDate?: Maybe<Scalars['String']['output']>;
  devolutionShippingCode?: Maybe<Scalars['String']['output']>;
  devolutionShippingCodeOrScheduleDate?: Maybe<Scalars['String']['output']>;
  devolutionShippingType?: Maybe<Scalars['String']['output']>;
};

export type DisablerDto = {
  lastDisablingAction?: Maybe<Scalars['String']['output']>;
  lastDisablingActionTime?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type DisablerStatus = 'DisablePending' | 'Disabled' | 'Disabling' | 'EnablePending' | 'Enabled';

export type DmsEvents = {
  distracted_driving: SensibilityConfiguration;
  eyes_closed: SensibilityConfiguration;
  min_speed_trigger_in_km_per_h: Scalars['Int']['output'];
  /** Driver absent. Streamax only */
  no_driver_detected?: Maybe<SensibilityConfiguration>;
  /** Streamax only */
  occupancy?: Maybe<SensibilityConfiguration>;
  /** People in the cabin (driver included) that trigger the occupancy alarm, 2–6 */
  occupancy_people_limit?: Maybe<Scalars['Int']['output']>;
  phone_usage: SensibilityConfiguration;
  /** Driver without the seat belt: on/off only. Streamax only */
  seat_belt?: Maybe<EnabledConfiguration>;
  smoking: SensibilityConfiguration;
  yawn: SensibilityConfiguration;
};

export type DmsEventsInput = {
  distracted_driving: SensibilityConfigurationInput;
  eyes_closed: SensibilityConfigurationInput;
  min_speed_trigger_in_km_per_h: Scalars['Int']['input'];
  no_driver_detected?: InputMaybe<SensibilityConfigurationInput>;
  occupancy?: InputMaybe<SensibilityConfigurationInput>;
  occupancy_people_limit?: InputMaybe<Scalars['Int']['input']>;
  phone_usage: SensibilityConfigurationInput;
  seat_belt?: InputMaybe<EnabledConfigurationInput>;
  smoking: SensibilityConfigurationInput;
  yawn: SensibilityConfigurationInput;
};

export type Driver = {
  active?: Maybe<Scalars['Boolean']['output']>;
  assigned?: Maybe<Scalars['Boolean']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  driver_code?: Maybe<Scalars['String']['output']>;
  driver_license?: Maybe<Scalars['String']['output']>;
  first_license_acquirement_date?: Maybe<Scalars['Date']['output']>;
  fleet_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  identification_token?: Maybe<IdentificationTokenV2>;
  /** @deprecated Use `identification_token` field instead. */
  identifier?: Maybe<Scalars['String']['output']>;
  license_category?: Maybe<LicenseCategory>;
  license_expiration_date?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  phone_number?: Maybe<Scalars['PhoneNumber']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  registry_id?: Maybe<Scalars['String']['output']>;
  score?: Maybe<DriverScore>;
  vehicle?: Maybe<VehicleDto>;
};

export type DriverAssignmentInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type DriverAuthorization = {
  authorizationId: Scalars['ID']['output'];
  device?: Maybe<Device>;
  driver: Driver;
  identificationToken?: Maybe<IdentificationTokenV2>;
};

export type DriverFaceClusterUpdate = {
  /** Driver Face Cluster id. UUID */
  driver_face_cluster_id?: InputMaybe<Scalars['ID']['input']>;
  /** Driver identifier. UUID */
  driver_id?: InputMaybe<Scalars['ID']['input']>;
};

export type DriverFaceClustersInfo = {
  /** Time that the Driver Face Cluster was created in RFC 3339 format */
  created_at: Scalars['DateTime']['output'];
  /** Cobli driver identifier assigned to the cluster. */
  driver?: Maybe<Driver>;
  /** Driver Face Cluster identifier. An UUID */
  id: Scalars['ID']['output'];
  /** Driver Face Cluster image profile URL. An URL */
  profile_image_url: DriverPhoto;
  /**
   * Time the current suggestion was rejected by a manager, in RFC 3339 format.
   * Null when the suggestion has not been rejected.
   */
  rejected_at?: Maybe<Scalars['DateTime']['output']>;
  /** Number of Driver Face Cluster image URLs. Represents how many images are present in the list of sample_image_urls. */
  sample_image_url_count: Scalars['Int']['output'];
  /**
   * Driver Face Cluster list of images URL. A list of images URL
   * @deprecated Use sample_images instead.
   */
  sample_image_urls: Array<Maybe<DriverPhoto>>;
  /** Driver Face Cluster list of images with capture metadata. */
  sample_images: Array<Maybe<SampleImageDto>>;
  /** The suggested driver for this unnamed cluster. */
  suggested_driver?: Maybe<Driver>;
  /**
   * Origin of the current driver suggestion. One of DRIVER_APP or
   * EMBEDDING_NEAREST_NEIGHBOR. Kept as a String (not an enum) so new upstream
   * values don't break GraphQL serialization or couple backend/BFF deploys.
   * Null when there is no suggestion.
   */
  suggestion_source?: Maybe<Scalars['String']['output']>;
  /** Last time that the Driver Face Cluster was updated in RFC 3339 format */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** DriverFaceCluster data for the media */
export type DriverFaceClustersMedia = {
  /** Cobli driver. */
  driver?: Maybe<Driver>;
  /** Cobli driver identifier assigned to the cluster. An UUID */
  driver_id: Scalars['ID']['output'];
  /** Driver Face Cluster identifier. An UUID */
  id: Scalars['ID']['output'];
  /** Driver Face Cluster image profile URL. An URL */
  profile_image_url: DriverPhoto;
};

export type DriverFaceClustersSuggestion = {
  /** The candidate clusters for the driver */
  candidate_clusters: Array<Maybe<DriverFaceClustersInfo>>;
  /** Cobli driver suggested to the candidate clusters. */
  driver?: Maybe<Driver>;
};

export type DriverFaceIdRegistration = {
  driverId: Scalars['ID']['output'];
  lastSampleImageAt?: Maybe<Scalars['DateTime']['output']>;
  sampleImageCount: Scalars['Int']['output'];
  status: FaceIdRegistrationStatus;
};

export type DriverInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  assigned?: InputMaybe<Scalars['Boolean']['input']>;
  driver_code?: InputMaybe<Scalars['String']['input']>;
  first_license_acquirement_date?: InputMaybe<Scalars['Date']['input']>;
  fleet_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  license_category?: InputMaybe<LicenseCategory>;
  license_expiration_date?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['PhoneNumber']['input']>;
  score?: InputMaybe<DriverScoreInput>;
};

export type DriverLastAssociation = {
  associatedAt?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['String']['output'];
  driverId?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
};

export type DriverNominateTripImageInput = {
  /** The id of the driver. */
  driver_id?: InputMaybe<Scalars['String']['input']>;
  /** A feedback from the user marking that the driver is visible or not */
  driver_visibility?: InputMaybe<DriverVisibility>;
  /** The id of the image. */
  image_id: Scalars['String']['input'];
  /** The signed url of the image. */
  image_url?: InputMaybe<Scalars['String']['input']>;
  /** The operation. */
  operation: NominationOperation;
  /** The id of the trip. */
  trip_id: Scalars['String']['input'];
};

/** Driver Face Cluster image profile URL. An URL */
export type DriverPhoto = {
  /** A FaceBox containing the coordinates of the face in the picture. A FaceBox */
  box?: Maybe<FaceBox>;
  /** An URL for a image profile URL. An URL */
  image_url: Scalars['String']['output'];
};

export type DriverScore = {
  distance_driven?: Maybe<Scalars['Float']['output']>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  events_rates?: Maybe<EventRates>;
  score?: Maybe<Scalars['Float']['output']>;
  start_timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type DriverScoreInput = {
  distance_driven?: InputMaybe<Scalars['Float']['input']>;
  driver_id?: InputMaybe<Scalars['ID']['input']>;
  events_rates?: InputMaybe<EventRatesInput>;
  score?: InputMaybe<Scalars['Float']['input']>;
  start_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DriverSpeedRow = {
  driver: Driver;
  evolution: Scalars['Int']['output'];
  highEventsCount: Scalars['Int']['output'];
  higherEventsCount: Scalars['Int']['output'];
  kmsPerEvent: Scalars['Float']['output'];
  mediumEventsCount: Scalars['Int']['output'];
  percentageAboveLimit: Scalars['Float']['output'];
  totalEventsCount: Scalars['Int']['output'];
  totalTimeAboveLimitInMinutes: Scalars['Int']['output'];
  totalTripDurationInMinutes: Scalars['Int']['output'];
};

export type DriverSpeedRowInput = {
  driver_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  end_date: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  start_date: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export type DriverVisibility = 'NOT_VISIBLE' | 'VISIBLE';

export type DutyType = 'HEAVY' | 'LIGHT' | 'MEDIUM';

export type EnabledConfiguration = {
  enabled: Scalars['Boolean']['output'];
};

export type EnabledConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
};

export type EndOperationalSituationInput = {
  /** Omitido = encerra agora. Agendar um fim futuro não é aceito para RESERVE de dispositivo. */
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
};

export type EntireFleetAssociationConfig = {
  is_on?: Maybe<Scalars['Boolean']['output']>;
};

export type EntireFleetAssociationConfigInput = {
  is_on: Scalars['Boolean']['input'];
};

export type EventRates = {
  fast_acceleration?: Maybe<Scalars['Float']['output']>;
  hard_break?: Maybe<Scalars['Float']['output']>;
  high_speed?: Maybe<Scalars['Float']['output']>;
  speedy_turn?: Maybe<Scalars['Float']['output']>;
};

export type EventRatesInput = {
  fast_acceleration?: InputMaybe<Scalars['Float']['input']>;
  hard_break?: InputMaybe<Scalars['Float']['input']>;
  high_speed?: InputMaybe<Scalars['Float']['input']>;
  speedy_turn?: InputMaybe<Scalars['Float']['input']>;
};

export type EventTrigger =
  | 'ANOMALY'
  | 'ANTI_DESTRUCTION'
  | 'COLLISION'
  | 'DISTRACTED_DRIVING'
  | 'EATING'
  | 'EYES_CLOSED'
  | 'FATIGUE'
  | 'FRONT_COLLISION_WARNING'
  | 'G_SENSOR_WAKEUP'
  | 'HARSH_ACCELERATION'
  | 'HARSH_BREAKING'
  | 'HARSH_CORNERING'
  | 'IDLE_SPEED'
  | 'ILLEGAL_SHUTDOWN'
  | 'INSUFFICIENT_ELECTRICITY_ALARM'
  | 'LANE_DRIFT'
  | 'LEFT_TURN_SPEEDING'
  | 'LOW_VOLTAGE'
  | 'MAX_SPEED_EXCEEDED'
  | 'MISSINGFACE'
  | 'NOT_WEARING_SEAT_BELTS'
  | 'OVERCROWDING'
  | 'PASSENGER_NOT_WEARING_SEAT_BELTS'
  | 'PEDESTRIAN_COLLISION'
  | 'PHONE_USAGE'
  | 'SERIOUS_THEFT'
  | 'SMOKING'
  | 'SOS'
  | 'SPEED_LIMIT_SIGN'
  | 'STOP_SIGN_VIOLATED'
  | 'TAILGATING'
  | 'TEMPERATURE_ABNORMAL'
  | 'TRAFFIC_SPEED_VIOLATED'
  | 'UNKNOWN'
  | 'VIDEO_BLOCK'
  | 'YAWN';

export type EventVideo = {
  /** Event trigger. */
  event_trigger: EventTrigger;
  /** Event latitude. */
  latitude: Scalars['Float']['output'];
  /** Event longitude. */
  longitude: Scalars['Float']['output'];
  /** The url of the content media. */
  media_url: Scalars['String']['output'];
  /** Event speed. */
  speed: Scalars['Float']['output'];
  /** Speed limit of the road. Only available when event trigger is TRAFFICSPEEDVIOLATED. */
  speed_sign?: Maybe<Scalars['Int']['output']>;
  /** The url to the thumbnail image of a video. */
  thumbnail_url: Scalars['String']['output'];
};

export type EventsConfiguration = {
  adas_events: AdasEvents;
  dms_events: DmsEvents;
  face_identification_audio_alert_enabled?: Maybe<Scalars['Boolean']['output']>;
  harsh_events: HarshEventsByDutyType;
  /** Streamax only. Null when the fleet never set it (the device keeps its default) */
  idle_speed?: Maybe<IdleSpeedConfiguration>;
  ignition_off_record_settings?: Maybe<Scalars['Int']['output']>;
};

export type EventsConfigurationInput = {
  adas_events: AdasEventsInput;
  dms_events: DmsEventsInput;
  face_identification_audio_alert_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  harsh_events: HarshEventsByDutyTypeInput;
  idle_speed?: InputMaybe<IdleSpeedConfigurationInput>;
  ignition_off_record_settings?: InputMaybe<Scalars['Int']['input']>;
};

export type Expense = {
  category: Category;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  observation?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  source?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  totalCost: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
  vehicle: ExpenseVehicle;
};

export type ExpensePaginatedResponse = {
  content: Array<Expense>;
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ExpenseVehicle = {
  alias?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  groupPath?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  tagNames: Array<Scalars['String']['output']>;
};

export type ExpensesImportColumnMap = {
  categoryName?: InputMaybe<ImportColumnMapInput>;
  licensePlate?: InputMaybe<ImportColumnMapInput>;
  observation?: InputMaybe<ImportColumnMapInput>;
  occurredAt?: InputMaybe<ImportColumnMapInput>;
  supplierName?: InputMaybe<ImportColumnMapInput>;
  totalCost?: InputMaybe<ImportColumnMapInput>;
  type?: InputMaybe<ImportColumnMapInput>;
};

export type ExpensesListInput = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDate: Scalars['DateTime']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  tagNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleModels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A FaceBox containing the coordinates of the face in the picture. A FaceBox */
export type FaceBox = {
  x_max: Scalars['Int']['output'];
  x_min: Scalars['Int']['output'];
  y_max: Scalars['Int']['output'];
  y_min: Scalars['Int']['output'];
};

export type FaceIdCoverageChart = {
  data: Array<FaceIdCoveragePoint>;
  metadata: FaceIdCoverageMetadata;
};

export type FaceIdCoverageMetadata = {
  averageCoveragePercentage: Scalars['Float']['output'];
  fromTimestamp: Scalars['Float']['output'];
  identifiedEventsTotal: Scalars['Int']['output'];
  toTimestamp: Scalars['Float']['output'];
  validEventsTotal: Scalars['Int']['output'];
};

export type FaceIdCoveragePoint = {
  bucketStart: Scalars['Float']['output'];
  coveragePercentage: Scalars['Float']['output'];
  identifiedEvents: Scalars['Int']['output'];
  validEvents: Scalars['Int']['output'];
};

export type FaceIdRegistrationStatus = 'COMPLETE' | 'INCOMPLETE';

export type Field = {
  /**
   * Compliance of this answered question, decided by ryuk when the response was created, so clients
   * read it instead of replaying the rule over the options. Null on a template question and on a
   * response older than the feature.
   */
  compliance_status?: Maybe<ChecklistCompliance>;
  content: FieldContentType;
  id: Scalars['ID']['output'];
  photos_urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Stable identity of the question across template edits; field ids change on every write. Echo it
   * back when saving a template, or ryuk can only recover it by title. Inherited, never chosen, on a
   * response.
   */
  questionKey?: Maybe<Scalars['ID']['output']>;
  required: Scalars['Boolean']['output'];
  should_request_photos?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  type: FieldType;
};

export type FieldContentType = CheckContent | SelectContent | TextContent;

export type FieldControlInformation = {
  fieldObservations?: Maybe<Scalars['String']['output']>;
  technicalTeamObservation?: Maybe<Scalars['String']['output']>;
};

export type FieldType = 'CHECK' | 'MULTI_SELECT' | 'SINGLE_SELECT' | 'TEXT';

export type Filters = {
  wantedAlertTypes?: InputMaybe<Array<InputMaybe<UserNotificationSettingsType>>>;
  wantedGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wantedVehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type Fleet = {
  acceptance_terms?: Maybe<Scalars['JSONObject']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  global_score?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  managers?: Maybe<Array<Maybe<Manager>>>;
  name?: Maybe<Scalars['String']['output']>;
  periodical_scores?: Maybe<Scalars['JSONObject']['output']>;
};

export type FleetAudioMessage = {
  /** Timestamp when the message was created in RFC 3339 format. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who created the message. */
  createdBy: User;
  /** Fleet identifier that owns this audio message. */
  fleetId: Scalars['ID']['output'];
  /** Unique identifier for the audio message. */
  id: Scalars['ID']['output'];
  /** The text content of the audio message. */
  message: Scalars['String']['output'];
  /** URL to the generated MP3 file stored in S3. */
  mp3Url: Scalars['String']['output'];
  /** Optional name/identifier for the audio message. */
  name?: Maybe<Scalars['String']['output']>;
};

export type FleetAudioMessagePlayback = {
  /** The audio message ID that was played. */
  audioMessageId: Scalars['ID']['output'];
  /** Whether the playback will be auto-cancelled if not successfully delivered within 1 hour. */
  cancelIfTimeout?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp when the playback record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who created the playback request. */
  createdBy: User;
  /** The device where the message was played. */
  device: Device;
  /** Optional driver associated with the playback. */
  driver?: Maybe<Driver>;
  /** Unique identifier for this playback record. */
  id: Scalars['ID']['output'];
  /** The audio message content/text. */
  message?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the playback was successfully delivered. */
  playedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Number of retry attempts made for this playback. */
  retryCount: Scalars['Int']['output'];
  /** Current status of the playback (PENDING, SUCCESS, ERROR, or CANCELLED). */
  status: PlaybackStatus;
  /** The vehicle on which the message was played. */
  vehicle: VehicleDto;
};

export type FleetAudioMessagePlaybackPage = {
  /** List of playback records for the requested vehicle. */
  content?: Maybe<Array<Maybe<FleetAudioMessagePlayback>>>;
  /** Whether the page is empty. */
  empty?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is the first page. */
  first?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is the last page. */
  last?: Maybe<Scalars['Boolean']['output']>;
  /** Zero-based page index. */
  number?: Maybe<Scalars['Int']['output']>;
  /** Number of elements in this page. */
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  /** Pagination metadata. */
  pageable?: Maybe<PageableObject>;
  /** The size of the page. */
  size?: Maybe<Scalars['Int']['output']>;
  /** Sorting information. */
  sort?: Maybe<SortType>;
  /** Total number of elements across all pages. */
  totalElements?: Maybe<Scalars['Int']['output']>;
  /** Total number of pages. */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type FleetAutoAssociationSettings = {
  association_config?: Maybe<AssociationConfig>;
  fleet_id?: Maybe<Scalars['String']['output']>;
  last_updated_by?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['TimestampInMillis']['output']>;
};

export type FleetCompanyContract = {
  address?: Maybe<Scalars['String']['output']>;
  billingDay?: Maybe<Scalars['String']['output']>;
  cnpj?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  companyStatus?: Maybe<Scalars['String']['output']>;
  contractSignedDate?: Maybe<Scalars['TimestampInMillis']['output']>;
  corporateName?: Maybe<Scalars['String']['output']>;
  dueDay?: Maybe<Scalars['String']['output']>;
  financialAdjustmentIndex?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  lastRegistrationChangeDate?: Maybe<Scalars['String']['output']>;
  mrrCurrency?: Maybe<Scalars['String']['output']>;
  paymentFrequency?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  recentConversionEventName?: Maybe<Scalars['String']['output']>;
  responsavel?: Maybe<Scalars['String']['output']>;
  upsellBlockLoggedArea?: Maybe<Scalars['String']['output']>;
};

export type FleetCompanyContracts = {
  contracts?: Maybe<Array<Maybe<FleetCompanyContract>>>;
  fleetId: Scalars['ID']['output'];
};

export type FleetCompanyOnboardingStatus = {
  hasAnyContractSignedInLast90Days: Scalars['Boolean']['output'];
  hasAnyOnboardingContract: Scalars['Boolean']['output'];
};

export type FleetDeliveryTime = {
  mediaType: MediaType;
  p50Ms: Scalars['Float']['output'];
  /**
   * Limiar de atraso. Vem sempre da frota, nunca do dispositivo.
   *
   * Medido sobre uma janela que termina 7 dias atrás, porque pedido recente ainda pode não ter
   * terminado e incluí-lo mede só quem já chegou. Nulo quando essa janela não tem amostra — estado
   * normal em frota nova, não erro.
   */
  p90Ms?: Maybe<Scalars['Float']['output']>;
  /**
   * Quantas solicitações sustentam o p90. É um número próprio porque a janela do p90 é outra:
   * ela termina 7 dias antes da janela da mediana.
   */
  p90SampleSize: Scalars['Int']['output'];
  sampleSize: Scalars['Int']['output'];
};

export type FleetEventsConfiguration = {
  camera_events_config?: Maybe<CameraEventsConfiguration>;
  created_at: Scalars['String']['output'];
  fleet_id: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by_id?: Maybe<Scalars['ID']['output']>;
  updated_by_name?: Maybe<Scalars['String']['output']>;
};

export type FleetGeofenceRecommendation = {
  address?: Maybe<Scalars['String']['output']>;
  area: Scalars['Float']['output'];
  color: Scalars['String']['output'];
  fleetId: Scalars['ID']['output'];
  format: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  radius: Scalars['Float']['output'];
  reason: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FleetIdentificationHealthDto = {
  /** When the metric was computed (on-demand: the instant of the request), RFC 3339. */
  calculated_at: Scalars['DateTime']['output'];
  /**
   * M1 — percentage (0-100) of fleet drivers with a Cobli Cam photo processed into
   * an embedding. Manual uploads do not count. Reflects the current state (no window).
   */
  complete_registration_rate: Scalars['Float']['output'];
  /**
   * M2 — percentage (0-100) of valid video events identified with a driver over the
   * last 14 days.
   */
  identified_events_rate: Scalars['Float']['output'];
  /** Overall health state derived from the weighted score of M1 and M2. */
  state: FleetIdentificationHealthState;
};

/** Health state of a fleet's identification method. */
export type FleetIdentificationHealthState = 'CRITICAL' | 'HEALTHY' | 'WARNING';

export type FleetProducts = {
  products?: Maybe<Array<Maybe<Product>>>;
};

export type FleetUser = {
  active?: Maybe<Scalars['Boolean']['output']>;
  creation_date?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  fleet_id?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  granted_permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  groups?: Maybe<Array<Maybe<VehiclesGroup>>>;
  groups_restriction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  has_custom_permissions?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  last_login?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  timezone_offset?: Maybe<Scalars['String']['output']>;
};

export type FleetVehicleGroups = {
  created_at: Scalars['TimestampInMillis']['output'];
  creator_id: Scalars['ID']['output'];
  fleet_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  updated_at: Scalars['TimeIntervalInMillis']['output'];
  vehicle_ids: Array<Scalars['ID']['output']>;
};

/** How a fleet reviews its event videos. A fleet that never changed it has every option off. */
export type FleetVideoReviewConfiguration = {
  /** Dismissing an event video archives it instead */
  archiveInsteadOfDismiss?: Maybe<Scalars['Boolean']['output']>;
  /** Datetime of the last change. Null when the fleet never changed it */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the User that last changed it */
  updatedById?: Maybe<Scalars['ID']['output']>;
  /** Name of the User that last changed it */
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type FootageVideo = {
  /** Unix timestamp in millis of request creation. */
  created_at: Scalars['TimestampInMillis']['output'];
  /** Information of the user that requested the media. */
  created_by?: Maybe<FleetUser>;
  /** Information of the fleet policy trigger that requested the media. */
  created_by_trigger?: Maybe<MediaRequestTrigger>;
  /** Media duration in seconds */
  duration: Scalars['TimestampInMillis']['output'];
  /** Footage end latitude. Only available if the media has been uploaded. */
  end_latitude?: Maybe<Scalars['Float']['output']>;
  /** Footage end longitude. Only available if the media has been uploaded. */
  end_longitude?: Maybe<Scalars['Float']['output']>;
  /** The url of the content media. Only available if the media has been uploaded. */
  media_url?: Maybe<Scalars['String']['output']>;
  /** Unix timestamp in millis of request status processing. */
  processed_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  /** Request id of the footage. */
  request_id: Scalars['String']['output'];
  /** Status of footage request. */
  request_status: MediaRequestStatus;
  /** Footage start latitude. Only available if the media has been uploaded. */
  start_latitude?: Maybe<Scalars['Float']['output']>;
  /** Footage start longitude. Only available if the media has been uploaded. */
  start_longitude?: Maybe<Scalars['Float']['output']>;
  /**
   * Status of footage request.
   * @deprecated Use `requestStatus` field instead.
   */
  status: RequestedMediaStatus;
  /** The url to the thumbnail image of a video. Only available if the media has been uploaded. */
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  /** Unix timestamp in millis of request status update. */
  updated_at: Scalars['TimestampInMillis']['output'];
};

export type FuelCardAssociationResponse = {
  createdAt: Scalars['Float']['output'];
  deletedAt?: Maybe<Scalars['Float']['output']>;
  fleetId: Scalars['ID']['output'];
  fuelCardId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  providerLicensePlate: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Float']['output']>;
  vehicle?: Maybe<VehicleDto>;
};

export type FuelCardAssociationStatusInput = {
  fuelCardIds: Array<Scalars['ID']['input']>;
};

export type FuelCardAssociationStatusResponse = {
  message?: Maybe<Scalars['String']['output']>;
};

export type FuelConsumptionGoalsResponse = {
  goals: Array<VehicleFuelConsumptionGoalResponse>;
};

export type FuelDto = {
  consumption?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `consumption` field. */
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type FuelInput = {
  consumption?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Posto onde o abastecimento foi feito. Nulo na transação sem posto, como as lançadas via API, que o
 * frentista manda com os campos vazios.
 */
export type FuelStation = {
  city?: Maybe<Scalars['String']['output']>;
  cnpj?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type FuelTransactionIntegrationResponse = {
  createdAt: Scalars['TimestampInMillis']['output'];
  fleetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  ignoreTransactionType: Scalars['Boolean']['output'];
};

export type FuelTransactionResponse = {
  cobliCostPerDrivenKm?: Maybe<Scalars['Float']['output']>;
  cobliDrivenMeters?: Maybe<Scalars['Long']['output']>;
  cobliFuelConsumption?: Maybe<Scalars['Float']['output']>;
  cobliOdometer?: Maybe<Scalars['Float']['output']>;
  commodity: Scalars['String']['output'];
  costCenterDescription?: Maybe<Scalars['String']['output']>;
  costCenterId?: Maybe<Scalars['String']['output']>;
  costPerDrivenKm?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['TimestampInMillis']['output'];
  createdBy: Scalars['String']['output'];
  creatorId?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  deletedBy?: Maybe<Scalars['ID']['output']>;
  drivenMeters: Scalars['Long']['output'];
  driverName?: Maybe<Scalars['String']['output']>;
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
  groupPath?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  merchant?: Maybe<MerchantResponse>;
  odometer?: Maybe<Scalars['Float']['output']>;
  providerCode?: Maybe<Scalars['String']['output']>;
  totalCost: Scalars['Float']['output'];
  transactionTime: Scalars['TimestampInMillis']['output'];
  unitCost: Scalars['Float']['output'];
  units: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
  vehicle?: Maybe<FuelTransactionVehicleResponse>;
};

export type FuelTransactionStatsByVehicleSummaryResponse = {
  avgCostPerLiter: Scalars['Float']['output'];
  sumCobliDrivenKms: Scalars['Float']['output'];
  sumFuelLiters: Scalars['Float']['output'];
};

export type FuelTransactionSummaryResponse = {
  avgCostPerKm: Scalars['Float']['output'];
  avgFuelConsumption: Scalars['Float']['output'];
  sumTotalCost: Scalars['Float']['output'];
};

export type FuelTransactionVehicleResponse = {
  cobliVehicle: VehicleDto;
  id: Scalars['ID']['output'];
  integration?: Maybe<FuelTransactionIntegrationResponse>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  refFuelConsumption?: Maybe<Scalars['Float']['output']>;
};

export type FuelTransactionsImportColumnMap = {
  driverName?: InputMaybe<ImportColumnMapInput>;
  fuelType?: InputMaybe<ImportColumnMapInput>;
  licensePlate?: InputMaybe<ImportColumnMapInput>;
  merchantCity?: InputMaybe<ImportColumnMapInput>;
  merchantCnpj?: InputMaybe<ImportColumnMapInput>;
  merchantName?: InputMaybe<ImportColumnMapInput>;
  merchantState?: InputMaybe<ImportColumnMapInput>;
  odometer?: InputMaybe<ImportColumnMapInput>;
  quantityInLiters?: InputMaybe<ImportColumnMapInput>;
  totalCost?: InputMaybe<ImportColumnMapInput>;
  transactionTime?: InputMaybe<ImportColumnMapInput>;
};

export type GeofenceEvent = {
  eventType?: Maybe<Scalars['String']['output']>;
  geofence?: Maybe<GeofenceEventNestedGeofence>;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
};

export type GeofenceEventNestedGeofence = {
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Geofences = {
  category?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Geometry = {
  coordinates: Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>;
  type: Scalars['String']['output'];
};

export type GetChecklist = {
  id: Scalars['ID']['input'];
};

export type GetChecklistsNames = {
  template: Scalars['Boolean']['input'];
};

export type GetCompletedChecklists = {
  complianceFilter?: InputMaybe<Array<InputMaybe<ChecklistComplianceStatus>>>;
  createdByFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inputFilter?: InputMaybe<Scalars['String']['input']>;
  nameFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<DateRange>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  templateIdFilter?: InputMaybe<Scalars['String']['input']>;
  templateIdsFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleGroupIdsFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIdFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIdsFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetFuelTransactionSummaryByPeriodTypeInput = {
  endDate: Scalars['String']['input'];
  fuelTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  groupPeriod: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleSizes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetFuelTransactionsReportInput = {
  end: Scalars['TimestampInMillis']['input'];
  start: Scalars['TimestampInMillis']['input'];
  tz?: InputMaybe<Scalars['String']['input']>;
  vehicleGroupPaths?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetFuelTransactionsSummaryInput = {
  endDate: Scalars['String']['input'];
  fuelTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleSizes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetInsightInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['String']['input'];
  groupPath?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};

export type GetLatestMaintenanceInput = {
  timezone: Scalars['String']['input'];
  vehicleId: Scalars['ID']['input'];
};

export type GetMaintenanceHistoryInput = {
  endDate: Scalars['DateTime']['input'];
  maintenanceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  tagNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone: Scalars['String']['input'];
  vehicleGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetMaintenancePartsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export type GetPagedFuelTransactionsInput = {
  endDate: Scalars['String']['input'];
  fuelTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleSizes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetReminderListInput = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tagNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  titleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleModels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetReminderStatusCountInput = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  titleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleModels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetTemplateChecklists = {
  activeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  createdByFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * true keeps only templates with at least one option marked as conform or non conform; false keeps
   * only the unmarked ones. Filtered by ryuk before paging, so the page fields stay accurate.
   */
  hasComplianceFilter?: InputMaybe<Scalars['Boolean']['input']>;
  nameFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  vehicleGroupIdsFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIdsFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GroupRecommendation = {
  appliedPayloadJson?: Maybe<Scalars['String']['output']>;
  dismissCount: Scalars['Int']['output'];
  fleetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  suggestedName: Scalars['String']['output'];
  vehicleIds: Array<Scalars['ID']['output']>;
};

export type GroupRecommendationEditInput = {
  suggestedName?: InputMaybe<Scalars['String']['input']>;
  vehicleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type HarshEvents = {
  acceleration: SensibilityConfiguration;
  braking: SensibilityConfiguration;
  cornering: SensibilityConfiguration;
  impact?: Maybe<SensibilityConfiguration>;
};

export type HarshEventsByDutyType = {
  heavy: HarshEvents;
  light: HarshEvents;
  medium: HarshEvents;
};

export type HarshEventsByDutyTypeInput = {
  heavy: HarshEventsInput;
  light: HarshEventsInput;
  medium: HarshEventsInput;
};

export type HarshEventsInput = {
  acceleration: SensibilityConfigurationInput;
  braking: SensibilityConfigurationInput;
  cornering: SensibilityConfigurationInput;
  impact?: InputMaybe<SensibilityConfigurationInput>;
};

export type HomeProductivitySummary = {
  averageEngineOnTimeInMinutes: Scalars['Int']['output'];
  averageIdleOnTimeInMinutes: Scalars['Int']['output'];
  averageJourneyTimeInMinutes: Scalars['Int']['output'];
  averageStopTimeInMinutes: Scalars['Int']['output'];
};

export type HomeSpeedSummary = {
  roadEvents: AggregatedSpeedEventsSummary;
  vehicleEvents: AggregatedSpeedEventsSummary;
};

export type ICreatedUser = {
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type IEnrollmentFormInfo = {
  invite: IInvite;
  occupations?: Maybe<Array<Maybe<IOccupation>>>;
};

export type IInvite = {
  emailAddress: Scalars['String']['output'];
  fleetId: Scalars['String']['output'];
};

export type IInviteAcceptForm = {
  full_name: Scalars['String']['input'];
  occupation?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type IOccupation = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ITicket = {
  associatedDealId?: Maybe<Scalars['String']['output']>;
  closedDate?: Maybe<Scalars['TimestampInMillis']['output']>;
  createdAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  deletedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  deviceCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceTotalQuantity?: Maybe<DeviceTotalQuantity>;
  fleetId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type IdentificationMethod = 'FACE_IDENTIFICATION' | 'TRIP_WITHOUT_IMAGE' | 'USER_CONFIRMATION' | 'USER_EDIT' | 'WITHOUT_IDENTIFICATION';

export type IdentificationToken = {
  associated_to_driver_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  associated_to_fleet_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  cobli_internal_id: Scalars['String']['output'];
  driver_id?: Maybe<Scalars['ID']['output']>;
  fleet_id?: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  token_id: Scalars['String']['output'];
  token_type: Scalars['String']['output'];
};

export type IdentificationTokenFilters = {
  driverIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isLinkedToDriver?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdentificationTokenLastUsage = {
  location?: Maybe<Location>;
  timestamp?: Maybe<Scalars['TimestampInMillis']['output']>;
  vehicle?: Maybe<VehicleDto>;
};

export type IdentificationTokenStatus = 'awaiting_return' | 'broken' | 'commodate' | 'donated' | 'external' | 'in_stock' | 'indebted' | 'lost' | 'refunded' | 'testing' | 'unknown';

export type IdentificationTokenV2 = {
  alias?: Maybe<Scalars['String']['output']>;
  associatedToDriverAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  associatedToFleetAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  /** @deprecated Use associatedToDriverAt instead */
  associated_to_driver_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  /** @deprecated Use associatedToFleetAt instead */
  associated_to_fleet_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  cobliId?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use driverId instead */
  driver_id?: Maybe<Scalars['ID']['output']>;
  fleetId: Scalars['ID']['output'];
  /** @deprecated Use fleetId instead */
  fleet_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['String']['output'];
  isExternal: Scalars['Boolean']['output'];
  /** @deprecated Use isExternal instead */
  is_external: Scalars['Boolean']['output'];
  lastUsage?: Maybe<IdentificationTokenLastUsage>;
  origin: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tokenId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use alias instead */
  token_alias: Scalars['String']['output'];
  /** @deprecated Use tokenId instead */
  token_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use type instead */
  token_type: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type IdleSpeedConfiguration = {
  enabled: Scalars['Boolean']['output'];
  /** Time stopped with the engine on before the alarm, 300–1800 seconds */
  threshold_seconds: Scalars['Int']['output'];
};

export type IdleSpeedConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
  threshold_seconds: Scalars['Int']['input'];
};

export type ImportBatchResponse = {
  count: Scalars['Long']['output'];
};

export type ImportColumnMap = {
  name: Scalars['String']['output'];
  position: Scalars['String']['output'];
};

export type ImportColumnMapInput = {
  name: Scalars['String']['input'];
  position: Scalars['String']['input'];
};

export type ImportErrorDto = {
  field?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ImportExpensesBatchInput = {
  categoryId: Scalars['String']['input'];
  groupPath?: InputMaybe<Scalars['String']['input']>;
  observation?: InputMaybe<Scalars['String']['input']>;
  occurredAt: Scalars['String']['input'];
  supplierName?: InputMaybe<Scalars['String']['input']>;
  totalCost: Scalars['Float']['input'];
  type: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
};

export type ImportFuelTransactionsBatchInput = {
  driverName?: InputMaybe<Scalars['String']['input']>;
  fuelType: Scalars['String']['input'];
  licensePlate: Scalars['String']['input'];
  merchant?: InputMaybe<MerchantCreateInput>;
  odometerInKm: Scalars['Float']['input'];
  quantityInLiters: Scalars['Float']['input'];
  totalCost: Scalars['Float']['input'];
  transactionTime: Scalars['String']['input'];
};

export type ImportMaintenanceBatchInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  occurrenceAt: Scalars['DateTime']['input'];
  odometerInKms: Scalars['Float']['input'];
  parts: Array<ImportMaintenancePartInput>;
  types: Array<Scalars['String']['input']>;
  vehicleId: Scalars['String']['input'];
};

export type ImportMaintenancePartInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  partName: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type ImportVehicleRowDto = {
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
  fuelPrice?: Maybe<Scalars['Float']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  licensePlate: Scalars['String']['output'];
  size?: Maybe<Scalars['String']['output']>;
  speedLimitInKmh?: Maybe<Scalars['Int']['output']>;
};

export type Incidents = {
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  time: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type InputActivity = {
  additional_info?: InputMaybe<Scalars['String']['input']>;
  destination: DestinationInput;
  device_id?: InputMaybe<Scalars['String']['input']>;
  driver_id?: InputMaybe<Scalars['ID']['input']>;
  driver_name?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['TimeIntervalInMillis']['input']>;
  load_size?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  time_windows?: InputMaybe<Array<TimeWindowInput>>;
  vehicle_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InsertUserNotificationSettings = {
  active: Scalars['Boolean']['input'];
  settings_json: SettingsJsonInput;
  type: UserNotificationSettingsType;
};

export type Insight = {
  action?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  driver?: Maybe<Driver>;
  fleetId: Scalars['ID']['output'];
  group?: Maybe<Array<Maybe<VehiclesGroup>>>;
  id: Scalars['ID']['output'];
  impact?: Maybe<Scalars['String']['output']>;
  insightText?: Maybe<Scalars['String']['output']>;
  seen: Scalars['Boolean']['output'];
  vehicle?: Maybe<VehicleDto>;
};

export type InsightEvaluation = {
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insight: Insight;
  spanId: Scalars['String']['output'];
  thumbDown?: Maybe<Scalars['Boolean']['output']>;
  thumbUp?: Maybe<Scalars['Boolean']['output']>;
  traceId: Scalars['String']['output'];
};

export type InsightThumbsDownInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  groupPath?: InputMaybe<Scalars['String']['input']>;
  insightId: Scalars['ID']['input'];
};

export type InsightThumbsUpInput = {
  groupPath?: InputMaybe<Scalars['String']['input']>;
  insightId: Scalars['ID']['input'];
};

export type InstallDeviceInVehicleInput = {
  deviceId: Scalars['String']['input'];
  vehicleId: Scalars['ID']['input'];
};

export type InstallationAddressInformation = {
  addressConfirmation?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

export type InstallationClientInformation = {
  email?: Maybe<Scalars['String']['output']>;
  installationDoneByClient?: Maybe<Scalars['Boolean']['output']>;
  installationProblem?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  responsibleForTrackingScheduling?: Maybe<Scalars['String']['output']>;
};

export type InstallationCoblerInformation = {
  responsible?: Maybe<Scalars['String']['output']>;
  responsibleScheduling?: Maybe<Scalars['String']['output']>;
  responsibleToContactClient?: Maybe<Scalars['String']['output']>;
  technicalResponsible?: Maybe<Scalars['String']['output']>;
};

export type InstallationContactInformation = {
  bestTimeToContact?: Maybe<Scalars['String']['output']>;
  bestWayOfContact?: Maybe<Scalars['String']['output']>;
  meansToContact?: Maybe<Scalars['String']['output']>;
  meansToContactTheResponsibleForInstallation?: Maybe<Scalars['String']['output']>;
};

export type InstallationDateInformation = {
  clientFirstPreferredScheduleDay?: Maybe<Scalars['String']['output']>;
  clientFirstPreferredScheduleHour?: Maybe<Scalars['String']['output']>;
  clientSecondPreferredScheduleDay?: Maybe<Scalars['String']['output']>;
  clientSecondPreferredScheduleHour?: Maybe<Scalars['String']['output']>;
  installationConfirmedAt?: Maybe<Scalars['String']['output']>;
  installedDate?: Maybe<Scalars['String']['output']>;
  scheduledDateTime?: Maybe<Scalars['String']['output']>;
  scheduledDay?: Maybe<Scalars['String']['output']>;
};

export type InstallationDeviceInformation = {
  calculatedInstallDevices?: Maybe<Scalars['Int']['output']>;
  esnToInstall?: Maybe<Scalars['String']['output']>;
  esnToNotInstall?: Maybe<Scalars['String']['output']>;
  heavyOrLightVehiclesInstalledIdentifierQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightVehiclesInstalledImmobilizerQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightVehiclesInstalledQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightVehiclesInstalledQuantityCoblicam?: Maybe<Scalars['Int']['output']>;
  installationDevicesCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  installationDevicesIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  installationEsns?: Maybe<Scalars['String']['output']>;
  installationInstalledEsns?: Maybe<Scalars['String']['output']>;
  installationNotInstalledEsns?: Maybe<Scalars['String']['output']>;
  lightVehiclesInstalledBlockerQuantity?: Maybe<Scalars['Int']['output']>;
  motorcyclesOrHeavyVehiclesInstalledQuantity?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type InstallationFieldControlInformation = {
  fieldAssociation?: Maybe<Scalars['String']['output']>;
  fieldClass?: Maybe<Scalars['String']['output']>;
  fieldControlObservation?: Maybe<Scalars['String']['output']>;
  observationToTheTechnicalTeam?: Maybe<Scalars['String']['output']>;
  supplyInstalacaoClasse?: Maybe<Scalars['String']['output']>;
  worker?: Maybe<Scalars['String']['output']>;
};

export type InstallationInformation = {
  addressInformation?: Maybe<InstallationAddressInformation>;
  clientInformation?: Maybe<InstallationClientInformation>;
  coblerInformation?: Maybe<InstallationCoblerInformation>;
  contactInformation?: Maybe<InstallationContactInformation>;
  dateInformation?: Maybe<InstallationDateInformation>;
  deviceInformation?: Maybe<InstallationDeviceInformation>;
  fieldControlInformation?: Maybe<InstallationFieldControlInformation>;
  fleetId?: Maybe<Scalars['String']['output']>;
  installationConfirmedAt?: Maybe<Scalars['String']['output']>;
  installedDate?: Maybe<Scalars['String']['output']>;
  notResponsible?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ratedAt?: Maybe<Scalars['String']['output']>;
  responsibleUser?: Maybe<InstallationResponsibleUser>;
  scheduledDateTime?: Maybe<Scalars['String']['output']>;
  scheduledDay?: Maybe<Scalars['String']['output']>;
  vehicleInformation?: Maybe<InstallationVehicleInformation>;
};

export type InstallationResponsibleUser = {
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fleetIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type InstallationVehicleInformation = {
  plack?: Maybe<Scalars['String']['output']>;
  vehicles?: Maybe<Scalars['String']['output']>;
};

export type InvalidImportVehicleRowDto = {
  data: ValidateImportVehicleRowDto;
  errors: Array<ImportErrorDto>;
};

export type Invite = {
  creationDate: Scalars['TimestampInMillis']['output'];
  creatorId: Scalars['String']['output'];
  customPermissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  emailAddress: Scalars['String']['output'];
  fleetId: Scalars['String']['output'];
  groups?: Maybe<Array<Maybe<VehiclesGroup>>>;
  groupsRestriction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  role: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type InviteForm = {
  custom_permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_address: Scalars['String']['input'];
  groups_restriction: Array<InputMaybe<Scalars['String']['input']>>;
  role: Scalars['String']['input'];
  suggested_user_name?: InputMaybe<Scalars['String']['input']>;
};

export type InviteResponse = {
  email_address: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type LastAssociation = {
  cobliId?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<DriverLastAssociation>;
  fleetId: Scalars['ID']['output'];
  lastLocation?: Maybe<LastLocation>;
  vehicle?: Maybe<VehicleLastAssociation>;
};

export type LastLocation = {
  cobliIngestedAt?: Maybe<Scalars['Float']['output']>;
  deviceId: Scalars['String']['output'];
  heading?: Maybe<Scalars['Int']['output']>;
  idleOffDurationInMillis?: Maybe<Scalars['Float']['output']>;
  idleOnDurationInMillis?: Maybe<Scalars['Float']['output']>;
  ignitionOn?: Maybe<Scalars['Boolean']['output']>;
  isPlugged?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  pluggedUpdateTimestamp?: Maybe<Scalars['Float']['output']>;
  processedAt?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  timeInMillis?: Maybe<Scalars['Float']['output']>;
};

export type LastPath = {
  event_time: Scalars['TimestampInMillis']['output'];
};

export type LastPathInput = {
  deviceId: Scalars['String']['input'];
};

export type LicenseCategory = 'A' | 'AB' | 'AC' | 'ACC' | 'AD' | 'AE' | 'B' | 'C' | 'D' | 'E';

export type ListActivitiesInput = {
  activities_type?: InputMaybe<ActivityType>;
  completion_statuses?: InputMaybe<Array<ActivityCompletionStatus>>;
  drivers_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  end_in_millis?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  page: Scalars['Int']['input'];
  routes_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Sort>;
  start_in_millis?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  text_filter?: InputMaybe<Scalars['String']['input']>;
  vehicles_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  without_route?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListRoutesInput = {
  driver_id?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  period: DateRange;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Sort>;
  text_filter?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['String']['input']>;
};

export type ListRoutesInputV2 = {
  drivers_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  period: DateRange;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Sort>;
  text_filter?: InputMaybe<Scalars['String']['input']>;
  vehicles_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Location = {
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type LoggedUser = {
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Nulo quando não há telefone cadastrado — a distinção que decide se é preciso pedir
   * o número. O upstream usa string vazia; aqui ela vira nulo.
   */
  phoneNumber?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type Maintenance = {
  apiVersion?: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  occurrenceAt?: Maybe<Scalars['DateTime']['output']>;
  odometerInKms?: Maybe<Scalars['Float']['output']>;
  /**
   * Parada (situação operacional) que originou este registro, quando ele veio da sugestão de registrar
   * manutenção. Referência ao fusca — pode apontar para uma parada que não existe mais.
   */
  operationalSituationId?: Maybe<Scalars['ID']['output']>;
  parts?: Maybe<Array<Maybe<MaintenancePart>>>;
  recurrences?: Maybe<Array<Maybe<Recurrence>>>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  types: Array<Maybe<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['DateTime']['output']>;
  vehicle?: Maybe<VehicleDto>;
};

export type MaintenanceImportColumnMap = {
  licensePlate?: InputMaybe<ImportColumnMapInput>;
  maintenanceObservation?: InputMaybe<ImportColumnMapInput>;
  occurrenceAt?: InputMaybe<ImportColumnMapInput>;
  odometerInKms?: InputMaybe<ImportColumnMapInput>;
  partName?: InputMaybe<ImportColumnMapInput>;
  partObservation?: InputMaybe<ImportColumnMapInput>;
  quantity?: InputMaybe<ImportColumnMapInput>;
  type?: InputMaybe<ImportColumnMapInput>;
  unitCost?: InputMaybe<ImportColumnMapInput>;
};

export type MaintenancePart = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  part?: Maybe<Part>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type MaintenancePartInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  partId: Scalars['ID']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type MaintenancePartResponse = {
  count: Scalars['Int']['output'];
  rows?: Maybe<Array<Maybe<MaintenancePart>>>;
};

export type MaintenanceReminderResponse = {
  count: Scalars['Int']['output'];
  rows: Array<ReminderDto>;
};

export type MaintenanceResponse = {
  count: Scalars['Int']['output'];
  rows?: Maybe<Array<Maybe<Maintenance>>>;
};

export type MaintenanceStatus = {
  days?: Maybe<Scalars['Int']['output']>;
  km?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type Manager = {
  accessible_fleets?: Maybe<Array<Maybe<AcessibleFleets>>>;
  active?: Maybe<Scalars['Boolean']['output']>;
  creation_date?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fleets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fullname?: Maybe<Scalars['String']['output']>;
  groups_restriction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  last_login?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['Int']['output']>;
};

export type ManualOdometer = {
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  odometerAt: Scalars['String']['output'];
  odometerInKms: Scalars['Long']['output'];
};

export type MarkConferenceReviewInput = {
  observation?: InputMaybe<Scalars['String']['input']>;
  status: ConferenceReviewStatus;
  transactionId: Scalars['ID']['input'];
};

export type Media = {
  /** AI suggested driver */
  ai_suggested_driver?: Maybe<Driver>;
  /** AI suggested driver ID */
  ai_suggested_driver_id?: Maybe<Scalars['ID']['output']>;
  /** AI video tags */
  ai_video_tags?: Maybe<AiVideoTags>;
  /** Comments of the media */
  comments?: Maybe<Array<Maybe<MediaComment>>>;
  /** Device of the media */
  device?: Maybe<Device>;
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['output'];
  /** Driver associated with the Media */
  driver?: Maybe<Driver>;
  /** DriverFaceCluster data for the media */
  driver_face_cluster?: Maybe<DriverFaceClustersMedia>;
  /** Driver identifier UUID. Available only if a driver was assigned to the device ID at video start timestamp. */
  driver_id?: Maybe<Scalars['ID']['output']>;
  /**
   * Driver name. Available only if a driver was assigned to the device ID at video start timestamp.
   * @deprecated Use `driver` field instead
   */
  driver_name?: Maybe<Scalars['String']['output']>;
  /** Group path */
  group_path?: Maybe<Scalars['String']['output']>;
  /** Media ID */
  id: Scalars['ID']['output'];
  /** Is favorite media */
  is_favorite?: Maybe<Scalars['Boolean']['output']>;
  media_details: MediaDetails;
  /** Media status considering view count and safety review status. */
  media_status: MediaStatus;
  /** Type of media content. */
  media_type: MediaType;
  /**
   * User views count
   * @deprecated Use `mediaStatus` field instead.
   */
  media_view_count: Scalars['Int']['output'];
  /** Media safety review */
  safety_review?: Maybe<SafetyReview>;
  /** Event severity. */
  severity?: Maybe<Severity>;
  /** Detailed severity definition */
  severity_detail?: Maybe<SeverityDetail>;
  /** Video start Unix timestamp in millis. */
  timestamp: Scalars['TimestampInMillis']['output'];
  /** Driver associated before review */
  unreviewed_driver?: Maybe<Driver>;
  /** Vehicle details */
  vehicle?: Maybe<VehicleDto>;
  /** Group */
  vehicle_group?: Maybe<VehiclesGroup>;
  /** Vehicle identifier */
  vehicle_id?: Maybe<Scalars['ID']['output']>;
};

export type MediaComment = {
  /** Content of the comment */
  content?: Maybe<Scalars['String']['output']>;
  /** Datetime of comment creation */
  created_at: Scalars['String']['output'];
  /** ID of the user that created the comment */
  created_by: Scalars['ID']['output'];
  /** User that created the comment */
  created_by_user: FleetUser;
  /** Media comment ID */
  id: Scalars['ID']['output'];
  /** Media ID associated with comment */
  media_id: Scalars['ID']['output'];
  /** Datetime of comment last update */
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type MediaDetails = EventVideo | FootageVideo;

export type MediaPage = {
  content?: Maybe<Array<Maybe<Media>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type MediaRequestStatus =
  | 'AMOUNT_EXCEEDED'
  | 'CORRUPTED_VIDEO'
  | 'FAILED_REQUEST'
  | 'FINISHED_REQUEST'
  | 'LM_ERROR_FAILED'
  | 'LM_ERROR_UNAVAILABLE'
  | 'MANUAL_RETRY_REQUEST'
  | 'PENDING_REQUEST'
  | 'PERIOD_UNAVAILABLE'
  | 'REQUESTED'
  | 'REQUEST_ACKNOWLEDGED'
  | 'RETRY_REQUESTED'
  | 'TIMEOUT_REQUEST';

export type MediaRequestTrigger = {
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rule_category?: Maybe<Scalars['String']['output']>;
};

export type MediaResponse = {
  /** Safety review description generated by AI */
  ai_description?: Maybe<Scalars['String']['output']>;
  /** AI video tags */
  ai_video_tags?: Maybe<AiVideoTags>;
  /** Url expiration date */
  expiration_date?: Maybe<Scalars['Long']['output']>;
  /** Media information data */
  media_info?: Maybe<Media>;
  /** Media Url generated and signed with expiration data */
  media_url?: Maybe<Scalars['String']['output']>;
  /** Suggested occurrences by AI */
  suggested_occurrences?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Videos from media */
  videos?: Maybe<Array<Maybe<VideoDto>>>;
};

export type MediaStatus = 'ARCHIVED' | 'DISMISSED' | 'NEW' | 'RELEVANT' | 'WATCHED';

export type MediaType = 'EVENT_VIDEO' | 'FOOTAGE_VIDEO' | 'TIMELAPSE';

export type MerchantCreateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type MerchantImportResponse = {
  city?: Maybe<Scalars['String']['output']>;
  cnpj?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type MerchantResponse = {
  city?: Maybe<Scalars['String']['output']>;
  cnpj?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type MerchantUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  acceptInvite?: Maybe<ICreatedUser>;
  addChecklist: Checklist;
  addDriver?: Maybe<Driver>;
  applyGroupRecommendation: GroupRecommendation;
  assignDriverToDevice?: Maybe<Scalars['Boolean']['output']>;
  /** If the requester is authorized to assign a driver to a cluster, a face association request will be created. */
  assignFaceCluster?: Maybe<Scalars['Boolean']['output']>;
  associateTokenToDriver?: Maybe<IdentificationTokenV2>;
  batchCreateDrivers: Array<Driver>;
  batchCreateIdentificationTokens: Array<IdentificationTokenV2>;
  batchSetFuelConsumptionGoals: FuelConsumptionGoalsResponse;
  /**
   * Cancela uma parada que ainda não começou, apagando o registro: uma parada que nunca aconteceu não
   * é histórico. Situação que já começou — ativa ou encerrada — é recusada; para essa, use
   * `endOperationalSituation`.
   */
  cancelOperationalSituation: Scalars['Boolean']['output'];
  /** If the requester is authorized to change the camera configuration, it will be changed. */
  changeCameraConfiguration?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Os erros do ryuk chegam com o status em `extensions.response.status`: 422 (transição inválida, nota ou
   * responsável faltando), 409 (alguém alterou antes, ou já existe outra tratativa ativa para a mesma pergunta
   * e veículo) e 404.
   */
  changeChecklistNonConformityStatus?: Maybe<Array<ChecklistNonConformity>>;
  completeFleetRecommendation: RecommendationActionResult;
  createActivities: Array<Activity>;
  createCheckpointManual: CreateManualOdometerResponse;
  /** Create a new fleet audio message. The message text is converted to audio using AWS Polly text-to-speech and stored in S3. */
  createFleetAudioMessage?: Maybe<FleetAudioMessage>;
  createFuelTransaction: FuelTransactionResponse;
  createMaintenanceHistory: Maintenance;
  createMaintenanceParts: Part;
  createMaintenanceReminder: Array<ReminderDto>;
  createMedia: CreateMediaResponse;
  /** Cria de 1 a 500 situações atomicamente: se um dos alvos falhar, nenhuma é criada. */
  createOperationalSituations: Array<OperationalSituation>;
  createRoutes?: Maybe<Array<Route>>;
  createVehicle: VehicleDto;
  createVehiclesBatch: Array<VehicleDto>;
  createVehiclesGroup?: Maybe<VehiclesGroup>;
  deleteActivities: Array<Scalars['ID']['output']>;
  deleteChecklist: Checklist;
  deleteDriver?: Maybe<Driver>;
  /** Delete a playback record. Only pending and failed playbacks can be deleted (not successful ones). */
  deleteFleetAudioMessagePlayback?: Maybe<Scalars['Boolean']['output']>;
  deleteFuelCardAssociation: FuelCardAssociationStatusResponse;
  deleteFuelTransactions: Scalars['Boolean']['output'];
  deleteInvite?: Maybe<Scalars['String']['output']>;
  deleteMaintenanceHistory?: Maybe<Scalars['Boolean']['output']>;
  deleteMaintenanceParts?: Maybe<Scalars['Boolean']['output']>;
  deleteMaintenanceReminder?: Maybe<Scalars['Boolean']['output']>;
  deleteRoutes: Array<Maybe<Scalars['ID']['output']>>;
  deleteToken?: Maybe<Scalars['String']['output']>;
  deleteVehicle?: Maybe<Scalars['ID']['output']>;
  deleteVehicleTag: Scalars['String']['output'];
  deleteVehiclesGroup?: Maybe<Scalars['ID']['output']>;
  disassociateTokenFromDriver?: Maybe<Scalars['String']['output']>;
  dismissFleetRecommendation: RecommendationActionResult;
  dismissGroupRecommendation: GroupRecommendation;
  /** Nominates a driver for a trip. */
  driverNominateTripImage?: Maybe<Scalars['Boolean']['output']>;
  endOperationalSituation: Scalars['Boolean']['output'];
  endRoute: Route;
  evaluateInsightThumbsDown?: Maybe<InsightEvaluation>;
  evaluateInsightThumbsUp?: Maybe<InsightEvaluation>;
  /** @deprecated Gerar no request esgota threads do Tomcat (incidente 2026-07-22/23). Use a query fleetGeofenceRecommendations; a geração virou job na user-api. */
  generateFleetGeofenceRecommendations: Array<FleetGeofenceRecommendation>;
  /** @deprecated Gerar no request esgota threads do Tomcat (incidente 2026-07-22/23). Use a query fleetGroupRecommendations; a geração virou job na user-api. */
  generateGroupRecommendation: Array<GroupRecommendation>;
  importExpenses: ImportBatchResponse;
  importFuelTransactions: ImportBatchResponse;
  importMaintenanceHistory: ImportBatchResponse;
  importSpreadsheet: Array<SpreadsheetImportResultAddress>;
  insertUserNotificationSettings?: Maybe<UserNotificationSettings>;
  /** Associa (instala) um dispositivo a um veículo. Espelha POST /vehicles/{vehicleId}/installed-device do fusca. */
  installDeviceInVehicle?: Maybe<Scalars['Boolean']['output']>;
  markConferenceReview: ConferenceTransactionResponse;
  /** Send an audio message to play on a specific device. Creates a playback record and attempts immediate delivery. */
  playFleetAudioMessage?: Maybe<FleetAudioMessagePlayback>;
  /**
   * Reject the current driver suggestion for a cluster. Idempotent: rejecting an
   * already-rejected suggestion is a no-op. Returns true on success.
   */
  rejectClusterSuggestion?: Maybe<Scalars['Boolean']['output']>;
  reopenConferenceReview: ConferenceTransactionResponse;
  restoreFuelCardAssociation: FuelCardAssociationStatusResponse;
  /** Retry a failed or pending playback. Resets status to PENDING and attempts delivery again. */
  retryFleetAudioMessagePlayback?: Maybe<FleetAudioMessagePlayback>;
  sendInvites?: Maybe<SendInvitesResponse>;
  /** Updates user feedback on a labeled image obstruction. */
  sendTripImageObstructionFeedback?: Maybe<Scalars['Boolean']['output']>;
  setupUserNotificationSettings?: Maybe<Array<Maybe<UserNotificationSettings>>>;
  startRoute: Route;
  toggleChecklistActive: Checklist;
  /**
   * Registra a frota como usuária da feature de recomendações, para o job saber quais frotas
   * visitar. Não gera nada.
   */
  touchFleetRecommendations: Scalars['Boolean']['output'];
  unassignDriverToDevice?: Maybe<Scalars['Boolean']['output']>;
  /** Desassocia (desinstala) o dispositivo atualmente instalado no veículo. Espelha DELETE /vehicles/{vehicleId}/installed-device do fusca. */
  uninstallDeviceFromVehicle?: Maybe<Scalars['Boolean']['output']>;
  updateActivity: Activity;
  /** If the requester is authorized to request the media, the faceId association will be updated. */
  updateAssociation?: Maybe<Scalars['Boolean']['output']>;
  /** If the requester is authorized to request the media, a media request will be created. */
  updateAudio?: Maybe<Scalars['Boolean']['output']>;
  updateChecklist: Checklist;
  updateContactTraining?: Maybe<Scalars['Boolean']['output']>;
  updateDeviceParameters: UpdateParameterResponse;
  /** @deprecated Use createOperationalSituations com situation RESERVE, ou endOperationalSituation com o id de Device.operationalSituation */
  updateDeviceSpareStatus?: Maybe<Scalars['Boolean']['output']>;
  updateDeviceStatusSubscription?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use createOperationalSituations, que aceita até 500 registros num request */
  updateDevicesSpareStatus?: Maybe<Scalars['Boolean']['output']>;
  updateDriver?: Maybe<Driver>;
  /** Update the events configuration for the requester's fleet cameras. */
  updateFleetEventsConfiguration?: Maybe<Scalars['Boolean']['output']>;
  /** Update how the requester's fleet reviews its event videos. Only users without group restriction can change it. */
  updateFleetVideoReviewConfiguration?: Maybe<FleetVideoReviewConfiguration>;
  updateFuelCardAssociation: FuelCardAssociationStatusResponse;
  updateFuelTransaction: FuelTransactionResponse;
  /**
   * Grava o telefone do usuário da sessão. Só o próprio usuário: o id vem da sessão,
   * nunca do cliente.
   */
  updateLoggedUserPhoneNumber: LoggedUser;
  updateMaintenanceHistory: Maintenance;
  updateMaintenanceParts: Part;
  updateMaintenanceReminder: ReminderDto;
  /**
   * Edita período e justificativa de uma situação que ainda não terminou. Situação já encerrada é
   * recusada: o histórico fica como aconteceu.
   */
  updateOperationalSituation: OperationalSituation;
  updateRouteV2: Route;
  /** If the requester is authorized to change the speed limit configuration, it will be changed. */
  updateSpeedLimitConfiguration?: Maybe<Scalars['Boolean']['output']>;
  updateUserActivationTask?: Maybe<UserActivationTask>;
  updateUserNotificationSettings?: Maybe<UserNotificationSettings>;
  updateUserTrainingMedia?: Maybe<UserTrainingMedia>;
  updateVehicle?: Maybe<VehicleDto>;
  updateVehicleImmobilizer?: Maybe<VehicleDto>;
  updateVehiclesGroup?: Maybe<VehiclesGroup>;
  validateImportVehicleSpreadsheet: ValidateImportVehicleSpreadsheetResponse;
  vehicleAssociations: Array<Activity>;
};

export type MutationAcceptInviteArgs = {
  input: IInviteAcceptForm;
  token: Scalars['String']['input'];
};

export type MutationAddChecklistArgs = {
  input?: InputMaybe<NewChecklist>;
};

export type MutationAddDriverArgs = {
  input?: InputMaybe<AddDriver>;
};

export type MutationApplyGroupRecommendationArgs = {
  fleetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: ApplyGroupRecommendationInput;
};

export type MutationAssignDriverToDeviceArgs = {
  input: DriverAssignmentInput;
};

export type MutationAssignFaceClusterArgs = {
  input: Array<InputMaybe<DriverFaceClusterUpdate>>;
};

export type MutationAssociateTokenToDriverArgs = {
  driverId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type MutationBatchCreateDriversArgs = {
  input: BatchCreateDriversInput;
};

export type MutationBatchCreateIdentificationTokensArgs = {
  input: BatchCreateIdentificationTokensInput;
};

export type MutationBatchSetFuelConsumptionGoalsArgs = {
  input: Array<UpsertVehicleFuelConsumptionGoalInput>;
};

export type MutationCancelOperationalSituationArgs = {
  input: CancelOperationalSituationInput;
};

export type MutationChangeCameraConfigurationArgs = {
  input: Array<InputMaybe<CameraConfigurationUpdateInput>>;
};

export type MutationChangeChecklistNonConformityStatusArgs = {
  input: ChangeChecklistNonConformityStatusInput;
};

export type MutationCompleteFleetRecommendationArgs = {
  category: Scalars['String']['input'];
  fleetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationCreateActivitiesArgs = {
  input: Array<InputActivity>;
};

export type MutationCreateCheckpointManualArgs = {
  input: CreateCheckpointManualInput;
};

export type MutationCreateFleetAudioMessageArgs = {
  input: CreateFleetAudioMessageInput;
};

export type MutationCreateFuelTransactionArgs = {
  input: CreateFuelTransactionInput;
};

export type MutationCreateMaintenanceHistoryArgs = {
  input: CreateMaintenanceHistoryInput;
};

export type MutationCreateMaintenancePartsArgs = {
  input: CreateMaintenancePartsInput;
};

export type MutationCreateMaintenanceReminderArgs = {
  input: CreateReminderInput;
};

export type MutationCreateMediaArgs = {
  input: CreateMediaRequest;
};

export type MutationCreateOperationalSituationsArgs = {
  input: Array<CreateOperationalSituationInput>;
};

export type MutationCreateRoutesArgs = {
  input?: InputMaybe<RoutingSettings>;
};

export type MutationCreateVehicleArgs = {
  input: CreateVehicleInput;
};

export type MutationCreateVehiclesBatchArgs = {
  input: CreateVehiclesBatchInput;
};

export type MutationCreateVehiclesGroupArgs = {
  input: VehiclesGroupInput;
};

export type MutationDeleteActivitiesArgs = {
  input: DeleteActivitiesIds;
};

export type MutationDeleteChecklistArgs = {
  input?: InputMaybe<DeleteChecklist>;
};

export type MutationDeleteDriverArgs = {
  input?: InputMaybe<DeleteDriver>;
};

export type MutationDeleteFleetAudioMessagePlaybackArgs = {
  audioMessageId: Scalars['ID']['input'];
  playbackId: Scalars['ID']['input'];
};

export type MutationDeleteFuelCardAssociationArgs = {
  input: FuelCardAssociationStatusInput;
};

export type MutationDeleteFuelTransactionsArgs = {
  input: DeleteFuelTransactionsInput;
};

export type MutationDeleteInviteArgs = {
  token: Scalars['String']['input'];
};

export type MutationDeleteMaintenanceHistoryArgs = {
  input: DeleteMaintenanceHistoryInput;
};

export type MutationDeleteMaintenancePartsArgs = {
  input: DeleteMaintenancePartsInput;
};

export type MutationDeleteMaintenanceReminderArgs = {
  input: DeleteMaintenanceReminderInput;
};

export type MutationDeleteRoutesArgs = {
  input?: InputMaybe<DeleteRoutesInput>;
};

export type MutationDeleteTokenArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteVehicleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteVehicleTagArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteVehiclesGroupArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDisassociateTokenFromDriverArgs = {
  id: Scalars['String']['input'];
};

export type MutationDismissFleetRecommendationArgs = {
  category: Scalars['String']['input'];
  fleetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDismissGroupRecommendationArgs = {
  fleetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type MutationDriverNominateTripImageArgs = {
  input?: InputMaybe<Array<InputMaybe<DriverNominateTripImageInput>>>;
};

export type MutationEndOperationalSituationArgs = {
  input: EndOperationalSituationInput;
};

export type MutationEndRouteArgs = {
  input?: InputMaybe<RouteStartOrEndInput>;
};

export type MutationEvaluateInsightThumbsDownArgs = {
  input: InsightThumbsDownInput;
};

export type MutationEvaluateInsightThumbsUpArgs = {
  input: InsightThumbsUpInput;
};

export type MutationGenerateFleetGeofenceRecommendationsArgs = {
  fleetId: Scalars['ID']['input'];
};

export type MutationGenerateGroupRecommendationArgs = {
  fleetId: Scalars['ID']['input'];
};

export type MutationImportExpensesArgs = {
  input: Array<ImportExpensesBatchInput>;
};

export type MutationImportFuelTransactionsArgs = {
  input: Array<ImportFuelTransactionsBatchInput>;
};

export type MutationImportMaintenanceHistoryArgs = {
  input: Array<ImportMaintenanceBatchInput>;
};

export type MutationImportSpreadsheetArgs = {
  input: Array<SpreadsheetRow>;
};

export type MutationInsertUserNotificationSettingsArgs = {
  input?: InputMaybe<InsertUserNotificationSettings>;
};

export type MutationInstallDeviceInVehicleArgs = {
  input: InstallDeviceInVehicleInput;
};

export type MutationMarkConferenceReviewArgs = {
  input: MarkConferenceReviewInput;
};

export type MutationPlayFleetAudioMessageArgs = {
  audioMessageId: Scalars['ID']['input'];
  input: PlayFleetAudioMessageInput;
};

export type MutationRejectClusterSuggestionArgs = {
  clusterId: Scalars['ID']['input'];
};

export type MutationReopenConferenceReviewArgs = {
  input: ReopenConferenceReviewInput;
};

export type MutationRestoreFuelCardAssociationArgs = {
  input: FuelCardAssociationStatusInput;
};

export type MutationRetryFleetAudioMessagePlaybackArgs = {
  audioMessageId: Scalars['ID']['input'];
  playbackId: Scalars['ID']['input'];
};

export type MutationSendInvitesArgs = {
  input?: InputMaybe<Array<InputMaybe<InviteForm>>>;
};

export type MutationSendTripImageObstructionFeedbackArgs = {
  input?: InputMaybe<SendImageObstructionFeedback>;
};

export type MutationSetupUserNotificationSettingsArgs = {
  input?: InputMaybe<Array<InputMaybe<InsertUserNotificationSettings>>>;
};

export type MutationStartRouteArgs = {
  input?: InputMaybe<RouteStartOrEndInput>;
};

export type MutationToggleChecklistActiveArgs = {
  input?: InputMaybe<ToggleChecklistActive>;
};

export type MutationTouchFleetRecommendationsArgs = {
  fleetId: Scalars['ID']['input'];
};

export type MutationUnassignDriverToDeviceArgs = {
  input: DriverAssignmentInput;
};

export type MutationUninstallDeviceFromVehicleArgs = {
  input: UninstallDeviceFromVehicleInput;
};

export type MutationUpdateActivityArgs = {
  input: ActivityUpdate;
};

export type MutationUpdateAssociationArgs = {
  input: AssociationConfigInput;
};

export type MutationUpdateAudioArgs = {
  input: Array<InputMaybe<UpdateAudioRequest>>;
};

export type MutationUpdateChecklistArgs = {
  input?: InputMaybe<UpdateChecklist>;
};

export type MutationUpdateContactTrainingArgs = {
  input: UpdateContactTrainingInfoInput;
};

export type MutationUpdateDeviceParametersArgs = {
  input: UpdateDeviceParameter;
};

export type MutationUpdateDeviceSpareStatusArgs = {
  input: UpdateDeviceSpareStatusInput;
};

export type MutationUpdateDeviceStatusSubscriptionArgs = {
  input?: InputMaybe<DeviceStatusSubscriptionInput>;
};

export type MutationUpdateDevicesSpareStatusArgs = {
  input: Array<UpdateDeviceSpareStatusInput>;
};

export type MutationUpdateDriverArgs = {
  input?: InputMaybe<UpdateDriver>;
};

export type MutationUpdateFleetEventsConfigurationArgs = {
  input: UpdateEventsConfigurationInput;
};

export type MutationUpdateFleetVideoReviewConfigurationArgs = {
  input: UpdateFleetVideoReviewConfigurationInput;
};

export type MutationUpdateFuelCardAssociationArgs = {
  input: UpdateFuelCardAssociationInput;
};

export type MutationUpdateFuelTransactionArgs = {
  input: UpdateFuelTransactionInput;
};

export type MutationUpdateLoggedUserPhoneNumberArgs = {
  input: UpdateLoggedUserPhoneNumberInput;
};

export type MutationUpdateMaintenanceHistoryArgs = {
  input: UpdateMaintenanceHistoryInput;
};

export type MutationUpdateMaintenancePartsArgs = {
  input: UpdateMaintenancePartsInput;
};

export type MutationUpdateMaintenanceReminderArgs = {
  input: UpdateReminderInput;
};

export type MutationUpdateOperationalSituationArgs = {
  input: UpdateOperationalSituationInput;
};

export type MutationUpdateRouteV2Args = {
  input?: InputMaybe<RouteUpdate>;
};

export type MutationUpdateSpeedLimitConfigurationArgs = {
  input?: InputMaybe<SpeedLimitUpdateInput>;
};

export type MutationUpdateUserActivationTaskArgs = {
  input: UserActivationTaskInput;
};

export type MutationUpdateUserNotificationSettingsArgs = {
  input?: InputMaybe<UpdateUserNotificationSettings>;
};

export type MutationUpdateUserTrainingMediaArgs = {
  input: UpdateUserTrainingMediaInput;
};

export type MutationUpdateVehicleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateVehicleInput;
};

export type MutationUpdateVehicleImmobilizerArgs = {
  input: UpdateVehicleImmobilizerInput;
};

export type MutationUpdateVehiclesGroupArgs = {
  id: Scalars['ID']['input'];
  input: VehiclesGroupInput;
};

export type MutationValidateImportVehicleSpreadsheetArgs = {
  input: ValidateImportVehicleSpreadsheetInput;
};

export type MutationVehicleAssociationsArgs = {
  input: Array<ActivityVehicleAssociationInput>;
};

export type NewChecklist = {
  context?: InputMaybe<NewChecklistContext>;
  fields: Array<NewChecklistField>;
  name: Scalars['String']['input'];
  template: Scalars['Boolean']['input'];
  vehicle_group_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicle_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  version: Scalars['Int']['input'];
};

export type NewChecklistContext = {
  address?: InputMaybe<Scalars['String']['input']>;
  app_version: Scalars['String']['input'];
  vehicle?: InputMaybe<NewChecklistVehicle>;
};

export type NewChecklistField = {
  content: Scalars['String']['input'];
  /** Echo the key read from `Field.questionKey`; omit it for a new question. */
  questionKey?: InputMaybe<Scalars['ID']['input']>;
  required: Scalars['Boolean']['input'];
  should_request_photos?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: FieldType;
};

export type NewChecklistVehicle = {
  brand?: InputMaybe<Scalars['String']['input']>;
  device_id: Scalars['String']['input'];
  group_id?: InputMaybe<Scalars['String']['input']>;
  license_plate?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export type NominationOperation = 'CONFIRM' | 'EDIT';

export type OldProofOfConclusion = {
  activity_id?: Maybe<Scalars['ID']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  completed_at: Scalars['TimestampInMillis']['output'];
  fleet_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  img_urls: Array<Scalars['String']['output']>;
  license_plate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Scalars['String']['output']>;
  saved_at: Scalars['TimestampInMillis']['output'];
  user_id: Scalars['ID']['output'];
  user_name: Scalars['String']['output'];
  vehicle_id?: Maybe<Scalars['ID']['output']>;
};

export type OperationSummary = {
  activities: ActivitiesSummary;
  routes: RoutesSummary;
};

export type OperationSummaryInput = {
  activity_route_relation?: InputMaybe<ActivityRouteRelation>;
  devices_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  drivers_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  period: DateRange;
  text_filter?: InputMaybe<Scalars['String']['input']>;
  vehicles_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OperationalSituation = {
  /**
   * Se a situação está ativa no momento da leitura. Mantido para os clientes anteriores ao `status`;
   * uma situação SCHEDULED não é ativa.
   * @deprecated Use status: uma situação agendada não é ativa nem encerrada
   */
  active: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Quem registrou a situação. Nulo nas linhas criadas pelo backfill do is_spare, que
   * são anteriores à coluna no backend.
   */
  createdBy?: Maybe<FleetUser>;
  /**
   * Nulo = sem prazo definido. Uma data no passado faz a situação deixar de ser ativa — a expiração é
   * avaliada na leitura, não existe job de encerramento.
   */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  /**
   * Lembrete de manutenção que gerou esta situação, quando ela nasceu da sugestão. Referência ao
   * serviço de manutenção — pode apontar para um lembrete que não existe mais.
   */
  reminderId?: Maybe<Scalars['ID']['output']>;
  situation: OperationalSituationType;
  startsAt: Scalars['DateTime']['output'];
  status: OperationalSituationStatus;
  target?: Maybe<OperationalSituationTarget>;
  /** UUID do veículo ou ESN do dispositivo, conforme targetType. */
  targetId: Scalars['String']['output'];
  targetType: OperationalSituationTargetType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OperationalSituationPage = {
  content: Array<OperationalSituation>;
  page: OperationalSituationPageInfo;
};

export type OperationalSituationPageInfo = {
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type OperationalSituationSort = {
  column?: OperationalSituationSortColumn;
  order?: Order;
};

/**
 * Colunas ordenáveis. Enum em vez de string livre porque o backend ordena por nome de propriedade
 * JPA: uma coluna inexistente virava 500 lá, ou seja, um erro de digitação do front acordava o
 * alerta de produção. Aqui o schema recusa na borda.
 */
export type OperationalSituationSortColumn = 'CREATED_AT' | 'ENDS_AT' | 'SITUATION' | 'STARTS_AT' | 'TARGET_ID' | 'TARGET_TYPE';

/**
 * Onde a situação está no tempo, derivado na leitura — não existe job movendo entre os estados.
 * SCHEDULED só passou a ser alcançável quando a situação passou a aceitar início futuro.
 */
export type OperationalSituationStatus =
  /** Já começou e não terminou. É o único estado que torna o recurso indisponível. */
  | 'ACTIVE'
  /** Já passou do ends_at. */
  | 'ENDED'
  /** Começa no futuro: o recurso ainda não está indisponível. */
  | 'SCHEDULED';

/**
 * O recurso ao qual a situação se aplica. Nulo quando o recurso já foi excluído — o backend preserva
 * a situação como histórico.
 */
export type OperationalSituationTarget = Device | VehicleDto;

export type OperationalSituationTargetType = 'DEVICE' | 'VEHICLE';

export type OperationalSituationType = 'MAINTENANCE' | 'RESERVE';

export type OperationalSituationsFilter = {
  /**
   * true = ativas agora; false = já encerradas; omitido = todas. Não distingue as agendadas: para
   * filtrar por SCHEDULED é preciso o filtro equivalente no fusca, que ainda não existe.
   */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Só as que encerraram entre este instante e agora. Combine com active: false para pegar as paradas
   * recém-terminadas em vez do histórico inteiro do alvo.
   */
  endedSince?: InputMaybe<Scalars['DateTime']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  situation?: InputMaybe<OperationalSituationType>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OperationalSituationSort>;
  /** Deve ser acompanhado de targetType. Para VEHICLE precisa ser um UUID válido. */
  targetId?: InputMaybe<Scalars['String']['input']>;
  targetType?: InputMaybe<OperationalSituationTargetType>;
};

export type OptionContent = {
  checked?: Maybe<Scalars['Boolean']['output']>;
  compliance?: Maybe<ChecklistCompliance>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type Order = 'asc' | 'desc';

export type PageDriverFaceClustersInfo = {
  content?: Maybe<Array<Maybe<DriverFaceClustersInfo>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type PageDriverFaceClustersSuggestion = {
  content?: Maybe<Array<Maybe<DriverFaceClustersSuggestion>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type PageImageTrip = {
  content?: Maybe<Array<Maybe<TripImage>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type PagePeriodicImage = {
  content: Array<PeriodicImage>;
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageRunningWithoutDriverVehicles = {
  content: Array<RunningWithoutDriverVehicle>;
  page: RunningWithoutDriverPageInfo;
};

export type PageTrip = {
  content?: Maybe<Array<Maybe<Trip>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type PageableObject = {
  offset?: Maybe<Scalars['Int']['output']>;
  page_number?: Maybe<Scalars['Int']['output']>;
  page_size?: Maybe<Scalars['Int']['output']>;
  paged?: Maybe<Scalars['Boolean']['output']>;
  sort?: Maybe<SortType>;
  unpaged?: Maybe<Scalars['Boolean']['output']>;
};

export type PagedFuelTransaction = {
  cobliDrivenKms?: Maybe<Scalars['Float']['output']>;
  /**
   * Odômetro virtual da telemetria Cobli no momento do abastecimento: conta a partir da instalação ou de
   * um valor configurado, e pode não bater com o painel do veículo.
   */
  cobliOdometer?: Maybe<Scalars['Float']['output']>;
  conferenceStatus?: Maybe<Scalars['String']['output']>;
  costPerLiter: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  createdBy: Scalars['String']['output'];
  creatorId?: Maybe<Scalars['ID']['output']>;
  /**
   * Km desde o abastecimento anterior pelo odômetro informado. O medido pela telemetria é
   * `cobliDrivenKms`.
   */
  drivenKms?: Maybe<Scalars['Float']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  fuelLiters: Scalars['Float']['output'];
  fuelPumpFileUrl?: Maybe<Scalars['String']['output']>;
  fuelType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  odometer?: Maybe<Scalars['Float']['output']>;
  odometerFileUrl?: Maybe<Scalars['String']['output']>;
  recalculatedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  /**
   * Origem do lançamento. É String e não enum, como `conferenceStatus`: uma origem nova do frentista
   * não pode derrubar a query.
   */
  source?: Maybe<Scalars['String']['output']>;
  station?: Maybe<FuelStation>;
  totalCost: Scalars['Float']['output'];
  totalCount: Scalars['Int']['output'];
  transactionCode?: Maybe<Scalars['String']['output']>;
  transactionTime: Scalars['TimestampInMillis']['output'];
  vehicle: PagedVehicleResponse;
};

export type PagedFuelTransactionStatsByVehicle = {
  avgCostPerKm?: Maybe<Scalars['Float']['output']>;
  avgCostPerLiter: Scalars['Float']['output'];
  consumptionAvg?: Maybe<Scalars['Float']['output']>;
  consumptionGoal?: Maybe<Scalars['Float']['output']>;
  fuelType: Scalars['String']['output'];
  sumCobliDrivenKms?: Maybe<Scalars['Float']['output']>;
  sumFuelLiters: Scalars['Float']['output'];
  sumTotalCost: Scalars['Float']['output'];
  totalCount: Scalars['Int']['output'];
  vehicleGroup?: Maybe<Scalars['String']['output']>;
  vehicleGroupName?: Maybe<Scalars['String']['output']>;
  vehicleId: Scalars['ID']['output'];
  vehicleLicensePlate: Scalars['String']['output'];
  vehicleModel?: Maybe<Scalars['String']['output']>;
};

export type PagedFuelTransactionStatsByVehicleResponse = {
  content: Array<PagedFuelTransactionStatsByVehicle>;
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PagedFuelTransactionsResponse = {
  content: Array<PagedFuelTransaction>;
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PagedVehicleResponse = {
  group?: Maybe<VehicleGroupDto>;
  id: Scalars['ID']['output'];
  licensePlate: Scalars['String']['output'];
  model?: Maybe<Scalars['String']['output']>;
};

export type PaginatedActivities = {
  content: Array<Maybe<Activity>>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  number_of_elements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total_elements: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type PaginatedChecklists = {
  content: Array<Maybe<Checklist>>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  number_of_elements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total_elements: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type PaginatedRoutes = {
  content: Array<Maybe<Route>>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  number_of_elements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total_elements: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type PaginatedUserAlerts = {
  content: Array<Maybe<UserAlert>>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  number_of_elements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total_elements: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type PaginatedVehiclesV1 = {
  content: Array<VehicleV1>;
  totalElements: Scalars['Int']['output'];
};

export type PaginatedVehiclesV1Input = {
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type Parameter = {
  created_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  value: Scalars['String']['output'];
};

export type ParameterInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Part = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type Path = {
  associationSource?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<VehicleDriverDto>;
  endLatitude?: Maybe<Scalars['Float']['output']>;
  endLongitude?: Maybe<Scalars['Float']['output']>;
  endTime: Scalars['Float']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  startLatitude?: Maybe<Scalars['Float']['output']>;
  startLongitude?: Maybe<Scalars['Float']['output']>;
  startTime: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  vehicle?: Maybe<VehicleDto>;
};

export type PathGeojson = {
  geometry: Geometry;
  properties: Properties;
  type: Scalars['String']['output'];
};

export type PeriodicImage = {
  /**
   * The camera the still came from. Nullable on purpose: this is the one field whose value can arrive
   * outside the enum — the pooler gaining a channel this schema does not know yet — and a non-null
   * enum would nullify the whole page instead of just this field.
   */
  channel?: Maybe<PeriodicImageChannel>;
  /** Identifier. */
  id: Scalars['ID']['output'];
  /** Signed URL for the still. */
  imageUrl: Scalars['String']['output'];
  /** The moment captured, as a Unix timestamp in millis. */
  timestamp: Scalars['TimestampInMillis']['output'];
};

export type PeriodicImageChannel = 'CABIN' | 'CHANNEL_FIVE' | 'CHANNEL_FOUR' | 'CHANNEL_THREE' | 'DRIVER' | 'PIP' | 'ROAD';

export type PlannedVsExecutedDurationTimeInMillis = {
  executed?: Maybe<Scalars['Long']['output']>;
  planned?: Maybe<Scalars['Long']['output']>;
};

export type PlannedVsExecutedInt = {
  executed?: Maybe<Scalars['Int']['output']>;
  planned?: Maybe<Scalars['Int']['output']>;
};

export type PlannedVsExecutedTimestampInMillis = {
  executed?: Maybe<Scalars['TimestampInMillis']['output']>;
  planned: Scalars['TimestampInMillis']['output'];
};

export type PlayFleetAudioMessageInput = {
  /** If true, auto-cancel the audio playback if not successfully sent within 1 hour. */
  cancelIfTimeout?: InputMaybe<Scalars['Boolean']['input']>;
  /** Device identifier (10-15 digits). */
  deviceId: Scalars['String']['input'];
  /** Optional driver ID associated with this playback. */
  driverId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional driver name associated with this playback. */
  driverName?: InputMaybe<Scalars['String']['input']>;
  /** The vehicle ID on which to play the audio message. */
  vehicleId: Scalars['ID']['input'];
};

export type PlaybackStatus =
  /** Playback was cancelled. */
  | 'CANCELLED'
  /** Playback delivery failed. */
  | 'ERROR'
  /** Playback is pending delivery to the device. */
  | 'PENDING'
  /** Playback was successfully delivered and played on the device. */
  | 'SUCCESS';

export type Product = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProofOfConclusion = {
  activityId?: Maybe<Scalars['ID']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  completedAt: Scalars['TimestampInMillis']['output'];
  fleetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  imgUrls: Array<Scalars['String']['output']>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Scalars['String']['output']>;
  savedAt: Scalars['TimestampInMillis']['output'];
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
  vehicle?: Maybe<VehicleDto>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
};

export type PropagationType = 'ALL_ROUTES' | 'ONLY_THIS_ROUTE';

export type Properties = {
  jumpsPeriods?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  speeds?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  timestamps: Array<Maybe<Scalars['Float']['output']>>;
};

export type Query = {
  activationTasks: Array<ActivationTask>;
  activities: PaginatedActivities;
  activity: Activity;
  activitySummary: ActivitiesSummary;
  alert: PaginatedUserAlerts;
  /** Get association status of the requester's fleet cameras. */
  association?: Maybe<FleetAutoAssociationSettings>;
  /** Get audio coaching status of the requester's fleet cameras. */
  audio?: Maybe<AudioCoachingDevicesInfoPage>;
  avgFuelConsumptionAndCostPerKm: Array<AvgFuelConsumptionAndCostPerKmResponse>;
  billets?: Maybe<Array<Maybe<Billet>>>;
  billetsByCompanies?: Maybe<Array<Maybe<Billet>>>;
  /** Get audio coaching status of the requester's fleet cameras. */
  cameraConfiguration?: Maybe<CameraConfigurationInfoPage>;
  categories?: Maybe<Array<Maybe<Category>>>;
  checklist: Checklist;
  checklistNonConformities?: Maybe<ChecklistNonConformityPaginated>;
  /**
   * Nulo, com o 404 do ryuk em `extensions.response.status`, quando a tratativa não existe na frota ou fora dos
   * grupos do usuário.
   */
  checklistNonConformity?: Maybe<ChecklistNonConformity>;
  /** Ignora `statuses` do filtro: conta todos os status para os demais filtros. */
  checklistNonConformitySummary?: Maybe<ChecklistNonConformitySummary>;
  checklistsNames: ChecklistsNames;
  coachingFeedback?: Maybe<CoachingFeedbackPage>;
  coachingFeedbackDetails?: Maybe<CoachingFeedback>;
  companyOnboardingStatus?: Maybe<FleetCompanyOnboardingStatus>;
  completedChecklists: ChecklistsPage;
  completionData?: Maybe<CompletionData>;
  conferenceTransactionById: ConferenceTransactionResponse;
  contracts?: Maybe<FleetCompanyContracts>;
  customDashboard: CustomDashboard;
  customDashboards: Array<CustomDashboard>;
  deviceConfiguration: DeviceConfiguration;
  deviceStatusSubscription: DeviceStatusSubscription;
  devices: Array<Device>;
  devolutionTicketsByDeviceId: Tickets;
  driverById: Driver;
  /** Get driver face clusters of the requester's fleet cameras. */
  driverFaceClustersInfo?: Maybe<PageDriverFaceClustersInfo>;
  driverFaceClustersSuggestions?: Maybe<PageDriverFaceClustersSuggestion>;
  driverFaceIdRegistrations: Array<DriverFaceIdRegistration>;
  driverSpeedRow?: Maybe<Array<DriverSpeedRow>>;
  drivers: Array<Maybe<Driver>>;
  driversById: Array<Maybe<Driver>>;
  driversCount: Scalars['Int']['output'];
  driversWithCompleteFaceIdRegistrationCount: Scalars['Int']['output'];
  /** Get a summary of media counts grouped by severity levels */
  eventsSeveritiesSummary?: Maybe<SeveritiesSummary>;
  expenses: ExpensePaginatedResponse;
  faceIdCoverageChart: FaceIdCoverageChart;
  /** Get the geolocation (latitude, longitude) of a specific face image by its ID. Returns null when the location service has no data within the tolerance window for the image's device and timestamp. */
  faceImageGeolocation?: Maybe<Coordinate>;
  fleet?: Maybe<Fleet>;
  /**
   * Get playback history for a vehicle with pagination support.
   * Results are ordered by creation date in descending order by default (newest first).
   */
  fleetAudioMessagePlaybacks?: Maybe<FleetAudioMessagePlaybackPage>;
  fleetDevicesParameterStatus: Array<DeviceParameterStatus>;
  fleetDevicesParameterValues: Array<DeviceParameterValue>;
  fleetEventsConfiguration?: Maybe<FleetEventsConfiguration>;
  /** Recomendações de locais de interesse já persistidas para a frota. Só lê. */
  fleetGeofenceRecommendations: Array<FleetGeofenceRecommendation>;
  /**
   * Recomendações de grupos já persistidas para a frota. Só lê: a geração vive num job agendado
   * na user-api.
   */
  fleetGroupRecommendations: Array<GroupRecommendation>;
  /**
   * Identification-method health of the requester's fleet: how well the fleet
   * registered its drivers (M1) and how many of its video events are being
   * attributed to a driver (M2), plus the resulting health state. The fleet is
   * derived from the session; no argument is needed.
   */
  fleetIdentificationHealth?: Maybe<FleetIdentificationHealthDto>;
  /** Get fleet products */
  fleetProducts?: Maybe<FleetProducts>;
  /** Returns the users of the fleet */
  fleetUsers?: Maybe<Array<Maybe<FleetUser>>>;
  fleetVehicleGroups?: Maybe<Array<Maybe<FleetVehicleGroups>>>;
  /** How the requester's fleet reviews its event videos. */
  fleetVideoReviewConfiguration?: Maybe<FleetVideoReviewConfiguration>;
  fuelCardAssociations: Array<FuelCardAssociationResponse>;
  fuelTransactionById: FuelTransactionResponse;
  fuelTransactionStatsByVehicleSummary: FuelTransactionStatsByVehicleSummaryResponse;
  fuelTransactionsSummary: FuelTransactionSummaryResponse;
  /**
   * Get the public S3 URL for an audio file by playback ID.
   * The URL is valid for download and does not require authentication.
   */
  getAudioFile: AudioFileResponse;
  /** Check if fleet has camera */
  hasCameraFlag?: Maybe<Scalars['Boolean']['output']>;
  /** Check if fleet has camera (cached 1d) */
  hasCameraFlagCached?: Maybe<Scalars['Boolean']['output']>;
  hasFaceIdIdentificationHistory: Scalars['Boolean']['output'];
  /** Check if fleet has redecan */
  hasRedeCan?: Maybe<Scalars['Boolean']['output']>;
  homeProductivitySummary?: Maybe<HomeProductivitySummary>;
  homeSpeedSummary?: Maybe<HomeSpeedSummary>;
  homeSummaryDevices: Scalars['Int']['output'];
  homeSummaryGeofences: Scalars['Int']['output'];
  homeSummaryVehicles: Scalars['Int']['output'];
  insights?: Maybe<Array<Maybe<Insight>>>;
  inviteInfo?: Maybe<IEnrollmentFormInfo>;
  lastAssociation?: Maybe<LastAssociation>;
  lastPath?: Maybe<LastPath>;
  latestMaintenanceByVehicle?: Maybe<Maintenance>;
  /**
   * Identidade e contato do usuário da sessão.
   *
   * Existe para quem precisa saber se há telefone cadastrado — o número só chegava
   * ao cliente na resposta do login, e quem pergunta depois não tinha por onde.
   * Frotas, permissões e preferências continuam nas queries próprias.
   */
  loggedUser?: Maybe<LoggedUser>;
  maintenanceHistory: MaintenanceResponse;
  maintenanceParts: MaintenancePartResponse;
  /** Get media events and footages of the requester's fleet. */
  media?: Maybe<MediaPage>;
  /** Daily recommendations of relevant medias. */
  mediaDailyRecommendations?: Maybe<MediaPage>;
  /** Used to view a media. If the requester is authorized to watch the media, it will return a generated signed media URL and its expiration date. */
  mediaView?: Maybe<MediaResponse>;
  operationSummary: OperationSummary;
  operationalSituations: OperationalSituationPage;
  orderById?: Maybe<CrmOrder>;
  orders: Array<Maybe<CrmOrder>>;
  pagedFuelTransactionStatsByVehicle: PagedFuelTransactionStatsByVehicleResponse;
  pagedFuelTransactions: PagedFuelTransactionsResponse;
  paginatedVehiclesV1: PaginatedVehiclesV1;
  paths?: Maybe<Array<Maybe<Path>>>;
  pendingInvites?: Maybe<Array<Maybe<Invite>>>;
  proofsOfConclusion: Array<ProofOfConclusion>;
  reminderList: MaintenanceReminderResponse;
  reminderStatusSummary: ReminderStatusCount;
  reminderTitles: Array<ReminderTitle>;
  riskEvents: Array<RiskEvent>;
  route: Route;
  routes: PaginatedRoutes;
  routesReport: Array<RouteReport>;
  routesV2: PaginatedRoutes;
  runningWithoutDriverVehicles: PageRunningWithoutDriverVehicles;
  safetyRankingParams: SafetyRankingParams;
  safetyRankingProductType: SafetyRankingProductType;
  safetyRankingProductivity: SafetyRankingProductivity;
  safetyRankingScores: SafetyRankingScores;
  /** Gets the Safety Review historic records */
  safetyReviewHistory?: Maybe<SafetyReviewHistoryPage>;
  schedulingHolidays: Array<Scalars['String']['output']>;
  settings: Array<Maybe<UserNotificationSettings>>;
  sumTotalCostByFuelType: Array<SumTotalCostByFuelTypeResponse>;
  suppliers?: Maybe<Array<Maybe<Supplier>>>;
  templateChecklists: ChecklistsPage;
  tokens?: Maybe<Array<IdentificationToken>>;
  tokensV2?: Maybe<Array<IdentificationTokenV2>>;
  tracking?: Maybe<Tracking>;
  /** Returns all the training videos. */
  trainingVideos?: Maybe<Array<Maybe<TrainingVideo>>>;
  /** Returns all the training videos aggregated by category. */
  trainingVideosByCategory?: Maybe<Array<Maybe<TrainingVideos>>>;
  /** Get camera trips from a given device ID. */
  trip?: Maybe<PageTrip>;
  /** Get trip image history of the requester's fleet */
  tripImage?: Maybe<PageImageTrip>;
  /** Get camera trip images from a single trip. */
  tripImagesDetails?: Maybe<TripImage>;
  /**
   * Stills captured by the camera during a trip, to judge the window before requesting footage.
   * Distinct from `tripImage`, which is the driver-nomination history of a trip.
   */
  tripPeriodicImages?: Maybe<PagePeriodicImage>;
  tripsByVehicle?: Maybe<PageTrip>;
  unnamedFaceClustersCount: Scalars['Int']['output'];
  upcomingTickets?: Maybe<UpcomingTickets>;
  userActivationTasks: Array<UserActivationTask>;
  /** Returns the user attributes for the given user id. */
  userAttributes?: Maybe<UserAttributes>;
  /** Returns the user default roles for the given user id. */
  userDefaultRoles?: Maybe<Array<Maybe<UserDefaultRoles>>>;
  /** Returns the user fleets for the given user id. */
  userFleets?: Maybe<Array<Maybe<UserFleets>>>;
  /** Returns the user preferences for the given user id. */
  userPreferences?: Maybe<UserPreferences>;
  /** Returns user metadata for training media */
  userTrainingMedia?: Maybe<Array<Maybe<UserTrainingMedia>>>;
  validateExpensesImport: ValidateExpensesImportResponse;
  validateFuelTransactionsImport: ValidateFuelTransactionsImportResponse;
  validateMaintenanceImport: ValidateMaintenanceImportResponse;
  vehicle?: Maybe<VehicleDto>;
  vehicleDeviceAssociationReportByDevice: VehicleDeviceAssociationInfoResponse;
  vehicleDeviceAssociationReportByVehicle: VehicleDeviceAssociationInfoResponse;
  vehicleDriverAuthorizations?: Maybe<VehicleDriverAuthorization>;
  vehicleExpenses: VehicleExpensesPaginatedResponse;
  vehicleGroups?: Maybe<Array<Maybe<VehiclesGroup>>>;
  vehicleModels: Array<Branding>;
  vehiclePastAssociations?: Maybe<Array<Maybe<VehiclePastAssociationDto>>>;
  vehicleSuggestionsBatch: BatchSuggestionsResponse;
  vehicleTags?: Maybe<Array<VehicleTag>>;
  /** Get images by vehicle and an image timestamp */
  vehicleTimestampImagesDetails?: Maybe<VehicleImages>;
  vehicleTracking?: Maybe<Tracking>;
  /** Returns trackings of route steps (trip/stop) that intersects a segment */
  vehicleTrackingSegment?: Maybe<VehicleTrackingSegmentType>;
  vehicleTripDistance: VehicleTripDistanceResponse;
  vehicles?: Maybe<Array<Maybe<VehicleDto>>>;
  vehiclesRunningWithoutDriverCount: Scalars['Int']['output'];
  /**
   * Quanto uma solicitação de vídeo costuma levar, agregado pelo pooler sobre os últimos 30 dias.
   *
   * A amostra tem só solicitações concluídas, de origem manual, e feitas com o veículo ligado e
   * transmitindo — sem esse recorte a mediana mistura minutos de câmera ligada com horas de carro
   * parado esperando ligar, e não descreve nenhum dos dois casos.
   *
   * O p90 só existe por frota de propósito: cerca de 22% dos dispositivos juntam as 20 solicitações
   * concluídas que um quantil alto precisa para significar alguma coisa. Quem consome decide o
   * tamanho mínimo de amostra a partir de `sampleSize`.
   */
  videoDeliveryTime: VideoDeliveryTime;
  wifiSettings?: Maybe<AccessPoints>;
};

export type QueryActivationTasksArgs = {
  input?: InputMaybe<ActivationTaskInput>;
};

export type QueryActivitiesArgs = {
  input: ListActivitiesInput;
};

export type QueryActivityArgs = {
  input: Scalars['ID']['input'];
};

export type QueryActivitySummaryArgs = {
  input: ActivitiesSummaryInput;
};

export type QueryAlertArgs = {
  filters?: InputMaybe<Filters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<DateRange>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
};

export type QueryAudioArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryAvgFuelConsumptionAndCostPerKmArgs = {
  input: GetFuelTransactionSummaryByPeriodTypeInput;
};

export type QueryBilletsArgs = {
  companyId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryBilletsByCompaniesArgs = {
  companyIds: Array<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCameraConfigurationArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryChecklistArgs = {
  input?: InputMaybe<GetChecklist>;
};

export type QueryChecklistNonConformitiesArgs = {
  filter?: InputMaybe<ChecklistNonConformitiesFilter>;
};

export type QueryChecklistNonConformityArgs = {
  id: Scalars['ID']['input'];
};

export type QueryChecklistNonConformitySummaryArgs = {
  filter?: InputMaybe<ChecklistNonConformitiesFilter>;
};

export type QueryChecklistsNamesArgs = {
  input?: InputMaybe<GetChecklistsNames>;
};

export type QueryCoachingFeedbackArgs = {
  input?: InputMaybe<CoachingFeedbackInput>;
};

export type QueryCoachingFeedbackDetailsArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCompanyOnboardingStatusArgs = {
  fleetId: Scalars['String']['input'];
};

export type QueryCompletedChecklistsArgs = {
  input?: InputMaybe<GetCompletedChecklists>;
};

export type QueryConferenceTransactionByIdArgs = {
  input: Scalars['ID']['input'];
};

export type QueryContractsArgs = {
  fleetId: Scalars['String']['input'];
};

export type QueryCustomDashboardArgs = {
  input: Scalars['String']['input'];
};

export type QueryDeviceConfigurationArgs = {
  input: Scalars['String']['input'];
};

export type QueryDevicesArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryDevolutionTicketsByDeviceIdArgs = {
  cobliId?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDriverByIdArgs = {
  input?: InputMaybe<WantedDriverId>;
};

export type QueryDriverFaceClustersInfoArgs = {
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fromTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  hasBeenNominated?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  samplesPerCluster?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withoutSampleImageUrls?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryDriverFaceClustersSuggestionsArgs = {
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryDriverFaceIdRegistrationsArgs = {
  driverIds: Array<Scalars['ID']['input']>;
};

export type QueryDriverSpeedRowArgs = {
  input: DriverSpeedRowInput;
};

export type QueryDriversByIdArgs = {
  input?: InputMaybe<WantedDrivers>;
};

export type QueryDriversCountArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryDriversWithCompleteFaceIdRegistrationCountArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryEventsSeveritiesSummaryArgs = {
  descriptionTextQuery?: InputMaybe<Scalars['String']['input']>;
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  eventTriggers?: InputMaybe<Array<InputMaybe<EventTrigger>>>;
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  mediaStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  safetyOccurrenceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  suggestedOccurrences?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type QueryExpensesArgs = {
  input: ExpensesListInput;
};

export type QueryFaceIdCoverageChartArgs = {
  fromTimestamp: Scalars['Float']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone: Scalars['String']['input'];
  toTimestamp: Scalars['Float']['input'];
};

export type QueryFaceImageGeolocationArgs = {
  imageId: Scalars['ID']['input'];
};

export type QueryFleetArgs = {
  fleetId: Scalars['String']['input'];
};

export type QueryFleetAudioMessagePlaybacksArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleId: Scalars['ID']['input'];
};

export type QueryFleetDevicesParameterStatusArgs = {
  parameterName: Scalars['String']['input'];
};

export type QueryFleetDevicesParameterValuesArgs = {
  parameterName: Scalars['String']['input'];
};

export type QueryFleetGeofenceRecommendationsArgs = {
  fleetId: Scalars['ID']['input'];
};

export type QueryFleetGroupRecommendationsArgs = {
  fleetId: Scalars['ID']['input'];
};

export type QueryFleetUsersArgs = {
  fleetId: Scalars['String']['input'];
};

export type QueryFleetVehicleGroupsArgs = {
  fleetId: Scalars['String']['input'];
};

export type QueryFuelCardAssociationsArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFuelTransactionByIdArgs = {
  input: Scalars['ID']['input'];
};

export type QueryFuelTransactionStatsByVehicleSummaryArgs = {
  input: GetFuelTransactionsSummaryInput;
};

export type QueryFuelTransactionsSummaryArgs = {
  input: GetFuelTransactionsSummaryInput;
};

export type QueryGetAudioFileArgs = {
  playbackId: Scalars['ID']['input'];
};

export type QueryHasFaceIdIdentificationHistoryArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryHomeProductivitySummaryArgs = {
  end_date: Scalars['String']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  start_date: Scalars['String']['input'];
  tz: Scalars['String']['input'];
};

export type QueryHomeSpeedSummaryArgs = {
  begin: Scalars['Float']['input'];
  end: Scalars['Float']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  interval_in_days: Scalars['Int']['input'];
  tz: Scalars['String']['input'];
};

export type QueryHomeSummaryVehiclesArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryInsightsArgs = {
  input: GetInsightInput;
};

export type QueryInviteInfoArgs = {
  token: Scalars['String']['input'];
};

export type QueryLastAssociationArgs = {
  deviceId: Scalars['String']['input'];
};

export type QueryLastPathArgs = {
  input: LastPathInput;
};

export type QueryLatestMaintenanceByVehicleArgs = {
  input: GetLatestMaintenanceInput;
};

export type QueryMaintenanceHistoryArgs = {
  input: GetMaintenanceHistoryInput;
};

export type QueryMaintenancePartsArgs = {
  input?: InputMaybe<GetMaintenancePartsInput>;
};

export type QueryMediaArgs = {
  aiVideoTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  archived?: InputMaybe<ArchivedMediaFilter>;
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  descriptionTextQuery?: InputMaybe<Scalars['String']['input']>;
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverFaceClusterIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  eventTriggers?: InputMaybe<Array<InputMaybe<EventTrigger>>>;
  footageStatusesToCount?: InputMaybe<Array<InputMaybe<RequestedMediaStatus>>>;
  fromCreatedAtTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  isRequestedByTrigger?: InputMaybe<Scalars['Boolean']['input']>;
  mediaStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaTypes?: InputMaybe<Array<InputMaybe<MediaType>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  requestOrigins?: InputMaybe<Array<InputMaybe<RequestOrigin>>>;
  requestStatus?: InputMaybe<Array<InputMaybe<MediaRequestStatus>>>;
  safetyOccurrenceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  severities?: InputMaybe<Array<InputMaybe<Severity>>>;
  severitiesToCount?: InputMaybe<Array<InputMaybe<Severity>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  suggestedOccurrences?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toCreatedAtTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  triggerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type QueryMediaDailyRecommendationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type QueryMediaViewArgs = {
  mediaId?: InputMaybe<Scalars['ID']['input']>;
  shouldGenerateDescription?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryOperationSummaryArgs = {
  input: OperationSummaryInput;
};

export type QueryOperationalSituationsArgs = {
  filter?: InputMaybe<OperationalSituationsFilter>;
};

export type QueryOrderByIdArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPagedFuelTransactionStatsByVehicleArgs = {
  input: GetPagedFuelTransactionsInput;
};

export type QueryPagedFuelTransactionsArgs = {
  input: GetPagedFuelTransactionsInput;
};

export type QueryPaginatedVehiclesV1Args = {
  input: PaginatedVehiclesV1Input;
};

export type QueryPathsArgs = {
  associationMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endTime: Scalars['Float']['input'];
  startTime: Scalars['Float']['input'];
  tz: Scalars['String']['input'];
  vehicleId: Scalars['ID']['input'];
};

export type QueryProofsOfConclusionArgs = {
  activityId?: InputMaybe<Scalars['ID']['input']>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<DateRange>;
};

export type QueryReminderListArgs = {
  input: GetReminderListInput;
};

export type QueryReminderStatusSummaryArgs = {
  input: GetReminderStatusCountInput;
};

export type QueryRiskEventsArgs = {
  input: RiskEventsInput;
};

export type QueryRouteArgs = {
  input: Scalars['ID']['input'];
};

export type QueryRoutesArgs = {
  input?: InputMaybe<ListRoutesInput>;
};

export type QueryRoutesReportArgs = {
  input: DateRange;
};

export type QueryRoutesV2Args = {
  input?: InputMaybe<ListRoutesInputV2>;
};

export type QueryRunningWithoutDriverVehiclesArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  timezone: Scalars['String']['input'];
};

export type QuerySafetyRankingParamsArgs = {
  input: SafetyRankingParamsInput;
};

export type QuerySafetyRankingProductivityArgs = {
  input: SafetyRankingInput;
};

export type QuerySafetyRankingScoresArgs = {
  input: SafetyRankingInput;
};

export type QuerySafetyReviewHistoryArgs = {
  mediaId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuerySumTotalCostByFuelTypeArgs = {
  input: GetFuelTransactionSummaryByPeriodTypeInput;
};

export type QueryTemplateChecklistsArgs = {
  input?: InputMaybe<GetTemplateChecklists>;
};

export type QueryTokensArgs = {
  input?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryTokensV2Args = {
  input?: InputMaybe<IdentificationTokenFilters>;
};

export type QueryTrackingArgs = {
  input?: InputMaybe<TrackingInput>;
};

export type QueryTripArgs = {
  deviceId: Scalars['String']['input'];
  footageAvailabilityStatus?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
};

export type QueryTripImageArgs = {
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  driverVisibilities?: InputMaybe<Array<InputMaybe<DriverVisibility>>>;
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  identificationMethod?: InputMaybe<Array<InputMaybe<IdentificationMethod>>>;
  isObstructed?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type QueryTripImagesDetailsArgs = {
  tripId: Scalars['String']['input'];
};

export type QueryTripPeriodicImagesArgs = {
  channels?: InputMaybe<Array<InputMaybe<PeriodicImageChannel>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tripId: Scalars['String']['input'];
};

export type QueryTripsByVehicleArgs = {
  footageAvailabilityStatus?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  vehicleId: Scalars['ID']['input'];
};

export type QueryUnnamedFaceClustersCountArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryUserAttributesArgs = {
  input?: InputMaybe<UserInput>;
};

export type QueryUserDefaultRolesArgs = {
  input?: InputMaybe<UserInput>;
};

export type QueryUserFleetsArgs = {
  input?: InputMaybe<UserInput>;
};

export type QueryUserPreferencesArgs = {
  input?: InputMaybe<UserInput>;
};

export type QueryValidateExpensesImportArgs = {
  input: ValidateExpensesImportInput;
};

export type QueryValidateFuelTransactionsImportArgs = {
  input: ValidateFuelTransactionsImportInput;
};

export type QueryValidateMaintenanceImportArgs = {
  input: ValidateMaintenanceImportInput;
};

export type QueryVehicleArgs = {
  id: Scalars['ID']['input'];
};

export type QueryVehicleDeviceAssociationReportByDeviceArgs = {
  input: VehicleDeviceAssociationInfoInput;
};

export type QueryVehicleDeviceAssociationReportByVehicleArgs = {
  input: VehicleDeviceAssociationInfoInput;
};

export type QueryVehicleDriverAuthorizationsArgs = {
  vehicleId: Scalars['ID']['input'];
};

export type QueryVehicleExpensesArgs = {
  input: VehiclesExpensesInput;
};

export type QueryVehicleGroupsArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryVehiclePastAssociationsArgs = {
  referenceTimestamp: Scalars['String']['input'];
  vehicleId: Scalars['ID']['input'];
};

export type QueryVehicleSuggestionsBatchArgs = {
  input: BatchSuggestionInput;
};

export type QueryVehicleTimestampImagesDetailsArgs = {
  image_timestamp: Scalars['Float']['input'];
  images_before: Scalars['Int']['input'];
  vehicle_id: Scalars['String']['input'];
};

export type QueryVehicleTrackingArgs = {
  input?: InputMaybe<VehicleTrackingInput>;
};

export type QueryVehicleTrackingSegmentArgs = {
  input: VehicleTrackingSegmentInput;
};

export type QueryVehicleTripDistanceArgs = {
  input: VehicleTripDistanceInput;
};

export type QueryVehiclesArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryVehiclesRunningWithoutDriverCountArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone: Scalars['String']['input'];
};

export type RecommendationActionResult = {
  completedBy?: Maybe<Scalars['ID']['output']>;
  dismissedAt?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  fleetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type RecordingResolution = 'HD' | 'NHD';

export type Recurrence = {
  description?: Maybe<Scalars['String']['output']>;
  everyDays?: Maybe<Scalars['Int']['output']>;
  everyKms?: Maybe<Scalars['Int']['output']>;
};

export type RecurrencyFrequency = 'DAILY' | 'MONTHLY' | 'NONE' | 'WEEKLY';

export type ReminderDto = {
  description?: Maybe<Scalars['String']['output']>;
  fleetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lastMaintenanceDate?: Maybe<Scalars['DateTime']['output']>;
  nextOccurrenceDate?: Maybe<Scalars['DateTime']['output']>;
  nextOccurrenceInKm?: Maybe<Scalars['Float']['output']>;
  recurrenceInDays?: Maybe<Scalars['Int']['output']>;
  recurrenceInKm?: Maybe<Scalars['Int']['output']>;
  status: MaintenanceStatus;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vehicle: VehicleDto;
};

export type ReminderStatusCount = {
  delayed?: Maybe<Scalars['Int']['output']>;
  onTime?: Maybe<Scalars['Int']['output']>;
  warning?: Maybe<Scalars['Int']['output']>;
};

export type ReminderTitle = {
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type ReminderTitleInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ReopenConferenceReviewInput = {
  transactionId: Scalars['ID']['input'];
};

/** How a footage request was originated. */
export type RequestOrigin =
  /** Requested by the alert rule itself, with no person involved. */
  | 'AUTOMATIC_ALERT'
  /** Requested by a person through the video flow. */
  | 'MANUAL'
  /** Requested by a person from an alert occurrence. */
  | 'MANUAL_ALERT';

export type RequestedMediaStatus = 'ACKNOWLEDGE' | 'CANCELED' | 'CORRUPTED' | 'FAILED' | 'FINISHED' | 'PENDING' | 'STARTED' | 'UNAVAILABLE';

export type Return = ITicket & {
  addressInformation?: Maybe<AddressInformation>;
  arrivalOfDevicesAtCobli?: Maybe<Scalars['String']['output']>;
  associatedDealId?: Maybe<Scalars['String']['output']>;
  clientCNPJ?: Maybe<Scalars['String']['output']>;
  clientInformation?: Maybe<ClientInformation>;
  closedDate?: Maybe<Scalars['TimestampInMillis']['output']>;
  coblerInformation?: Maybe<CoblerInformation>;
  contactInformation?: Maybe<ContactInformation>;
  createdAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  dateInformation?: Maybe<DateInformation>;
  deadline?: Maybe<Scalars['TimestampInMillis']['output']>;
  deletedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  deviceCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceTotalQuantity?: Maybe<DeviceTotalQuantity>;
  fieldControlInformation?: Maybe<FieldControlInformation>;
  fleetId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  penaltyPrice?: Maybe<Scalars['Float']['output']>;
  pipeline?: Maybe<Scalars['String']['output']>;
  postingDate?: Maybe<Scalars['String']['output']>;
  responsibleUser?: Maybe<User>;
  returnType?: Maybe<Scalars['String']['output']>;
  scheduleDate?: Maybe<Scalars['String']['output']>;
  shippingCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  vehicleInformation?: Maybe<VehicleInformation>;
};

export type RiskEvent = {
  coordinates: Coordinate;
  device: RiskEventDevice;
  driver: RiskEventDriver;
  media?: Maybe<Media>;
  timestamp: Scalars['DateTime']['output'];
  type: RiskEventType;
};

export type RiskEventMediaArgs = {
  input: RiskEventsInput;
};

export type RiskEventDevice = {
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type RiskEventDriver = {
  id: Scalars['ID']['output'];
};

export type RiskEventType =
  | 'ANOMALY'
  | 'DISTRACTED_DRIVING'
  | 'HARSH_ACCELERATION'
  | 'HARSH_BREAKING'
  | 'HARSH_CORNERING'
  | 'LANE_DRIFT'
  | 'STOP_SIGN_VIOLATED'
  | 'TAILGATING'
  | 'TRAFFIC_SPEED_VIOLATED'
  | 'UNKNOWN';

export type RiskEventsInput = {
  driver_id: Scalars['ID']['input'];
  end: Scalars['TimestampInMillis']['input'];
  media_types?: InputMaybe<Array<MediaType>>;
  severities?: InputMaybe<Array<Severity>>;
  start: Scalars['TimestampInMillis']['input'];
  triggers?: InputMaybe<Array<EventTrigger>>;
};

export type RoadSpeedLimitAlert = UserAlert & {
  driver?: Maybe<Driver>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  duration_in_millis?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  processed_at: Scalars['Float']['output'];
  severity?: Maybe<Severity>;
  speed_in_km_h?: Maybe<Scalars['Int']['output']>;
  speed_limit_in_km_h?: Maybe<Scalars['Int']['output']>;
  type: UserNotificationSettingsType;
  vehicle_group_id?: Maybe<Scalars['ID']['output']>;
  vehicle_id: Scalars['ID']['output'];
};

export type RoadSpeedLimitSettings = {
  duration_above_limit_in_millis: Scalars['Int']['output'];
  severity: Severity;
  vehicle_group_ids: Array<Maybe<Scalars['ID']['output']>>;
};

export type Route = {
  activities: Array<Activity>;
  break?: Maybe<RouteBreak>;
  created_at: Scalars['TimestampInMillis']['output'];
  device_id?: Maybe<Scalars['String']['output']>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  driver_name?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  executed_end_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  executed_start_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  planned_distance_in_meters: Scalars['Int']['output'];
  planned_duration: Scalars['TimeIntervalInMillis']['output'];
  points: Array<Coordinate>;
  propagation_type?: Maybe<PropagationType>;
  recurrency?: Maybe<RouteRecurrency>;
  settings?: Maybe<RouteSettings>;
  shared_id?: Maybe<Scalars['ID']['output']>;
  start_time: Scalars['TimestampInMillis']['output'];
  status: RouteStatus;
  type: RouteType;
  updated_at: Scalars['TimestampInMillis']['output'];
  vehicle_id?: Maybe<Scalars['ID']['output']>;
};

export type RouteBreak = {
  duration: Scalars['TimeIntervalInMillis']['output'];
  end_time: Scalars['TimestampInMillis']['output'];
  start_time: Scalars['TimestampInMillis']['output'];
};

export type RouteBreakInput = {
  duration: Scalars['TimeIntervalInMillis']['input'];
  end_time: Scalars['TimestampInMillis']['input'];
  start_time: Scalars['TimestampInMillis']['input'];
};

export type RouteRecurrency = {
  days_of_month?: Maybe<Array<Scalars['Int']['output']>>;
  days_of_week?: Maybe<Array<Scalars['Int']['output']>>;
  frequency: RecurrencyFrequency;
  id?: Maybe<Scalars['ID']['output']>;
  repeat_interval: Scalars['Int']['output'];
  until_date?: Maybe<Scalars['TimestampInMillis']['output']>;
  week_numbers?: Maybe<Array<Scalars['Int']['output']>>;
};

export type RouteRecurrencyUpdate = {
  days_of_month?: InputMaybe<Array<Scalars['Int']['input']>>;
  days_of_week?: InputMaybe<Array<Scalars['Int']['input']>>;
  frequency: RecurrencyFrequency;
  id?: InputMaybe<Scalars['ID']['input']>;
  repeat_interval: Scalars['Int']['input'];
  until_date?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  week_numbers?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RouteReport = {
  activities: Array<ActivityReport>;
  distance?: Maybe<PlannedVsExecutedInt>;
  driver?: Maybe<Driver>;
  duration?: Maybe<PlannedVsExecutedDurationTimeInMillis>;
  end_time?: Maybe<PlannedVsExecutedTimestampInMillis>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<PlannedVsExecutedTimestampInMillis>;
  status?: Maybe<RouteStatus>;
  vehicle?: Maybe<VehicleDto>;
};

export type RouteSettings = {
  break_window?: Maybe<RouteBreak>;
  objectives: Array<RoutingObjective>;
  routing_type: RouteType;
  vehicle_average_cargo_capacity?: Maybe<Scalars['Int']['output']>;
  working_hours: WorkingHours;
};

export type RouteSettingsInput = {
  break_window?: InputMaybe<RouteBreakInput>;
  objectives: Array<RoutingObjective>;
  routing_type: RouteType;
  vehicle_average_cargo_capacity?: InputMaybe<Scalars['Int']['input']>;
  working_hours: WorkingHoursInput;
};

export type RouteStartOrEndInput = {
  id: Scalars['ID']['input'];
  time: Scalars['Long']['input'];
};

export type RouteStatus = 'DELAYED' | 'EXECUTED' | 'IN_PROGRESS' | 'PARTIALLY_EXECUTED' | 'PLANNED' | 'UNEXECUTED';

export type RouteType = 'MANUAL' | 'OPTIMIZED';

export type RouteUpdate = {
  activities?: InputMaybe<Array<InputMaybe<ActivityUpdate>>>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  driver_id?: InputMaybe<Scalars['ID']['input']>;
  driver_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  propagation_type?: InputMaybe<PropagationType>;
  recurrency?: InputMaybe<RouteRecurrencyUpdate>;
  settings?: InputMaybe<RouteSettingsInput>;
  vehicle_id?: InputMaybe<Scalars['ID']['input']>;
};

export type RoutesSummary = {
  routes_with_vehicle: ExecutionDigestSummary;
  routes_without_vehicle: ExecutionDigestSummary;
  total: Scalars['Int']['output'];
};

export type RoutingObjective = 'MIN_COMPLETION_TIME' | 'MIN_TRANSPORT_TIME' | 'MIN_VEHICLES';

export type RoutingOptimization = {
  break?: InputMaybe<RouteBreakInput>;
  end_route_destination?: InputMaybe<DestinationInput>;
  num_vehicles: Scalars['Int']['input'];
  objectives?: InputMaybe<Array<RoutingObjective>>;
  vehicle_average_cargo_capacity?: InputMaybe<Scalars['Int']['input']>;
  working_hours: WorkingHoursInput;
};

export type RoutingSettings = {
  activities: Array<InputActivity>;
  optimization?: InputMaybe<RoutingOptimization>;
  start_time: Scalars['TimestampInMillis']['input'];
  type: RouteType;
};

export type RuleCategory = 'DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD' | 'GEOFENCE' | 'IDLE_ENGINE';

export type RuleEvaluationResponse = {
  evaluatedAt: Scalars['TimestampInMillis']['output'];
  evidence?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['ID']['output'];
  result: Scalars['String']['output'];
  ruleCode: Scalars['String']['output'];
  ruleVersion: Scalars['Int']['output'];
  severity?: Maybe<Scalars['String']['output']>;
};

export type RuleMode = 'BACKGROUND_POLICY' | 'FLEET_POLICY';

export type RunningWithoutDriverPageInfo = {
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type RunningWithoutDriverVehicle = {
  totalTripCount: Scalars['Int']['output'];
  unassignedTripCount: Scalars['Int']['output'];
  unnamedClusters: Array<UnnamedFaceCluster>;
  vehicle?: Maybe<VehicleDto>;
};

export type SafetyOccurrence = {
  /** Safety occurrence ID */
  id: Scalars['ID']['output'];
  /** Safety occurrence name */
  name: Scalars['String']['output'];
};

export type SafetyRankingInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  timezone: Scalars['String']['input'];
};

export type SafetyRankingParams = {
  cameraCorrectionWeights: SafetyRankingParamsValues;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  params: SafetyRankingParamsValues;
  telemetryCorrectionWeights: SafetyRankingParamsValues;
  user?: Maybe<FleetUser>;
};

export type SafetyRankingParamsInput = {
  referenceDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SafetyRankingParamsValues = {
  distractedDriving?: Maybe<Scalars['Float']['output']>;
  eyesClosed?: Maybe<Scalars['Float']['output']>;
  fastAcceleration?: Maybe<Scalars['Float']['output']>;
  hardBreak?: Maybe<Scalars['Float']['output']>;
  ignoreDismissedEvents?: Maybe<Scalars['Boolean']['output']>;
  minDistanceInKm?: Maybe<Scalars['Int']['output']>;
  phoneUsage?: Maybe<Scalars['Float']['output']>;
  roadSpeedLimit?: Maybe<Scalars['Float']['output']>;
  smoking?: Maybe<Scalars['Float']['output']>;
  speedyTurn?: Maybe<Scalars['Float']['output']>;
  tailgating?: Maybe<Scalars['Float']['output']>;
  vehicleSpeedLimit?: Maybe<Scalars['Float']['output']>;
  yawn?: Maybe<Scalars['Float']['output']>;
};

export type SafetyRankingProductType = {
  productType: Scalars['String']['output'];
};

export type SafetyRankingProductivity = {
  averageKmPerVehicle: Scalars['Float']['output'];
};

export type SafetyRankingScoreDetail = {
  discount: Scalars['Float']['output'];
  eventType: Scalars['String']['output'];
  frequency: Scalars['Float']['output'];
  occurrences: Scalars['Int']['output'];
};

export type SafetyRankingScoreRow = {
  drivenDistanceInKm: Scalars['Int']['output'];
  drivenTimeInMinutes: Scalars['Int']['output'];
  kmsPerEvent?: Maybe<Scalars['Float']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  scoreDetail: Array<SafetyRankingScoreDetail>;
  totalEventsCount?: Maybe<Scalars['Int']['output']>;
  variation?: Maybe<Scalars['Int']['output']>;
};

export type SafetyRankingScores = {
  averageFleetScore?: Maybe<Scalars['Int']['output']>;
  classifiedCount: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  lastRankUpdate?: Maybe<Scalars['DateTime']['output']>;
  rows: Array<SafetyRankingScoreRow>;
  unclassifiedCount: Scalars['Int']['output'];
};

export type SafetyReview = {
  /** Datetime the video was archived. Null when it is not archived */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the User that archived the video. Null when it is not archived */
  archivedById?: Maybe<Scalars['ID']['output']>;
  /** Name of the User that archived the video. Null when it is not archived */
  archivedByName?: Maybe<Scalars['String']['output']>;
  /** Where the video was archived from. Null when it is not archived */
  archivedOrigin?: Maybe<SafetyReviewOrigin>;
  /** Datetime of review creation */
  created_at: Scalars['String']['output'];
  /** ID of the User that first reviewed */
  created_by: Scalars['ID']['output'];
  /** Indicates the reason for dismissal */
  dismiss_reason?: Maybe<Scalars['String']['output']>;
  /** Cobli driver associated with review. */
  driver?: Maybe<Driver>;
  /** Driver ID associated with review */
  driver_id?: Maybe<Scalars['ID']['output']>;
  /**
   * Name of the driver associated with review
   * @deprecated Use `driver` field instead
   */
  driver_name?: Maybe<Scalars['String']['output']>;
  /** Fleet ID */
  fleet_id: Scalars['ID']['output'];
  /** Safety review ID */
  id: Scalars['ID']['output'];
  /** Safety occurrences associated with review */
  occurrences?: Maybe<Array<Maybe<SafetyOccurrence>>>;
  /** First Driver ID associated before review */
  original_media_driver_id?: Maybe<Scalars['ID']['output']>;
  /** First Severity associated before review */
  original_media_severity?: Maybe<Scalars['String']['output']>;
  /** reviewed Severity */
  severity?: Maybe<Scalars['String']['output']>;
  /** Current safety review status */
  status?: Maybe<Scalars['String']['output']>;
  /** Datetime of review last update */
  updated_at: Scalars['String']['output'];
  /** ID of the User that last updated */
  updated_by: Scalars['ID']['output'];
  /** User that last updated */
  updated_by_user?: Maybe<FleetUser>;
};

export type SafetyReviewHistory = {
  /** What the record registers. Null on records written before it existed */
  action?: Maybe<SafetyReviewHistoryAction>;
  /** Datetime of the History record creation */
  created_at: Scalars['String']['output'];
  /** ID of the History record */
  id: Scalars['ID']['output'];
  /** Where the change came from. Null on records written before it existed */
  origin?: Maybe<SafetyReviewOrigin>;
  /** Safety Review entity snapshot */
  snapshot: SafetyReviewSnapshot;
  /** User who created the record */
  user?: Maybe<FleetUser>;
  /** ID of the User who created the record */
  user_id: Scalars['ID']['output'];
};

/** What a review history record registers */
export type SafetyReviewHistoryAction = 'ARCHIVED' | 'CREATED' | 'UNARCHIVED' | 'UPDATED';

export type SafetyReviewHistoryPage = {
  content?: Maybe<Array<Maybe<SafetyReviewHistory>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

/** Where a review change came from */
export type SafetyReviewOrigin = 'API' | 'PANEL';

export type SafetyReviewSnapshot = {
  /** Indicates the reason for dismissal */
  dismiss_reason?: Maybe<Scalars['String']['output']>;
  /** Driver associated at the snapshot time */
  driver?: Maybe<Driver>;
  /** Driver ID associated at the snapshot time */
  driver_id?: Maybe<Scalars['ID']['output']>;
  /** Safety Occurrences at the snapshot time */
  occurrences?: Maybe<Array<Maybe<SafetyOccurrence>>>;
  /** Severity at the snapshot time */
  severity?: Maybe<Scalars['String']['output']>;
  /** Review status at the snapshot time */
  status?: Maybe<Scalars['String']['output']>;
};

export type SampleImageDto = {
  /** Date and time when the image was captured. */
  captured_at: Scalars['DateTime']['output'];
  /** Identifier of the captured face image. UUID */
  image_id: Scalars['ID']['output'];
  /** An URL for the captured image. */
  image_url: Scalars['String']['output'];
  /** Vehicle where the image was captured. */
  vehicle?: Maybe<VehicleDto>;
};

export type Scheduling = ITicket & {
  addressInformation?: Maybe<AddressInformation>;
  associatedDealId?: Maybe<Scalars['String']['output']>;
  clientInformation?: Maybe<ClientInformation>;
  closedDate?: Maybe<Scalars['TimestampInMillis']['output']>;
  coblerInformation?: Maybe<CoblerInformation>;
  contactInformation?: Maybe<ContactInformation>;
  createdAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  dateInformation?: Maybe<DateInformation>;
  deletedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  deviceCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceTotalQuantity?: Maybe<DeviceTotalQuantity>;
  fieldControlInformation?: Maybe<FieldControlInformation>;
  fleetId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  installedDate?: Maybe<Scalars['TimestampInMillis']['output']>;
  pipeline?: Maybe<Scalars['String']['output']>;
  scheduledDate?: Maybe<Scalars['TimestampInMillis']['output']>;
  scheduledTime?: Maybe<Scalars['TimestampInMillis']['output']>;
  schedulingSubCategory?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  vehicleInformation?: Maybe<VehicleInformation>;
};

export type SeatbeltDetection = {
  with_seatbelt?: Maybe<Scalars['Boolean']['output']>;
};

export type SelectContent = {
  options: Array<OptionContent>;
};

export type SendImageObstructionFeedback = {
  /** Image UUID identifier */
  image_id: Scalars['String']['input'];
  /** User given feedback class */
  obstruction_feedback: Scalars['String']['input'];
  /** Trip identifier */
  trip_id: Scalars['String']['input'];
};

export type SendInviteResponse = {
  invites?: Maybe<Array<Maybe<InviteResponse>>>;
  status: Scalars['String']['output'];
};

export type SendInvitesResponse = {
  invites?: Maybe<SendInviteResponse>;
};

export type Sensibility = 'DEFAULT' | 'MAXIMUM' | 'MINIMUM' | 'MODERATELY_HIGH' | 'MODERATELY_LOW';

export type SensibilityConfiguration = {
  enabled: Scalars['Boolean']['output'];
  sensibility: Sensibility;
};

export type SensibilityConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
  sensibility: Sensibility;
};

export type Servicos = {
  coAbanQtdDesinstalacaoInstaladoMotosOuMaquinariosCliente?: Maybe<Scalars['Int']['output']>;
  coAbanQtdDesinstalacaoInstaladoVeiculosLevesOuPesadosCliente?: Maybe<Scalars['Int']['output']>;
  coAbanQtdDesinstalacaoInstaladoVeiculosLevesOuPesadosCoblicam?: Maybe<Scalars['Int']['output']>;
  coAbanQtdDesinstalacaoRemovivelVeiculosPesados?: Maybe<Scalars['Int']['output']>;
  csAbanQtdDesinstalacao2130?: Maybe<Scalars['Int']['output']>;
  csAbanQtdDesinstalacao2630?: Maybe<Scalars['Int']['output']>;
  csAbanQtdDesinstalacao2630Bloqueador?: Maybe<Scalars['Int']['output']>;
  csAbanQtdDesinstalacao2630Ibutton?: Maybe<Scalars['Int']['output']>;
  csAbanQtdDesinstalacao3030?: Maybe<Scalars['Int']['output']>;
  quantidadeDesinstalacaoInstaladoLevesOuPesadosBuzzer?: Maybe<Scalars['Int']['output']>;
  quantidadeDesinstalacaoInstaladoLevesOuPesadosCameraFadiga?: Maybe<Scalars['Int']['output']>;
  quantidadeDesinstalacaoInstaladoLevesOuPesadosCameraFadigaPremium?: Maybe<Scalars['Int']['output']>;
  quantidadeDesinstalacaoRemovivelLevesOuPesadosBuzzer?: Maybe<Scalars['Int']['output']>;
  quantidadeDesinstalacaoRemovivelLevesOuPesadosIdentificador?: Maybe<Scalars['Int']['output']>;
  supplyDesinstalacaoCalculoTotal?: Maybe<Scalars['Int']['output']>;
};

export type SettingsJson = RoadSpeedLimitSettings | StopIdleTimeSettings | VehicleSpeedLimitSettings;

export type SettingsJsonInput = {
  /** ROAD SPEED LIMIT. VEHICLE SPEED LIMIT also uses the duration */
  duration_above_limit_in_millis?: InputMaybe<Scalars['Int']['input']>;
  /** STOP IDLE TIME */
  duration_idle_in_millis?: InputMaybe<Scalars['Int']['input']>;
  severity?: InputMaybe<Severity>;
  vehicle_group_ids: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type SeveritiesSummary = {
  high: Scalars['Int']['output'];
  higher: Scalars['Int']['output'];
  low: Scalars['Int']['output'];
  medium: Scalars['Int']['output'];
};

export type Severity = 'HIGH' | 'HIGHER' | 'LOW' | 'MEDIUM';

export type SeverityDetail = {
  id: Scalars['ID']['output'];
  /** List of identified risk factors */
  risk_factors?: Maybe<Array<Maybe<SeverityRiskFactor>>>;
  /** Severity level according to score */
  severity_level: Severity;
  /** Severity score */
  severity_score?: Maybe<Scalars['Int']['output']>;
};

export type SeverityRiskFactor = {
  /** Customized details for the risk kind */
  custom_details?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['ID']['output'];
  /** Identifier of the risk kind */
  type: Scalars['String']['output'];
  /** Risk factor multiplier value */
  value: Scalars['Float']['output'];
};

export type Shipping = ITicket & {
  addressInformation?: Maybe<AddressInformation>;
  associatedDealId?: Maybe<Scalars['String']['output']>;
  closedDate?: Maybe<Scalars['TimestampInMillis']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  deletedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  deviceCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceTotalQuantity?: Maybe<DeviceTotalQuantity>;
  devicesWithInstallation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  devicesWithoutInstallation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  estimatedTimeOfArrival?: Maybe<Scalars['String']['output']>;
  fleetId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pipeline?: Maybe<Scalars['String']['output']>;
  shippingCompany?: Maybe<Scalars['String']['output']>;
  shippingCompanyLink?: Maybe<Scalars['String']['output']>;
  shippingDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trackingCode?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ShippingInformation = {
  address?: Maybe<Scalars['String']['output']>;
  deviceInformation?: Maybe<DeviceShippingInformation>;
  estimatedReceivingDate?: Maybe<Scalars['String']['output']>;
  shippingCompany?: Maybe<Scalars['String']['output']>;
  shippingCompanyLink?: Maybe<Scalars['String']['output']>;
  trackingCode?: Maybe<Scalars['String']['output']>;
};

export type Sort = {
  column: Scalars['String']['input'];
  order: Order;
};

export type SortType = {
  empty?: Maybe<Scalars['Boolean']['output']>;
  sorted?: Maybe<Scalars['Boolean']['output']>;
  unsorted?: Maybe<Scalars['Boolean']['output']>;
};

export type SpeedEvent = {
  driverName?: Maybe<Scalars['String']['output']>;
  durationAboveInMillis?: Maybe<Scalars['Float']['output']>;
  eventTime: Scalars['Float']['output'];
  location: Location;
  medianBasedSeverity?: Maybe<Scalars['String']['output']>;
  medianSpeedInKmh?: Maybe<Scalars['Float']['output']>;
  severity: Scalars['String']['output'];
  speedInKmh: Scalars['Float']['output'];
  speedLimitInKmh: Scalars['Float']['output'];
  startTime?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type SpeedLimitUpdateInput = {
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['input'];
  /** The duty type of the vehicle. */
  duty_type?: InputMaybe<DutyType>;
  /** The desired speed limit */
  speed_limit_warning_in_kmph?: InputMaybe<Scalars['Float']['input']>;
};

export type SpreadsheetActivity = {
  additional_info?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<SpreadsheetDestination>;
  duration?: Maybe<Scalars['TimeIntervalInMillis']['output']>;
  load_size?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  start_hour?: Maybe<Scalars['String']['output']>;
  time_windows?: Maybe<Array<Maybe<SpreadsheetTimeWindow>>>;
};

export type SpreadsheetDestination = {
  city?: Maybe<Scalars['String']['output']>;
  coordinate: Coordinate;
  country?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_address?: Maybe<Scalars['String']['output']>;
  street_complement?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
};

export type SpreadsheetImportResultAddress = {
  activity?: Maybe<SpreadsheetActivity>;
  query_address: Scalars['String']['output'];
  /**
   * Values of this row that could not be interpreted. Null when the importer reported none, so a
   * caller must treat null and empty as the same thing: nothing was lost.
   */
  warnings?: Maybe<Array<SpreadsheetMappingWarning>>;
};

/**
 * A value the import could not interpret. Without it, the setting is dropped and the response is
 * indistinguishable from one where the customer never asked for it.
 */
export type SpreadsheetMappingWarning = {
  /** Which field of the row was not interpreted, e.g. `time_window`. */
  field: Scalars['String']['output'];
  /** The value exactly as it arrived, so the caller can point at the offending cell. */
  raw_value: Scalars['String']['output'];
};

export type SpreadsheetRow = {
  additional_info?: InputMaybe<Scalars['String']['input']>;
  address: Scalars['String']['input'];
  load_size?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  start_hour?: InputMaybe<Scalars['String']['input']>;
  time_window?: InputMaybe<Scalars['String']['input']>;
};

export type SpreadsheetTimeWindow = {
  earliest?: Maybe<Scalars['TimestampInMillis']['output']>;
  latest?: Maybe<Scalars['TimestampInMillis']['output']>;
};

export type StopIdleTimeAlert = UserAlert & {
  driver?: Maybe<Driver>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  duration_in_millis?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  processed_at: Scalars['Float']['output'];
  type: UserNotificationSettingsType;
  vehicle_group_id?: Maybe<Scalars['ID']['output']>;
  vehicle_id: Scalars['ID']['output'];
};

export type StopIdleTimeSettings = {
  duration_idle_in_millis: Scalars['Int']['output'];
  vehicle_group_ids: Array<Maybe<Scalars['ID']['output']>>;
};

export type Stops = {
  driverName?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['Float']['output'];
  geofences: Array<Maybe<Geofences>>;
  hasFilteredIdleOnTime?: Maybe<Scalars['Boolean']['output']>;
  idleOffInMillis: Scalars['Float']['output'];
  idleOnInMillis: Scalars['Float']['output'];
  location: Location;
  startTime: Scalars['Float']['output'];
};

export type SumTotalCostByFuelTypeResponse = {
  endInterval: Scalars['String']['output'];
  fuelType: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  startInterval: Scalars['String']['output'];
  totalCost: Scalars['Float']['output'];
};

export type Summary = {
  totalDistance: Scalars['Float']['output'];
  totalDuration: Scalars['Float']['output'];
  totalFuelCost: Scalars['Float']['output'];
  totalGeofenceEvents: Scalars['Int']['output'];
  totalSpeedEvents: Scalars['Int']['output'];
  totalStops: Scalars['Int']['output'];
};

export type Supplier = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TextContent = {
  value?: Maybe<Scalars['String']['output']>;
};

export type Ticket = {
  closedDate?: Maybe<Scalars['String']['output']>;
  conclusionDate?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['String']['output']>;
  devolutionInformation?: Maybe<DevolutionInformation>;
  id: Scalars['String']['output'];
  installationInformation?: Maybe<InstallationInformation>;
  lastActivityDate?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['String']['output']>;
  nextActivityDate?: Maybe<Scalars['String']['output']>;
  notesLastUpdated?: Maybe<Scalars['String']['output']>;
  notesNextActivityDate?: Maybe<Scalars['String']['output']>;
  originTicketId?: Maybe<Scalars['String']['output']>;
  panelFormTest?: Maybe<Scalars['Boolean']['output']>;
  pipeline?: Maybe<Scalars['String']['output']>;
  pipelineStage?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  resolution?: Maybe<Scalars['String']['output']>;
  servicos?: Maybe<Servicos>;
  shippingInformation?: Maybe<ShippingInformation>;
  sourceType?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  ticketAssociatedDealId?: Maybe<Scalars['String']['output']>;
};

export type Tickets = {
  tickets?: Maybe<Array<Ticket>>;
  total: Scalars['Int']['output'];
};

export type TimeWindow = {
  earliest: Scalars['TimestampInMillis']['output'];
  latest: Scalars['TimestampInMillis']['output'];
};

export type TimeWindowInput = {
  earliest: Scalars['TimestampInMillis']['input'];
  latest: Scalars['TimestampInMillis']['input'];
};

export type ToggleChecklistActive = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type TotalAndIdsReportSummary = {
  ids: Array<Scalars['ID']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Tracking = {
  device?: Maybe<DeviceFields>;
  deviceId?: Maybe<Scalars['String']['output']>;
  drivers: Array<Maybe<Driver>>;
  endTime: Scalars['TimestampInMillis']['output'];
  geofenceEvents?: Maybe<Array<Maybe<GeofenceEvent>>>;
  groupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  incidents?: Maybe<Array<Maybe<Incidents>>>;
  lastPath?: Maybe<LastPath>;
  pathGeojson: PathGeojson;
  roadSpeedEvents?: Maybe<Array<Maybe<SpeedEvent>>>;
  startTime: Scalars['TimestampInMillis']['output'];
  stops?: Maybe<Array<Maybe<Stops>>>;
  summary?: Maybe<Summary>;
  tz: Scalars['String']['output'];
  vehicle?: Maybe<VehicleFields>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
  vehicleSpeedEvents?: Maybe<Array<Maybe<SpeedEvent>>>;
};

export type TrackingInput = {
  device_id: Scalars['String']['input'];
  end_time: Scalars['Float']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  match?: InputMaybe<Scalars['Boolean']['input']>;
  start_time: Scalars['Float']['input'];
  tz: Scalars['String']['input'];
};

export type TrainingVideo = {
  categoryId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type TrainingVideoCategory = {
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TrainingVideos = {
  category?: Maybe<TrainingVideoCategory>;
  trainingVideos?: Maybe<Array<Maybe<TrainingVideo>>>;
};

export type Trigger = {
  active: Scalars['Boolean']['output'];
  allowNotifications: Scalars['Boolean']['output'];
  condition?: Maybe<TriggerCondition>;
  createdAt: Scalars['String']['output'];
  daysOfWeek: Array<Scalars['Int']['output']>;
  deviceIds: Array<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  event?: Maybe<TriggerEvent>;
  geofenceIds: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notifiedUsers: Array<Maybe<UserFleets>>;
  startTime: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<UserFleets>;
  vehicleGroupIds: Array<Scalars['ID']['output']>;
  vehicleIds: Array<Scalars['ID']['output']>;
};

export type TriggerCondition = {
  category: ConditionCategory;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  params: Array<Maybe<Scalars['String']['output']>>;
  rule: TriggerConditionRule;
};

export type TriggerConditionRule = {
  category: RuleCategory;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TriggerEvent = {
  nameIdentifier: Scalars['String']['output'];
};

export type TriggerListFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  conditionId?: InputMaybe<Scalars['ID']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  geofenceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  myNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requestVideo?: InputMaybe<Scalars['Boolean']['input']>;
  ruleCategory?: InputMaybe<RuleCategory>;
  ruleMode?: InputMaybe<RuleMode>;
  triggerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TriggerPage = {
  content?: Maybe<Array<Trigger>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type Trip = {
  /** Trip end Unix timestamp in millis. */
  end_timestamp: Scalars['TimestampInMillis']['output'];
  /** Whether the trip has stills to preview before requesting footage. */
  hasImages?: Maybe<Scalars['Boolean']['output']>;
  /** Identifier. */
  id?: Maybe<Scalars['String']['output']>;
  /** Flag indicating whether the trip is available for requesting or not. */
  is_footage_available: Scalars['Boolean']['output'];
  /** Trip start Unix timestamp in millis. */
  start_timestamp: Scalars['TimestampInMillis']['output'];
};

export type TripImage = {
  /** Whether the trip images were marked with a driver visible or not visible */
  driver_visibility?: Maybe<DriverVisibility>;
  /** Trip end Unix timestamp in millis. */
  end_timestamp: Scalars['TimestampInMillis']['output'];
  /** Identification method utilized at the time. */
  identification_method: Scalars['String']['output'];
  /** The timestamp that the user has nominated an image formatted as Unix timestamp in millis. */
  nominated_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  /** The user that nominated the trip. */
  nominated_by?: Maybe<User>;
  /** The driver recognized by the faceID. */
  recognized_driver?: Maybe<Driver>;
  /** Trip start Unix timestamp in millis. */
  start_timestamp: Scalars['TimestampInMillis']['output'];
  /** The id of the trip. */
  trip_id: Scalars['String']['output'];
  /** An image sample of the trip. */
  trip_image_sample?: Maybe<TripImageDetails>;
  /** List of images from the trip. It will only be filled when one single trip were selected. */
  trip_images?: Maybe<Array<Maybe<TripImageDetails>>>;
  /** The driver nominated by the user. */
  user_nominated_driver?: Maybe<Driver>;
  /** The id of the vehicle with the media. */
  vehicle: VehicleDto;
};

export type TripImageDetails = {
  id: Scalars['ID']['output'];
  image_url: Scalars['String']['output'];
  is_obstructed?: Maybe<Scalars['Boolean']['output']>;
  obstruction_feedback?: Maybe<Scalars['String']['output']>;
};

export type UninstallDeviceFromVehicleInput = {
  vehicleId: Scalars['ID']['input'];
};

export type UnnamedFaceCluster = {
  id: Scalars['ID']['output'];
  lastCapturedAt?: Maybe<Scalars['DateTime']['output']>;
  photoCount: Scalars['Int']['output'];
  thumbnailUrl: Scalars['String']['output'];
};

export type UpcomingTickets = {
  daysWithoutMovement?: Maybe<Scalars['Int']['output']>;
  hasUpsell?: Maybe<Scalars['Boolean']['output']>;
  nextBatchScheduledAt?: Maybe<Scalars['String']['output']>;
  tickets?: Maybe<Array<Maybe<ITicket>>>;
};

export type UpdateAssociationPayloadInput = {
  input: AssociationConfigInput;
};

export type UpdateAudioRequest = {
  /** The status of the camera audio. */
  audio_status: AudioStatus;
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['input'];
};

export type UpdateChecklist = {
  id: Scalars['ID']['input'];
  updatedChecklist: UpdatedChecklist;
};

export type UpdateContactTrainingInfoInput = {
  finishedVideos: Array<InputMaybe<VideoInfo>>;
  startedVideos: Array<InputMaybe<VideoInfo>>;
};

export type UpdateDeviceParameter = {
  device_id: Scalars['String']['input'];
  parameters: Array<ParameterInput>;
};

export type UpdateDeviceSpareStatusInput = {
  deviceId: Scalars['String']['input'];
  isSpare: Scalars['Boolean']['input'];
};

export type UpdateDriver = {
  cpf?: InputMaybe<Scalars['String']['input']>;
  driver_license?: InputMaybe<Scalars['String']['input']>;
  first_license_acquirement_date?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  license_category?: InputMaybe<Scalars['String']['input']>;
  license_expiration_date?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_image_base64?: InputMaybe<Scalars['String']['input']>;
  registry_id?: InputMaybe<Scalars['String']['input']>;
  remove_profile_image?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEventsConfigurationInput = {
  events_configuration: EventsConfigurationInput;
};

export type UpdateFleetVideoReviewConfigurationInput = {
  /** Dismissing an event video archives it instead */
  archiveInsteadOfDismiss: Scalars['Boolean']['input'];
};

export type UpdateFuelCardAssociationInput = {
  id: Scalars['ID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateFuelTransactionInput = {
  commodity: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  merchant?: InputMaybe<MerchantUpdateInput>;
  odometerInKms?: InputMaybe<Scalars['Float']['input']>;
  totalCost: Scalars['Float']['input'];
  transactionerName?: InputMaybe<Scalars['String']['input']>;
  units: Scalars['Float']['input'];
};

export type UpdateLoggedUserPhoneNumberInput = {
  /** E.164 sem o `+`, como o cadastro guarda: `5511900000000`. Nulo apaga o telefone. */
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type UpdateMaintenanceHistoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  parts?: InputMaybe<Array<InputMaybe<MaintenancePartInput>>>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateMaintenancePartsInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/**
 * Substitui o estado editável da situação. É PUT no fusca, não PATCH: o corpo carrega tudo o que é
 * editável, então omitir `endsAt` deixa a parada sem prazo e omitir `reason` limpa a justificativa —
 * que é o que torna possível remover uma data de retorno. Encerrar continua em endOperationalSituation.
 */
export type UpdateOperationalSituationInput = {
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Obrigatório: a substituição carrega o estado inteiro, não um delta. */
  startsAt: Scalars['DateTime']['input'];
};

export type UpdateParameterResponse = {
  device_id: Scalars['String']['output'];
  parameters: Array<Parameter>;
};

export type UpdateReminderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  recurrenceInDays?: InputMaybe<Scalars['Int']['input']>;
  recurrenceInKm?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title: ReminderTitleInput;
};

export type UpdateUserNotificationSettings = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  settings_json: SettingsJsonInput;
  type: UserNotificationSettingsType;
};

export type UpdateUserTrainingMediaInput = {
  action: UserTrainingMediaActionType;
  trainingMediaId: Scalars['ID']['input'];
};

export type UpdateVehicleImmobilizerInput = {
  driverIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  isImmobilizerEnabled: Scalars['Boolean']['input'];
  vehicleDriverAuthorizationMode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVehicleInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  driverId?: InputMaybe<Scalars['ID']['input']>;
  fuelConsumption?: InputMaybe<Scalars['Float']['input']>;
  fuelPrice?: InputMaybe<Scalars['Float']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  speedInKmh?: InputMaybe<Scalars['Float']['input']>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatedChecklist = {
  context?: InputMaybe<NewChecklistContext>;
  fields: Array<NewChecklistField>;
  name: Scalars['String']['input'];
  template_active?: InputMaybe<Scalars['Boolean']['input']>;
  vehicle_group_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicle_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  version: Scalars['Int']['input'];
};

export type UpsertVehicleFuelConsumptionGoalInput = {
  /** Meta de consumo em km/L. Aceita decimal (ex.: 8.6). */
  goal: Scalars['Float']['input'];
  vehicleId: Scalars['ID']['input'];
};

export type User = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserActivationTask = {
  category: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  finished: Scalars['Boolean']['output'];
  fleet_id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  step_id?: Maybe<Scalars['ID']['output']>;
  task_id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id: Scalars['ID']['output'];
};

export type UserActivationTaskInput = {
  finished: Scalars['Boolean']['input'];
  stepId: Scalars['ID']['input'];
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserAlert = {
  driver?: Maybe<Driver>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  processed_at: Scalars['Float']['output'];
  type: UserNotificationSettingsType;
  vehicle_group_id?: Maybe<Scalars['ID']['output']>;
  vehicle_id: Scalars['ID']['output'];
};

export type UserAttributes = {
  creation_date?: Maybe<Scalars['String']['output']>;
  num_devices?: Maybe<Scalars['Int']['output']>;
};

export type UserDefaultRoles = {
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserFleets = {
  active?: Maybe<Scalars['Boolean']['output']>;
  associated_at?: Maybe<Scalars['String']['output']>;
  fleet_id?: Maybe<Scalars['ID']['output']>;
  granted_permissions: Array<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<VehiclesGroup>>>;
  groups_restriction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  has_no_valid_groups: Scalars['Boolean']['output'];
  has_only_groups_with_no_vehicles: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  managers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type UserInput = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserNotificationSettings = {
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  settings_json: SettingsJson;
  type: UserNotificationSettingsType;
};

export type UserNotificationSettingsType = 'ROAD_SPEED_LIMIT' | 'STOP_IDLE_TIME' | 'VEHICLE_SPEED_LIMIT';

export type UserPreferences = {
  created_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  filtered_groups?: Maybe<Array<Maybe<VehiclesGroup>>>;
  fleet_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  use_vehicles_cluster?: Maybe<Scalars['Boolean']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
  vehicle_group_ids?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type UserTrainingMedia = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  trainingMediaId?: Maybe<Scalars['ID']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type UserTrainingMediaActionType = 'FINISH' | 'START';

export type ValidateExpensesImportInput = {
  columnMap: ExpensesImportColumnMap;
  data: Array<ValidateExpensesImportInputItem>;
  timeZone: Scalars['String']['input'];
};

export type ValidateExpensesImportInputItem = {
  categoryName: Scalars['String']['input'];
  licensePlate: Scalars['String']['input'];
  observation?: InputMaybe<Scalars['String']['input']>;
  occurredAt: Scalars['String']['input'];
  rowIndex: Scalars['Int']['input'];
  supplierName?: InputMaybe<Scalars['String']['input']>;
  totalCost: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ValidateExpensesImportItem = {
  categoryName: Scalars['String']['output'];
  licensePlate: Scalars['String']['output'];
  observation?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
  supplierName?: Maybe<Scalars['String']['output']>;
  totalCost: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ValidateExpensesImportResponse = {
  invalidRows: Array<ValidateExpensesInvalidRowsResponse>;
  validRows: Array<ValidateExpensesValidRowsResponse>;
};

export type ValidateExpensesInvalidRowsResponse = {
  data: ValidateExpensesImportItem;
  errors: Array<ValidationError>;
};

export type ValidateExpensesValidRowsResponse = {
  categoryId: Scalars['String']['output'];
  groupPath?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['String']['output'];
  supplierName?: Maybe<Scalars['String']['output']>;
  totalCost: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  vehicleId: Scalars['String']['output'];
};

export type ValidateFuelTransactionsImportInput = {
  columnMap: FuelTransactionsImportColumnMap;
  data: Array<ValidateFuelTransactionsImportInputItem>;
  timeZone: Scalars['String']['input'];
};

export type ValidateFuelTransactionsImportInputItem = {
  driverName?: InputMaybe<Scalars['String']['input']>;
  fuelType: Scalars['String']['input'];
  licensePlate: Scalars['String']['input'];
  merchantCity?: InputMaybe<Scalars['String']['input']>;
  merchantCnpj?: InputMaybe<Scalars['String']['input']>;
  merchantName?: InputMaybe<Scalars['String']['input']>;
  merchantState?: InputMaybe<Scalars['String']['input']>;
  odometer: Scalars['String']['input'];
  quantityInLiters: Scalars['String']['input'];
  rowIndex: Scalars['Int']['input'];
  totalCost: Scalars['String']['input'];
  transactionTime: Scalars['String']['input'];
};

export type ValidateFuelTransactionsImportItem = {
  driverName?: Maybe<Scalars['String']['output']>;
  fuelType: Scalars['String']['output'];
  licensePlate: Scalars['String']['output'];
  merchantCity?: Maybe<Scalars['String']['output']>;
  merchantCnpj?: Maybe<Scalars['String']['output']>;
  merchantName?: Maybe<Scalars['String']['output']>;
  merchantState?: Maybe<Scalars['String']['output']>;
  odometer: Scalars['String']['output'];
  quantityInLiters: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
  totalCost: Scalars['String']['output'];
  transactionTime: Scalars['String']['output'];
};

export type ValidateFuelTransactionsImportResponse = {
  invalidRows: Array<ValidateFuelTransactionsInvalidRowsResponse>;
  validRows: Array<ValidateFuelTransactionsValidRowsResponse>;
};

export type ValidateFuelTransactionsInvalidRowsResponse = {
  data: ValidateFuelTransactionsImportItem;
  errors: Array<ValidationError>;
};

export type ValidateFuelTransactionsValidRowsResponse = {
  driverName?: Maybe<Scalars['String']['output']>;
  fuelType: Scalars['String']['output'];
  licensePlate: Scalars['String']['output'];
  merchant?: Maybe<MerchantImportResponse>;
  odometerInKm: Scalars['Float']['output'];
  quantityInLiters: Scalars['Float']['output'];
  totalCost: Scalars['Float']['output'];
  transactionTime: Scalars['String']['output'];
};

export type ValidateImportVehicleRowDto = {
  fuelConsumption?: Maybe<Scalars['String']['output']>;
  fuelPrice?: Maybe<Scalars['String']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  rowIndex: Scalars['Int']['output'];
  size?: Maybe<Scalars['String']['output']>;
  speedLimitInKmh?: Maybe<Scalars['String']['output']>;
};

export type ValidateImportVehicleRowInput = {
  fuelConsumption?: InputMaybe<Scalars['String']['input']>;
  fuelPrice?: InputMaybe<Scalars['String']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  licensePlate: Scalars['String']['input'];
  rowIndex: Scalars['Int']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  speedLimitInKmh?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateImportVehicleSpreadsheetInput = {
  columnMap: Array<ColumnMapEntryInput>;
  data: Array<ValidateImportVehicleRowInput>;
};

export type ValidateImportVehicleSpreadsheetResponse = {
  invalidRows: Array<InvalidImportVehicleRowDto>;
  validRows: Array<ImportVehicleRowDto>;
};

export type ValidateMaintenanceAggregatedPart = {
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  rowIndex: Scalars['Int']['output'];
  serviceItemName?: Maybe<Scalars['String']['output']>;
  unitCost?: Maybe<Scalars['String']['output']>;
};

export type ValidateMaintenanceImportInput = {
  columnMap: MaintenanceImportColumnMap;
  data: Array<ValidateMaintenanceImportInputItem>;
  timeZone: Scalars['String']['input'];
};

export type ValidateMaintenanceImportInputItem = {
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  maintenanceObservations?: InputMaybe<Scalars['String']['input']>;
  occurrenceAt?: InputMaybe<Scalars['String']['input']>;
  odometerInKms?: InputMaybe<Scalars['String']['input']>;
  partName?: InputMaybe<Scalars['String']['input']>;
  partObservation?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  rowIndex: Scalars['Int']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  unitCost?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateMaintenanceImportResponse = {
  invalidRows: Array<ValidateMaintenanceInvalidRowsResponse>;
  validRows: Array<ValidateMaintenanceValidRowsResponse>;
};

export type ValidateMaintenanceInvalidPart = {
  partName?: Maybe<Scalars['String']['output']>;
  partObservation?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  unitCost?: Maybe<Scalars['String']['output']>;
};

export type ValidateMaintenanceInvalidRow = {
  items?: Maybe<Array<Maybe<ValidateMaintenanceAggregatedPart>>>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  maintenanceObservation?: Maybe<Scalars['String']['output']>;
  occurrenceAt?: Maybe<Scalars['String']['output']>;
  odometerInKms?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ValidateMaintenanceInvalidRowItem = {
  errors: Array<ValidationError>;
  itemsData: ValidateMaintenanceInvalidPart;
  rowIndex: Scalars['Int']['output'];
};

export type ValidateMaintenanceInvalidRowsResponse = {
  errors: Array<ValidationError>;
  items: Array<ValidateMaintenanceInvalidRowItem>;
  maintenanceData: ValidateMaintenanceInvalidRow;
};

export type ValidateMaintenancePart = {
  partName: Scalars['String']['output'];
  partObservation?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  unitCost: Scalars['Float']['output'];
};

export type ValidateMaintenanceValidRowsResponse = {
  maintenanceObservations?: Maybe<Scalars['String']['output']>;
  occurrenceAt: Scalars['DateTime']['output'];
  odometerInKms: Scalars['Float']['output'];
  parts: Array<ValidateMaintenancePart>;
  type: Array<Scalars['String']['output']>;
  vehicle: VehicleDto;
};

export type ValidationError = {
  column: ImportColumnMap;
  error: Scalars['String']['output'];
};

export type VehicleConsumptionGoal = {
  createdAt: Scalars['String']['output'];
  goal: Scalars['Float']['output'];
  source: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  vehicleId: Scalars['ID']['output'];
};

export type VehicleDto = {
  alias?: Maybe<Scalars['String']['output']>;
  branding?: Maybe<Branding>;
  cobliId?: Maybe<Scalars['String']['output']>;
  consumptionGoal?: Maybe<VehicleConsumptionGoal>;
  device?: Maybe<Device>;
  deviceType?: Maybe<Scalars['String']['output']>;
  disablerStatus?: Maybe<DisablerDto>;
  driver?: Maybe<VehicleDriverDto>;
  esn?: Maybe<Scalars['String']['output']>;
  fleetId: Scalars['String']['output'];
  fuel?: Maybe<FuelDto>;
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
  groupPath: Scalars['String']['output'];
  groups: Array<VehicleGroupDto>;
  id: Scalars['ID']['output'];
  immobilizerStatus?: Maybe<VehicleDriverAuthorizationStatus>;
  isAllowListEnabled?: Maybe<Scalars['Boolean']['output']>;
  isImmobilizerEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastLocation?: Maybe<VehicleLastLocationDto>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  model: VehicleModelDto;
  odometer?: Maybe<VehicleOdometer>;
  operationalSituation?: Maybe<OperationalSituation>;
  size?: Maybe<Scalars['String']['output']>;
  speedLimitInKmh?: Maybe<Scalars['Float']['output']>;
  tagId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<VehicleTag>>;
  vehicleDriverAuthorizationMode: Scalars['String']['output'];
};

export type VehicleDeviceAssociationInfo = {
  device?: Maybe<Device>;
  duration?: Maybe<Scalars['Int']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['String']['output']>;
  fleetId?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  vehicle?: Maybe<VehicleDto>;
};

export type VehicleDeviceAssociationInfoInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  wantedDeviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wantedEvents?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wantedGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wantedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * Mantém as linhas cujo veículo OU dispositivo tem uma dessas situações ativa no momento da
   * consulta — não na data do evento, que o fusca não sabe responder. O serviço de analytics não
   * conhece situação operacional, então este filtro é aplicado no janus; exige frota na sessão e
   * uma falha do fusca vira erro, nunca resultado sem filtro.
   */
  wantedSituations?: InputMaybe<Array<OperationalSituationType>>;
  wantedUsers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wantedVehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VehicleDeviceAssociationInfoResponse = {
  associations: Array<VehicleDeviceAssociationInfo>;
  count?: Maybe<Scalars['Int']['output']>;
};

export type VehicleDriverAuthorization = {
  authorizations?: Maybe<Array<DriverAuthorization>>;
  vehicle: VehicleDto;
};

export type VehicleDriverAuthorizationStatus = 'ACTIVE' | 'INACTIVE' | 'PROCESSING';

export type VehicleDriverDto = {
  active?: Maybe<Scalars['Boolean']['output']>;
  firstLicenseAcquirementDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  licenseCategory?: Maybe<Scalars['String']['output']>;
  licenseExpirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VehicleExpense = {
  categoryCosts: Array<CategoryCost>;
  costPerKm: Scalars['Float']['output'];
  distanceDrivenInKm: Scalars['Float']['output'];
  previousPeriodCostPerKm: Scalars['Float']['output'];
  previousPeriodTotalCost: Scalars['Float']['output'];
  totalCost: Scalars['Float']['output'];
  vehicle: ExpenseVehicle;
};

export type VehicleExpensesPaginatedResponse = {
  content: Array<VehicleExpense>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfElements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type VehicleFields = {
  alias?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
  fuelPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type VehicleFuelConsumptionGoalResponse = {
  createdAt: Scalars['String']['output'];
  goal: Scalars['Float']['output'];
  source: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  vehicle: VehicleDto;
};

export type VehicleGroupDto = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type VehicleImages = {
  images?: Maybe<Array<Maybe<TripImageDetails>>>;
  vehicle?: Maybe<VehicleDto>;
  vehicle_id?: Maybe<Scalars['String']['output']>;
};

export type VehicleInfo = {
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  plate: Scalars['String']['output'];
  vin: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type VehicleInformation = {
  licensePlates?: Maybe<Scalars['String']['output']>;
  models?: Maybe<Scalars['String']['output']>;
};

export type VehicleLastAssociation = {
  alias?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  fleetId: Scalars['ID']['output'];
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type VehicleLastLocationDto = {
  cobliIngestedAt?: Maybe<Scalars['Float']['output']>;
  isPlugged?: Maybe<Scalars['Boolean']['output']>;
  timeInMillis?: Maybe<Scalars['Float']['output']>;
};

export type VehicleModelDto = {
  brand?: Maybe<Scalars['String']['output']>;
  isSuggestion?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type VehicleOdometer = {
  createdAt: Scalars['TimestampInMillis']['output'];
  createdByUserName?: Maybe<Scalars['String']['output']>;
  createdOdometerInKm: Scalars['Long']['output'];
  odometerDateAt: Scalars['TimestampInMillis']['output'];
  odometerInKm: Scalars['Long']['output'];
  vehicleId: Scalars['ID']['output'];
};

export type VehiclePastAssociationDto = {
  associatedAt: Scalars['String']['output'];
  associatedBy?: Maybe<FleetUser>;
  driver?: Maybe<VehicleDriverDto>;
  identificationMethod?: Maybe<Scalars['String']['output']>;
};

export type VehicleSpeedLimitAlert = UserAlert & {
  driver?: Maybe<Driver>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  duration_in_millis?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  processed_at: Scalars['Float']['output'];
  speed_in_km_h?: Maybe<Scalars['Int']['output']>;
  speed_limit_in_km_h?: Maybe<Scalars['Int']['output']>;
  type: UserNotificationSettingsType;
  vehicle_group_id?: Maybe<Scalars['ID']['output']>;
  vehicle_id: Scalars['ID']['output'];
};

export type VehicleSpeedLimitSettings = {
  duration_above_limit_in_millis: Scalars['Int']['output'];
  vehicle_group_ids: Array<Maybe<Scalars['ID']['output']>>;
};

export type VehicleSuggestionEntry = {
  key: Scalars['String']['output'];
  value?: Maybe<VehicleInfo>;
};

export type VehicleTag = {
  name: Scalars['String']['output'];
};

export type VehicleTrackingInput = {
  end_time: Scalars['Float']['input'];
  match?: InputMaybe<Scalars['Boolean']['input']>;
  start_time: Scalars['Float']['input'];
  tz: Scalars['String']['input'];
  vehicle_id: Scalars['ID']['input'];
  with_jumps?: InputMaybe<Scalars['Boolean']['input']>;
  with_speed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VehicleTrackingSegmentInput = {
  allow_unfinished_step?: InputMaybe<Scalars['Boolean']['input']>;
  end_time: Scalars['Float']['input'];
  match?: InputMaybe<Scalars['Boolean']['input']>;
  segment_end: Scalars['Float']['input'];
  segment_start: Scalars['Float']['input'];
  start_time: Scalars['Float']['input'];
  tz: Scalars['String']['input'];
  vehicle_id: Scalars['ID']['input'];
};

export type VehicleTrackingSegmentType = {
  end_time: Scalars['Float']['output'];
  has_route_steps?: Maybe<Scalars['Boolean']['output']>;
  match?: Maybe<Scalars['Boolean']['output']>;
  mediaEvents?: Maybe<Array<Maybe<Media>>>;
  start_time: Scalars['Float']['output'];
  tracking?: Maybe<Tracking>;
  tz: Scalars['String']['output'];
  vehicle_id: Scalars['ID']['output'];
};

export type VehicleTrackingSegmentTypeMediaEventsArgs = {
  event_triggers?: InputMaybe<Array<InputMaybe<EventTrigger>>>;
  media_types?: InputMaybe<Array<InputMaybe<MediaType>>>;
};

export type VehicleTripDistance = {
  distance_driven_in_meters: Scalars['Float']['output'];
  vehicle_id: Scalars['ID']['output'];
};

export type VehicleTripDistanceInput = {
  begin: Scalars['TimestampInMillis']['input'];
  end: Scalars['TimestampInMillis']['input'];
  timezone: Scalars['String']['input'];
  vehicleIds: Array<Scalars['ID']['input']>;
};

export type VehicleTripDistanceResponse = {
  content: Array<VehicleTripDistance>;
};

export type VehicleV1 = {
  alias?: Maybe<Scalars['String']['output']>;
  branding?: Maybe<Branding>;
  device?: Maybe<Device>;
  disablerStatus?: Maybe<DisablerDto>;
  driver?: Maybe<Driver>;
  fleetId: Scalars['String']['output'];
  fuel?: Maybe<FuelDto>;
  groupPath: Scalars['String']['output'];
  groups?: Maybe<VehicleGroupDto>;
  id: Scalars['ID']['output'];
  immobilizerStatus?: Maybe<VehicleDriverAuthorizationStatus>;
  isAllowListEnabled?: Maybe<Scalars['Boolean']['output']>;
  isImmobilizerEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastLocation?: Maybe<VehicleLastLocationDto>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  odometer?: Maybe<VehicleOdometer>;
  size?: Maybe<Scalars['String']['output']>;
  speedLimitInKmh?: Maybe<Scalars['Float']['output']>;
  tags?: Maybe<Array<VehicleTag>>;
  vehicleDriverAuthorizationMode: Scalars['String']['output'];
};

export type VehiclesExpensesInput = {
  endDate: Scalars['DateTime']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sortCategoryId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  tagNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone: Scalars['String']['input'];
  vehicleGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleModels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VehiclesGroup = {
  createdAt: Scalars['TimestampInMillis']['output'];
  creatorId: Scalars['ID']['output'];
  fleetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  updatedAt: Scalars['TimestampInMillis']['output'];
  users: Array<Maybe<FleetUser>>;
  vehicles: Array<VehicleDto>;
};

export type VehiclesGroupInput = {
  fleetId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds: Array<Scalars['ID']['input']>;
};

export type VideoDto = {
  /** Channel in which the video was recorded */
  channel?: Maybe<Scalars['String']['output']>;
  /** Video URL on storage */
  url?: Maybe<Scalars['String']['output']>;
};

export type VideoDeliveryTime = {
  devices: Array<DeviceDeliveryTime>;
  fleet: Array<FleetDeliveryTime>;
};

export type VideoInfo = {
  category: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type WantedDriverId = {
  driverId: Scalars['ID']['input'];
};

export type WantedDrivers = {
  driverIds: Array<Scalars['ID']['input']>;
};

export type WifiSetting = {
  /** The date and time the wifi setting was created. */
  created_at: Scalars['DateTime']['output'];
  /** The name of the user who created the wifi setting. */
  created_by: Scalars['String']['output'];
  /** The id of the wifi setting. */
  id: Scalars['ID']['output'];
  /** The ssid of the wifi setting. */
  ssid: Scalars['String']['output'];
};

export type WorkingHours = {
  end_time: Scalars['TimestampInMillis']['output'];
  start_time: Scalars['TimestampInMillis']['output'];
};

export type WorkingHoursInput = {
  end_time: Scalars['TimestampInMillis']['input'];
  start_time: Scalars['TimestampInMillis']['input'];
};

export type ExecutionDigestSummary = {
  ids: Array<Scalars['ID']['output']>;
  total: Scalars['Int']['output'];
};

export type ChecklistNonConformityItemFragment = {
  id: string;
  status: ChecklistNonConformityStatus;
  questionKey: string;
  questionTitle: string;
  vehicleId: string;
  licensePlate?: string | null;
  driverName?: string | null;
  occurrenceCount: number;
  firstDetectedAt: number;
  lastDetectedAt: number;
  lastChecklistId: string;
  resolutionNote?: string | null;
  statusChangedAt?: number | null;
  version: number;
  vehicle?: { id: string; licensePlate?: string | null; groupPath: string } | null;
  checklistTemplate: { id: string; name?: string | null };
  assignee?: { id?: string | null; full_name?: string | null } | null;
  statusChangedBy?: { id?: string | null; full_name?: string | null } | null;
};

export type ChecklistNonConformityPageQueryVariables = Exact<{
  filter?: InputMaybe<ChecklistNonConformitiesFilter>;
}>;

export type ChecklistNonConformityPageQuery = {
  checklistNonConformities?: {
    content: Array<{
      id: string;
      status: ChecklistNonConformityStatus;
      questionKey: string;
      questionTitle: string;
      vehicleId: string;
      licensePlate?: string | null;
      driverName?: string | null;
      occurrenceCount: number;
      firstDetectedAt: number;
      lastDetectedAt: number;
      lastChecklistId: string;
      resolutionNote?: string | null;
      statusChangedAt?: number | null;
      version: number;
      vehicle?: { id: string; licensePlate?: string | null; groupPath: string } | null;
      checklistTemplate: { id: string; name?: string | null };
      assignee?: { id?: string | null; full_name?: string | null } | null;
      statusChangedBy?: { id?: string | null; full_name?: string | null } | null;
    }>;
    page: { number: number; size: number; totalElements: number; totalPages: number };
  } | null;
};

export type ChecklistNonConformitySummaryQueryVariables = Exact<{
  filter?: InputMaybe<ChecklistNonConformitiesFilter>;
}>;

export type ChecklistNonConformitySummaryQuery = {
  checklistNonConformitySummary?: { open: number; inTreatment: number; resolved: number; autoResolved: number; dismissed: number } | null;
};

export type ChecklistNonConformityDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ChecklistNonConformityDetailsQuery = {
  checklistNonConformity?: {
    id: string;
    status: ChecklistNonConformityStatus;
    questionKey: string;
    questionTitle: string;
    vehicleId: string;
    licensePlate?: string | null;
    driverName?: string | null;
    occurrenceCount: number;
    firstDetectedAt: number;
    lastDetectedAt: number;
    lastChecklistId: string;
    resolutionNote?: string | null;
    statusChangedAt?: number | null;
    version: number;
    occurrences?: Array<{ id: string; checklistId: string; detectedAt: number; driverName?: string | null; withdrawnAt?: number | null }> | null;
    history?: Array<{
      id: string;
      type: ChecklistNonConformityHistoryEntryType;
      fromStatus?: ChecklistNonConformityStatus | null;
      toStatus?: ChecklistNonConformityStatus | null;
      note?: string | null;
      actorName?: string | null;
      checklistId?: string | null;
      createdAt: number;
      actor?: { id?: string | null; full_name?: string | null } | null;
      assignee?: { id?: string | null; full_name?: string | null } | null;
    }> | null;
    vehicle?: { id: string; licensePlate?: string | null; groupPath: string } | null;
    checklistTemplate: { id: string; name?: string | null };
    assignee?: { id?: string | null; full_name?: string | null } | null;
    statusChangedBy?: { id?: string | null; full_name?: string | null } | null;
  } | null;
};

export type ChangeChecklistNonConformityStatusMutationVariables = Exact<{
  input: ChangeChecklistNonConformityStatusInput;
}>;

export type ChangeChecklistNonConformityStatusMutation = {
  changeChecklistNonConformityStatus?: Array<{
    id: string;
    status: ChecklistNonConformityStatus;
    questionKey: string;
    questionTitle: string;
    vehicleId: string;
    licensePlate?: string | null;
    driverName?: string | null;
    occurrenceCount: number;
    firstDetectedAt: number;
    lastDetectedAt: number;
    lastChecklistId: string;
    resolutionNote?: string | null;
    statusChangedAt?: number | null;
    version: number;
    vehicle?: { id: string; licensePlate?: string | null; groupPath: string } | null;
    checklistTemplate: { id: string; name?: string | null };
    assignee?: { id?: string | null; full_name?: string | null } | null;
    statusChangedBy?: { id?: string | null; full_name?: string | null } | null;
  }> | null;
};

export type CoachingFeedbackPageQueryVariables = Exact<{
  input?: InputMaybe<CoachingFeedbackInput>;
}>;

export type CoachingFeedbackPageQuery = {
  coachingFeedback?: {
    empty: boolean;
    first: boolean;
    last: boolean;
    size: number;
    number: number;
    number_of_elements: number;
    total_pages: number;
    total_elements: number;
    content?: Array<{
      id: string;
      created_at: string;
      updated_at?: string | null;
      feedback_action?: CoachingFeedbackAction | null;
      status: CoachingFeedbackStatus;
      driver?: { id: string; name: string } | null;
      updated_by_user?: { full_name?: string | null } | null;
      created_by_user?: { full_name?: string | null } | null;
      coaching_evidences?: Array<{ id?: string | null; media_id?: string | null; safety_occurrences?: Array<{ id: string; name: string } | null> | null } | null> | null;
    } | null> | null;
  } | null;
};

export type CoachingFeedbackDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CoachingFeedbackDetailsQuery = {
  coachingFeedbackDetails?: {
    id: string;
    created_at: string;
    updated_at?: string | null;
    status: CoachingFeedbackStatus;
    note?: string | null;
    note_created_at?: string | null;
    feedback_action?: CoachingFeedbackAction | null;
    driver?: { id: string; name: string } | null;
    updated_by_user?: { full_name?: string | null } | null;
    created_by_user?: { full_name?: string | null } | null;
    note_author?: { full_name?: string | null } | null;
    coaching_evidences?: Array<{
      id?: string | null;
      media_id?: string | null;
      safety_occurrences?: Array<{ id: string; name: string } | null> | null;
      files?: Array<{ id: string; file_url: string; file_type: CoachingFileType; file_timestamp?: number | null; created_at?: string | null } | null> | null;
      media?: {
        media_url?: string | null;
        expiration_date?: number | null;
        videos?: Array<{ url?: string | null; channel?: string | null } | null> | null;
        media_info?: {
          id: string;
          device_id: string;
          driver_id?: string | null;
          media_type: MediaType;
          media_status: MediaStatus;
          is_favorite?: boolean | null;
          media_view_count: number;
          timestamp: number;
          severity?: Severity | null;
          driver?: { name: string } | null;
          comments?: Array<{
            id: string;
            media_id: string;
            created_by: string;
            content?: string | null;
            created_at: string;
            updated_at?: string | null;
            created_by_user: { full_name?: string | null };
          } | null> | null;
          safety_review?: {
            id: string;
            fleet_id: string;
            status?: string | null;
            driver_id?: string | null;
            created_by: string;
            updated_by: string;
            created_at: string;
            updated_at: string;
            driver?: { name: string } | null;
            updated_by_user?: { full_name?: string | null } | null;
            occurrences?: Array<{ id: string; name: string } | null> | null;
          } | null;
          media_details:
            | { event_trigger: EventTrigger; latitude: number; longitude: number; speed: number; speed_sign?: number | null; event_media_url: string; event_thumbnail_url: string }
            | {
                created_at: number;
                duration: number;
                end_latitude?: number | null;
                end_longitude?: number | null;
                request_id: string;
                start_latitude?: number | null;
                start_longitude?: number | null;
                status: RequestedMediaStatus;
                updated_at: number;
                footage_media_url?: string | null;
                footage_thumbnail_url?: string | null;
                created_by?: { id?: string | null; full_name?: string | null; fleet_id?: string | null; email_address?: string | null } | null;
                created_by_trigger?: { id?: string | null; name?: string | null } | null;
              };
          vehicle?: { id: string; licensePlate?: string | null; groups: Array<{ id: string; name: string }> } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ConferencePackageFragment = {
  evaluatedAt?: number | null;
  conferenceStatus: string;
  transaction: {
    id: string;
    transactionTime: number;
    updatedAt?: number | null;
    units: number;
    unitCost: number;
    totalCost: number;
    commodity: string;
    odometer?: number | null;
    cobliOdometer?: number | null;
    cobliDrivenMeters?: number | null;
    providerCode?: string | null;
    merchant?: { name?: string | null } | null;
    vehicle?: { id: string; licensePlate?: string | null; model?: string | null } | null;
  };
  ruleEvaluations: Array<{
    id: string;
    ruleCode: string;
    ruleVersion: number;
    result: string;
    severity?: string | null;
    evidence?: Record<string, unknown> | null;
    evaluatedAt: number;
  }>;
  review?: { id: string; status?: ConferenceReviewStatus | null; observation?: string | null; reviewedBy?: string | null; reviewedAt?: number | null; createdAt: number } | null;
  events: Array<{ id: string; eventType: string; actorId?: string | null; occurredAt: number; payload?: Record<string, unknown> | null }>;
};

export type ConferenceTransactionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ConferenceTransactionQuery = {
  conferenceTransactionById: {
    evaluatedAt?: number | null;
    conferenceStatus: string;
    transaction: {
      id: string;
      transactionTime: number;
      updatedAt?: number | null;
      units: number;
      unitCost: number;
      totalCost: number;
      commodity: string;
      odometer?: number | null;
      cobliOdometer?: number | null;
      cobliDrivenMeters?: number | null;
      providerCode?: string | null;
      merchant?: { name?: string | null } | null;
      vehicle?: { id: string; licensePlate?: string | null; model?: string | null } | null;
    };
    ruleEvaluations: Array<{
      id: string;
      ruleCode: string;
      ruleVersion: number;
      result: string;
      severity?: string | null;
      evidence?: Record<string, unknown> | null;
      evaluatedAt: number;
    }>;
    review?: { id: string; status?: ConferenceReviewStatus | null; observation?: string | null; reviewedBy?: string | null; reviewedAt?: number | null; createdAt: number } | null;
    events: Array<{ id: string; eventType: string; actorId?: string | null; occurredAt: number; payload?: Record<string, unknown> | null }>;
  };
};

export type MarkConferenceReviewMutationVariables = Exact<{
  input: MarkConferenceReviewInput;
}>;

export type MarkConferenceReviewMutation = {
  markConferenceReview: {
    evaluatedAt?: number | null;
    conferenceStatus: string;
    transaction: {
      id: string;
      transactionTime: number;
      updatedAt?: number | null;
      units: number;
      unitCost: number;
      totalCost: number;
      commodity: string;
      odometer?: number | null;
      cobliOdometer?: number | null;
      cobliDrivenMeters?: number | null;
      providerCode?: string | null;
      merchant?: { name?: string | null } | null;
      vehicle?: { id: string; licensePlate?: string | null; model?: string | null } | null;
    };
    ruleEvaluations: Array<{
      id: string;
      ruleCode: string;
      ruleVersion: number;
      result: string;
      severity?: string | null;
      evidence?: Record<string, unknown> | null;
      evaluatedAt: number;
    }>;
    review?: { id: string; status?: ConferenceReviewStatus | null; observation?: string | null; reviewedBy?: string | null; reviewedAt?: number | null; createdAt: number } | null;
    events: Array<{ id: string; eventType: string; actorId?: string | null; occurredAt: number; payload?: Record<string, unknown> | null }>;
  };
};

export type ReopenConferenceReviewMutationVariables = Exact<{
  input: ReopenConferenceReviewInput;
}>;

export type ReopenConferenceReviewMutation = {
  reopenConferenceReview: {
    evaluatedAt?: number | null;
    conferenceStatus: string;
    transaction: {
      id: string;
      transactionTime: number;
      updatedAt?: number | null;
      units: number;
      unitCost: number;
      totalCost: number;
      commodity: string;
      odometer?: number | null;
      cobliOdometer?: number | null;
      cobliDrivenMeters?: number | null;
      providerCode?: string | null;
      merchant?: { name?: string | null } | null;
      vehicle?: { id: string; licensePlate?: string | null; model?: string | null } | null;
    };
    ruleEvaluations: Array<{
      id: string;
      ruleCode: string;
      ruleVersion: number;
      result: string;
      severity?: string | null;
      evidence?: Record<string, unknown> | null;
      evaluatedAt: number;
    }>;
    review?: { id: string; status?: ConferenceReviewStatus | null; observation?: string | null; reviewedBy?: string | null; reviewedAt?: number | null; createdAt: number } | null;
    events: Array<{ id: string; eventType: string; actorId?: string | null; occurredAt: number; payload?: Record<string, unknown> | null }>;
  };
};

export type ConferenceCandidateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ConferenceCandidateQuery = {
  fuelTransactionById: {
    id: string;
    transactionTime: number;
    units: number;
    totalCost: number;
    commodity: string;
    odometer?: number | null;
    merchant?: { name?: string | null } | null;
  };
};

export type FleetUsersForAssignmentQueryVariables = Exact<{
  fleetId: Scalars['String']['input'];
}>;

export type FleetUsersForAssignmentQuery = { fleetUsers?: Array<{ id?: string | null; full_name?: string | null; active?: boolean | null } | null> | null };

export type FleetVideoReviewConfigurationQueryVariables = Exact<{ [key: string]: never }>;

export type FleetVideoReviewConfigurationQuery = {
  fleetVideoReviewConfiguration?: { archiveInsteadOfDismiss?: boolean | null; updatedAt?: string | null; updatedById?: string | null; updatedByName?: string | null } | null;
};

export type UpdateFleetVideoReviewConfigurationMutationVariables = Exact<{
  input: UpdateFleetVideoReviewConfigurationInput;
}>;

export type UpdateFleetVideoReviewConfigurationMutation = {
  updateFleetVideoReviewConfiguration?: { archiveInsteadOfDismiss?: boolean | null; updatedAt?: string | null; updatedById?: string | null; updatedByName?: string | null } | null;
};

export type GetMediaQueryVariables = Exact<{
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  eventTriggers?: InputMaybe<Array<InputMaybe<EventTrigger>> | InputMaybe<EventTrigger>>;
  severities?: InputMaybe<Array<InputMaybe<Severity>> | InputMaybe<Severity>>;
  requestStatus?: InputMaybe<Array<InputMaybe<MediaRequestStatus>> | InputMaybe<MediaRequestStatus>>;
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  mediaTypes?: InputMaybe<Array<InputMaybe<MediaType>> | InputMaybe<MediaType>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  sortList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromCreatedAtTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  toCreatedAtTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  safetyOccurrenceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  mediaStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  requestOrigins?: InputMaybe<Array<InputMaybe<RequestOrigin>> | InputMaybe<RequestOrigin>>;
  descriptionTextQuery?: InputMaybe<Scalars['String']['input']>;
  suggestedOccurrences?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  archived?: InputMaybe<ArchivedMediaFilter>;
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetMediaQuery = {
  media?: {
    empty?: boolean | null;
    first?: boolean | null;
    last?: boolean | null;
    number?: number | null;
    number_of_elements?: number | null;
    size?: number | null;
    total_elements?: number | null;
    total_pages?: number | null;
    content?: Array<{
      id: string;
      device_id: string;
      driver_id?: string | null;
      media_type: MediaType;
      media_status: MediaStatus;
      media_view_count: number;
      timestamp: number;
      severity?: Severity | null;
      is_favorite?: boolean | null;
      driver?: { id: string; name: string } | null;
      unreviewed_driver?: { id: string; name: string } | null;
      safety_review?: {
        id: string;
        fleet_id: string;
        status?: string | null;
        driver_id?: string | null;
        created_by: string;
        updated_by: string;
        created_at: string;
        updated_at: string;
        dismiss_reason?: string | null;
        archivedAt?: string | null;
        archivedById?: string | null;
        archivedByName?: string | null;
        archivedOrigin?: SafetyReviewOrigin | null;
        driver?: { id: string; name: string } | null;
        updated_by_user?: { full_name?: string | null } | null;
        occurrences?: Array<{ id: string; name: string } | null> | null;
      } | null;
      media_details:
        | { event_trigger: EventTrigger; latitude: number; longitude: number; speed: number; speed_sign?: number | null; event_media_url: string; event_thumbnail_url: string }
        | {
            created_at: number;
            processed_at?: number | null;
            duration: number;
            end_latitude?: number | null;
            end_longitude?: number | null;
            request_id: string;
            start_latitude?: number | null;
            start_longitude?: number | null;
            status: RequestedMediaStatus;
            request_status: MediaRequestStatus;
            updated_at: number;
            footage_media_url?: string | null;
            footage_thumbnail_url?: string | null;
            created_by?: { id?: string | null; full_name?: string | null; fleet_id?: string | null; email_address?: string | null } | null;
            created_by_trigger?: { id?: string | null; name?: string | null } | null;
          };
      vehicle?: {
        id: string;
        licensePlate?: string | null;
        alias?: string | null;
        driver?: { id?: string | null; name?: string | null; phoneNumbers?: Array<string | null> | null } | null;
        model: { brand?: string | null; name?: string | null };
      } | null;
      vehicle_group?: { id: string; name: string } | null;
      ai_suggested_driver?: { id: string; name: string } | null;
      ai_video_tags?: { seatbelt_detection?: { with_seatbelt?: boolean | null } | null } | null;
    } | null> | null;
  } | null;
};

export type GetDeviceMediaCountQueryVariables = Exact<{
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  mediaTypes?: InputMaybe<Array<InputMaybe<MediaType>> | InputMaybe<MediaType>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  eventTriggers?: InputMaybe<Array<InputMaybe<EventTrigger>> | InputMaybe<EventTrigger>>;
}>;

export type GetDeviceMediaCountQuery = { media?: { total_elements?: number | null } | null };

export type GetMediaViewQueryVariables = Exact<{
  mediaId?: InputMaybe<Scalars['ID']['input']>;
  shouldGenerateDescription?: InputMaybe<Scalars['Boolean']['input']>;
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetMediaViewQuery = {
  mediaView?: {
    media_url?: string | null;
    expiration_date?: number | null;
    ai_description?: string | null;
    suggested_occurrences?: Array<string | null> | null;
    ai_video_tags?: { seatbelt_detection?: { with_seatbelt?: boolean | null } | null } | null;
    videos?: Array<{ url?: string | null; channel?: string | null } | null> | null;
    media_info?: {
      id: string;
      device_id: string;
      driver_id?: string | null;
      media_type: MediaType;
      media_status: MediaStatus;
      is_favorite?: boolean | null;
      media_view_count: number;
      timestamp: number;
      severity?: Severity | null;
      driver?: { id: string; name: string } | null;
      unreviewed_driver?: { id: string; name: string } | null;
      comments?: Array<{
        id: string;
        media_id: string;
        created_by: string;
        content?: string | null;
        created_at: string;
        updated_at?: string | null;
        created_by_user?: { full_name?: string | null };
      } | null> | null;
      safety_review?: {
        id: string;
        fleet_id: string;
        status?: string | null;
        driver_id?: string | null;
        severity?: string | null;
        original_media_severity?: string | null;
        dismiss_reason?: string | null;
        created_by: string;
        updated_by: string;
        created_at: string;
        updated_at: string;
        archivedAt?: string | null;
        archivedById?: string | null;
        archivedByName?: string | null;
        archivedOrigin?: SafetyReviewOrigin | null;
        driver?: { id: string; name: string } | null;
        updated_by_user?: { full_name?: string | null } | null;
        occurrences?: Array<{ id: string; name: string } | null> | null;
      } | null;
      media_details:
        | { event_trigger: EventTrigger; latitude: number; longitude: number; speed: number; speed_sign?: number | null; event_media_url: string; event_thumbnail_url: string }
        | {
            created_at: number;
            duration: number;
            end_latitude?: number | null;
            end_longitude?: number | null;
            request_id: string;
            start_latitude?: number | null;
            start_longitude?: number | null;
            status: RequestedMediaStatus;
            updated_at: number;
            footage_media_url?: string | null;
            footage_thumbnail_url?: string | null;
            created_by?: { id?: string | null; full_name?: string | null; fleet_id?: string | null; email_address?: string | null } | null;
            created_by_trigger?: { id?: string | null; name?: string | null } | null;
          };
      severity_detail?: {
        id: string;
        severity_level: Severity;
        severity_score?: number | null;
        risk_factors?: Array<{ id: string; type: string; value: number; custom_details?: Record<string, unknown> | null } | null> | null;
      } | null;
      vehicle?: { id: string; cobliId?: string | null; licensePlate?: string | null } | null;
      vehicle_group?: { id: string; name: string } | null;
      ai_suggested_driver?: { id: string; name: string } | null;
    } | null;
  } | null;
};

export type GetMediaThumbnailQueryVariables = Exact<{
  mediaId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetMediaThumbnailQuery = {
  mediaView?: { media_info?: { id: string; media_details: { event_thumbnail_url: string } | { footage_thumbnail_url?: string | null } } | null } | null;
};

export type EventsSeveritiesSummaryQueryVariables = Exact<{
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  eventTriggers?: InputMaybe<Array<InputMaybe<EventTrigger>> | InputMaybe<EventTrigger>>;
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  safetyOccurrenceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  mediaStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  descriptionTextQuery?: InputMaybe<Scalars['String']['input']>;
  suggestedOccurrences?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type EventsSeveritiesSummaryQuery = { eventsSeveritiesSummary?: { low: number; medium: number; high: number; higher: number } | null };

export type CreateMediaMutationVariables = Exact<{
  createMediaRequest: CreateMediaRequest;
}>;

export type CreateMediaMutation = { createMedia: { vehicle_id?: string | null; start_time: number; end_time: number; media_id?: string | null } };

export type VehicleTrackingSegmentQueryVariables = Exact<{
  input: VehicleTrackingSegmentInput;
  event_triggers?: InputMaybe<Array<InputMaybe<EventTrigger>> | InputMaybe<EventTrigger>>;
  media_types?: InputMaybe<Array<InputMaybe<MediaType>> | InputMaybe<MediaType>>;
}>;

export type VehicleTrackingSegmentQuery = {
  vehicleTrackingSegment?: {
    start_time: number;
    end_time: number;
    has_route_steps?: boolean | null;
    tracking?: {
      vehicleId?: string | null;
      pathGeojson: { type: string; geometry: { type: string; coordinates: Array<Array<number | null> | null> }; properties: { timestamps: Array<number | null> } };
    } | null;
    mediaEvents?: Array<{
      id: string;
      media_type: MediaType;
      timestamp: number;
      severity?: Severity | null;
      media_details: { event_trigger: EventTrigger; latitude: number; longitude: number } | {};
    } | null> | null;
  } | null;
};

export class TypedDocumentString<TResult, TVariables> extends String implements DocumentTypeDecoration<TResult, TVariables> {
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const ChecklistNonConformityItemFragmentDoc = new TypedDocumentString(
  `
    fragment ChecklistNonConformityItem on ChecklistNonConformity {
  id
  status
  questionKey
  questionTitle
  vehicleId
  vehicle {
    id
    licensePlate
    groupPath
  }
  licensePlate
  driverName
  checklistTemplate {
    id
    name
  }
  occurrenceCount
  firstDetectedAt
  lastDetectedAt
  lastChecklistId
  resolutionNote
  statusChangedAt
  assignee {
    id
    full_name
  }
  statusChangedBy {
    id
    full_name
  }
  version
}
    `,
  { fragmentName: 'ChecklistNonConformityItem' }
) as unknown as TypedDocumentString<ChecklistNonConformityItemFragment, unknown>;
export const ConferencePackageFragmentDoc = new TypedDocumentString(
  `
    fragment ConferencePackage on ConferenceTransactionResponse {
  evaluatedAt
  conferenceStatus
  transaction {
    id
    transactionTime
    updatedAt
    units
    unitCost
    totalCost
    commodity
    odometer
    cobliOdometer
    cobliDrivenMeters
    providerCode
    merchant {
      name
    }
    vehicle {
      id
      licensePlate
      model
    }
  }
  ruleEvaluations {
    id
    ruleCode
    ruleVersion
    result
    severity
    evidence
    evaluatedAt
  }
  review {
    id
    status
    observation
    reviewedBy
    reviewedAt
    createdAt
  }
  events {
    id
    eventType
    actorId
    occurredAt
    payload
  }
}
    `,
  { fragmentName: 'ConferencePackage' }
) as unknown as TypedDocumentString<ConferencePackageFragment, unknown>;
export const ChecklistNonConformityPageDocument = new TypedDocumentString(`
    query checklistNonConformityPage($filter: ChecklistNonConformitiesFilter) {
  checklistNonConformities(filter: $filter) {
    content {
      ...ChecklistNonConformityItem
    }
    page {
      number
      size
      totalElements
      totalPages
    }
  }
}
    fragment ChecklistNonConformityItem on ChecklistNonConformity {
  id
  status
  questionKey
  questionTitle
  vehicleId
  vehicle {
    id
    licensePlate
    groupPath
  }
  licensePlate
  driverName
  checklistTemplate {
    id
    name
  }
  occurrenceCount
  firstDetectedAt
  lastDetectedAt
  lastChecklistId
  resolutionNote
  statusChangedAt
  assignee {
    id
    full_name
  }
  statusChangedBy {
    id
    full_name
  }
  version
}`) as unknown as TypedDocumentString<ChecklistNonConformityPageQuery, ChecklistNonConformityPageQueryVariables>;
export const ChecklistNonConformitySummaryDocument = new TypedDocumentString(`
    query checklistNonConformitySummary($filter: ChecklistNonConformitiesFilter) {
  checklistNonConformitySummary(filter: $filter) {
    open
    inTreatment
    resolved
    autoResolved
    dismissed
  }
}
    `) as unknown as TypedDocumentString<ChecklistNonConformitySummaryQuery, ChecklistNonConformitySummaryQueryVariables>;
export const ChecklistNonConformityDetailsDocument = new TypedDocumentString(`
    query checklistNonConformityDetails($id: ID!) {
  checklistNonConformity(id: $id) {
    ...ChecklistNonConformityItem
    occurrences {
      id
      checklistId
      detectedAt
      driverName
      withdrawnAt
    }
    history {
      id
      type
      fromStatus
      toStatus
      note
      actorName
      actor {
        id
        full_name
      }
      assignee {
        id
        full_name
      }
      checklistId
      createdAt
    }
  }
}
    fragment ChecklistNonConformityItem on ChecklistNonConformity {
  id
  status
  questionKey
  questionTitle
  vehicleId
  vehicle {
    id
    licensePlate
    groupPath
  }
  licensePlate
  driverName
  checklistTemplate {
    id
    name
  }
  occurrenceCount
  firstDetectedAt
  lastDetectedAt
  lastChecklistId
  resolutionNote
  statusChangedAt
  assignee {
    id
    full_name
  }
  statusChangedBy {
    id
    full_name
  }
  version
}`) as unknown as TypedDocumentString<ChecklistNonConformityDetailsQuery, ChecklistNonConformityDetailsQueryVariables>;
export const ChangeChecklistNonConformityStatusDocument = new TypedDocumentString(`
    mutation changeChecklistNonConformityStatus($input: ChangeChecklistNonConformityStatusInput!) {
  changeChecklistNonConformityStatus(input: $input) {
    ...ChecklistNonConformityItem
  }
}
    fragment ChecklistNonConformityItem on ChecklistNonConformity {
  id
  status
  questionKey
  questionTitle
  vehicleId
  vehicle {
    id
    licensePlate
    groupPath
  }
  licensePlate
  driverName
  checklistTemplate {
    id
    name
  }
  occurrenceCount
  firstDetectedAt
  lastDetectedAt
  lastChecklistId
  resolutionNote
  statusChangedAt
  assignee {
    id
    full_name
  }
  statusChangedBy {
    id
    full_name
  }
  version
}`) as unknown as TypedDocumentString<ChangeChecklistNonConformityStatusMutation, ChangeChecklistNonConformityStatusMutationVariables>;
export const CoachingFeedbackPageDocument = new TypedDocumentString(`
    query coachingFeedbackPage($input: CoachingFeedbackInput) {
  coachingFeedback(input: $input) {
    content {
      id
      driver {
        id
        name
      }
      created_at
      updated_by_user {
        full_name
      }
      updated_at
      feedback_action
      status
      created_by_user {
        full_name
      }
      coaching_evidences {
        id
        media_id
        safety_occurrences {
          id
          name
        }
      }
    }
    empty
    first
    last
    size
    number
    number_of_elements
    total_pages
    total_elements
  }
}
    `) as unknown as TypedDocumentString<CoachingFeedbackPageQuery, CoachingFeedbackPageQueryVariables>;
export const CoachingFeedbackDetailsDocument = new TypedDocumentString(`
    query coachingFeedbackDetails($id: ID!) {
  coachingFeedbackDetails(id: $id) {
    id
    driver {
      id
      name
    }
    created_at
    updated_at
    updated_by_user {
      full_name
    }
    status
    created_by_user {
      full_name
    }
    note
    note_created_at
    note_author {
      full_name
    }
    feedback_action
    coaching_evidences {
      id
      safety_occurrences {
        id
        name
      }
      files {
        id
        file_url
        file_type
        file_timestamp
        created_at
      }
      media_id
      media {
        media_url
        expiration_date
        videos {
          url
          channel
        }
        media_info {
          id
          device_id
          driver_id
          driver {
            name
          }
          media_type
          media_status
          is_favorite
          comments {
            id
            media_id
            created_by
            created_by_user {
              full_name
            }
            content
            created_at
            updated_at
          }
          safety_review {
            id
            fleet_id
            status
            driver_id
            driver {
              name
            }
            created_by
            updated_by
            updated_by_user {
              full_name
            }
            created_at
            updated_at
            occurrences {
              id
              name
            }
          }
          media_details {
            ... on EventVideo {
              event_trigger
              latitude
              longitude
              event_media_url: media_url
              speed
              speed_sign
              event_thumbnail_url: thumbnail_url
            }
            ... on FootageVideo {
              created_at
              duration
              end_latitude
              end_longitude
              footage_media_url: media_url
              request_id
              start_latitude
              start_longitude
              status
              footage_thumbnail_url: thumbnail_url
              updated_at
              created_by {
                id
                full_name
                fleet_id
                email_address
              }
              created_by_trigger {
                id
                name
              }
            }
          }
          media_view_count
          timestamp
          severity
          vehicle {
            id
            licensePlate
            groups {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CoachingFeedbackDetailsQuery, CoachingFeedbackDetailsQueryVariables>;
export const ConferenceTransactionDocument = new TypedDocumentString(`
    query conferenceTransaction($id: ID!) {
  conferenceTransactionById(input: $id) {
    ...ConferencePackage
  }
}
    fragment ConferencePackage on ConferenceTransactionResponse {
  evaluatedAt
  conferenceStatus
  transaction {
    id
    transactionTime
    updatedAt
    units
    unitCost
    totalCost
    commodity
    odometer
    cobliOdometer
    cobliDrivenMeters
    providerCode
    merchant {
      name
    }
    vehicle {
      id
      licensePlate
      model
    }
  }
  ruleEvaluations {
    id
    ruleCode
    ruleVersion
    result
    severity
    evidence
    evaluatedAt
  }
  review {
    id
    status
    observation
    reviewedBy
    reviewedAt
    createdAt
  }
  events {
    id
    eventType
    actorId
    occurredAt
    payload
  }
}`) as unknown as TypedDocumentString<ConferenceTransactionQuery, ConferenceTransactionQueryVariables>;
export const MarkConferenceReviewDocument = new TypedDocumentString(`
    mutation markConferenceReview($input: MarkConferenceReviewInput!) {
  markConferenceReview(input: $input) {
    ...ConferencePackage
  }
}
    fragment ConferencePackage on ConferenceTransactionResponse {
  evaluatedAt
  conferenceStatus
  transaction {
    id
    transactionTime
    updatedAt
    units
    unitCost
    totalCost
    commodity
    odometer
    cobliOdometer
    cobliDrivenMeters
    providerCode
    merchant {
      name
    }
    vehicle {
      id
      licensePlate
      model
    }
  }
  ruleEvaluations {
    id
    ruleCode
    ruleVersion
    result
    severity
    evidence
    evaluatedAt
  }
  review {
    id
    status
    observation
    reviewedBy
    reviewedAt
    createdAt
  }
  events {
    id
    eventType
    actorId
    occurredAt
    payload
  }
}`) as unknown as TypedDocumentString<MarkConferenceReviewMutation, MarkConferenceReviewMutationVariables>;
export const ReopenConferenceReviewDocument = new TypedDocumentString(`
    mutation reopenConferenceReview($input: ReopenConferenceReviewInput!) {
  reopenConferenceReview(input: $input) {
    ...ConferencePackage
  }
}
    fragment ConferencePackage on ConferenceTransactionResponse {
  evaluatedAt
  conferenceStatus
  transaction {
    id
    transactionTime
    updatedAt
    units
    unitCost
    totalCost
    commodity
    odometer
    cobliOdometer
    cobliDrivenMeters
    providerCode
    merchant {
      name
    }
    vehicle {
      id
      licensePlate
      model
    }
  }
  ruleEvaluations {
    id
    ruleCode
    ruleVersion
    result
    severity
    evidence
    evaluatedAt
  }
  review {
    id
    status
    observation
    reviewedBy
    reviewedAt
    createdAt
  }
  events {
    id
    eventType
    actorId
    occurredAt
    payload
  }
}`) as unknown as TypedDocumentString<ReopenConferenceReviewMutation, ReopenConferenceReviewMutationVariables>;
export const ConferenceCandidateDocument = new TypedDocumentString(`
    query conferenceCandidate($id: ID!) {
  fuelTransactionById(input: $id) {
    id
    transactionTime
    units
    totalCost
    commodity
    odometer
    merchant {
      name
    }
  }
}
    `) as unknown as TypedDocumentString<ConferenceCandidateQuery, ConferenceCandidateQueryVariables>;
export const FleetUsersForAssignmentDocument = new TypedDocumentString(`
    query fleetUsersForAssignment($fleetId: String!) {
  fleetUsers(fleetId: $fleetId) {
    id
    full_name
    active
  }
}
    `) as unknown as TypedDocumentString<FleetUsersForAssignmentQuery, FleetUsersForAssignmentQueryVariables>;
export const FleetVideoReviewConfigurationDocument = new TypedDocumentString(`
    query fleetVideoReviewConfiguration {
  fleetVideoReviewConfiguration {
    archiveInsteadOfDismiss
    updatedAt
    updatedById
    updatedByName
  }
}
    `) as unknown as TypedDocumentString<FleetVideoReviewConfigurationQuery, FleetVideoReviewConfigurationQueryVariables>;
export const UpdateFleetVideoReviewConfigurationDocument = new TypedDocumentString(`
    mutation updateFleetVideoReviewConfiguration($input: UpdateFleetVideoReviewConfigurationInput!) {
  updateFleetVideoReviewConfiguration(input: $input) {
    archiveInsteadOfDismiss
    updatedAt
    updatedById
    updatedByName
  }
}
    `) as unknown as TypedDocumentString<UpdateFleetVideoReviewConfigurationMutation, UpdateFleetVideoReviewConfigurationMutationVariables>;
export const GetMediaDocument = new TypedDocumentString(`
    query getMedia($driverIds: [ID], $vehicleIds: [ID], $eventTriggers: [EventTrigger], $severities: [Severity], $requestStatus: [MediaRequestStatus], $fromTimestamp: TimestampInMillis, $mediaTypes: [MediaType], $page: Int, $size: Int, $sort: [String], $sortList: [String], $toTimestamp: TimestampInMillis, $createdBy: [ID], $fromCreatedAtTimestamp: TimestampInMillis, $toCreatedAtTimestamp: TimestampInMillis, $isFavorite: Boolean, $safetyOccurrenceIds: [ID], $mediaStatus: [String], $requestOrigins: [RequestOrigin], $descriptionTextQuery: String, $suggestedOccurrences: [String], $archived: ArchivedMediaFilter, $withUsers: Boolean = true) {
  media(
    driverIds: $driverIds
    vehicleIds: $vehicleIds
    eventTriggers: $eventTriggers
    severities: $severities
    fromTimestamp: $fromTimestamp
    requestStatus: $requestStatus
    mediaTypes: $mediaTypes
    page: $page
    size: $size
    sort: $sort
    sortList: $sortList
    toTimestamp: $toTimestamp
    createdBy: $createdBy
    fromCreatedAtTimestamp: $fromCreatedAtTimestamp
    toCreatedAtTimestamp: $toCreatedAtTimestamp
    isFavorite: $isFavorite
    safetyOccurrenceIds: $safetyOccurrenceIds
    mediaStatus: $mediaStatus
    requestOrigins: $requestOrigins
    descriptionTextQuery: $descriptionTextQuery
    suggestedOccurrences: $suggestedOccurrences
    archived: $archived
  ) {
    content {
      id
      device_id
      driver_id
      driver {
        id
        name
      }
      unreviewed_driver {
        id
        name
      }
      media_type
      media_status
      safety_review {
        id
        fleet_id
        status
        driver_id
        driver {
          id
          name
        }
        created_by
        updated_by
        updated_by_user @include(if: $withUsers) {
          full_name
        }
        created_at
        updated_at
        occurrences {
          id
          name
        }
        dismiss_reason
        archivedAt
        archivedById
        archivedByName
        archivedOrigin
      }
      media_details {
        ... on EventVideo {
          event_trigger
          latitude
          longitude
          event_media_url: media_url
          speed
          speed_sign
          event_thumbnail_url: thumbnail_url
        }
        ... on FootageVideo {
          created_at
          processed_at
          duration
          end_latitude
          end_longitude
          footage_media_url: media_url
          request_id
          start_latitude
          start_longitude
          status
          request_status
          footage_thumbnail_url: thumbnail_url
          updated_at
          created_by @include(if: $withUsers) {
            id
            full_name
            fleet_id
            email_address
          }
          created_by_trigger {
            id
            name
          }
        }
      }
      vehicle {
        id
        driver {
          id
          name
          phoneNumbers
        }
        model {
          brand
          name
        }
        licensePlate
        alias
      }
      vehicle_group {
        id
        name
      }
      media_view_count
      timestamp
      severity
      is_favorite
      ai_suggested_driver {
        id
        name
      }
      ai_video_tags {
        seatbelt_detection {
          with_seatbelt
        }
      }
    }
    empty
    first
    last
    number
    number_of_elements
    size
    total_elements
    total_pages
  }
}
    `) as unknown as TypedDocumentString<GetMediaQuery, GetMediaQueryVariables>;
export const GetDeviceMediaCountDocument = new TypedDocumentString(`
    query getDeviceMediaCount($fromTimestamp: TimestampInMillis, $toTimestamp: TimestampInMillis, $mediaTypes: [MediaType], $vehicleIds: [ID], $eventTriggers: [EventTrigger]) {
  media(
    vehicleIds: $vehicleIds
    fromTimestamp: $fromTimestamp
    toTimestamp: $toTimestamp
    mediaTypes: $mediaTypes
    eventTriggers: $eventTriggers
  ) {
    total_elements
  }
}
    `) as unknown as TypedDocumentString<GetDeviceMediaCountQuery, GetDeviceMediaCountQueryVariables>;
export const GetMediaViewDocument = new TypedDocumentString(`
    query getMediaView($mediaId: ID, $shouldGenerateDescription: Boolean, $withUsers: Boolean = true) {
  mediaView(
    mediaId: $mediaId
    shouldGenerateDescription: $shouldGenerateDescription
  ) {
    media_url
    expiration_date
    ai_description
    suggested_occurrences
    ai_video_tags {
      seatbelt_detection {
        with_seatbelt
      }
    }
    videos {
      url
      channel
    }
    media_info {
      id
      device_id
      driver_id
      driver {
        id
        name
      }
      unreviewed_driver {
        id
        name
      }
      media_type
      media_status
      is_favorite
      comments {
        id
        media_id
        created_by
        created_by_user @include(if: $withUsers) {
          full_name
        }
        content
        created_at
        updated_at
      }
      safety_review {
        id
        fleet_id
        status
        driver_id
        severity
        original_media_severity
        dismiss_reason
        driver {
          id
          name
        }
        created_by
        updated_by
        updated_by_user @include(if: $withUsers) {
          full_name
        }
        created_at
        updated_at
        occurrences {
          id
          name
        }
        archivedAt
        archivedById
        archivedByName
        archivedOrigin
      }
      media_details {
        ... on EventVideo {
          event_trigger
          latitude
          longitude
          event_media_url: media_url
          speed
          speed_sign
          event_thumbnail_url: thumbnail_url
        }
        ... on FootageVideo {
          created_at
          duration
          end_latitude
          end_longitude
          footage_media_url: media_url
          request_id
          start_latitude
          start_longitude
          status
          footage_thumbnail_url: thumbnail_url
          updated_at
          created_by @include(if: $withUsers) {
            id
            full_name
            fleet_id
            email_address
          }
          created_by_trigger {
            id
            name
          }
        }
      }
      media_view_count
      timestamp
      severity
      severity_detail {
        id
        severity_level
        severity_score
        risk_factors {
          id
          type
          value
          custom_details
        }
      }
      vehicle {
        id
        cobliId
        licensePlate
      }
      vehicle_group {
        id
        name
      }
      ai_suggested_driver {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetMediaViewQuery, GetMediaViewQueryVariables>;
export const GetMediaThumbnailDocument = new TypedDocumentString(`
    query getMediaThumbnail($mediaId: ID) {
  mediaView(mediaId: $mediaId) {
    media_info {
      id
      media_details {
        ... on EventVideo {
          event_thumbnail_url: thumbnail_url
        }
        ... on FootageVideo {
          footage_thumbnail_url: thumbnail_url
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetMediaThumbnailQuery, GetMediaThumbnailQueryVariables>;
export const EventsSeveritiesSummaryDocument = new TypedDocumentString(`
    query eventsSeveritiesSummary($driverIds: [ID], $vehicleIds: [ID], $eventTriggers: [EventTrigger], $fromTimestamp: TimestampInMillis, $toTimestamp: TimestampInMillis, $isFavorite: Boolean, $safetyOccurrenceIds: [ID], $mediaStatus: [String], $descriptionTextQuery: String, $suggestedOccurrences: [String]) {
  eventsSeveritiesSummary(
    driverIds: $driverIds
    vehicleIds: $vehicleIds
    eventTriggers: $eventTriggers
    fromTimestamp: $fromTimestamp
    toTimestamp: $toTimestamp
    isFavorite: $isFavorite
    safetyOccurrenceIds: $safetyOccurrenceIds
    mediaStatus: $mediaStatus
    descriptionTextQuery: $descriptionTextQuery
    suggestedOccurrences: $suggestedOccurrences
  ) {
    low
    medium
    high
    higher
  }
}
    `) as unknown as TypedDocumentString<EventsSeveritiesSummaryQuery, EventsSeveritiesSummaryQueryVariables>;
export const CreateMediaDocument = new TypedDocumentString(`
    mutation createMedia($createMediaRequest: CreateMediaRequest!) {
  createMedia(input: $createMediaRequest) {
    vehicle_id
    start_time
    end_time
    media_id
  }
}
    `) as unknown as TypedDocumentString<CreateMediaMutation, CreateMediaMutationVariables>;
export const VehicleTrackingSegmentDocument = new TypedDocumentString(`
    query vehicleTrackingSegment($input: VehicleTrackingSegmentInput!, $event_triggers: [EventTrigger], $media_types: [MediaType]) {
  vehicleTrackingSegment(input: $input) {
    start_time
    end_time
    has_route_steps
    tracking {
      vehicleId
      pathGeojson {
        type
        geometry {
          type
          coordinates
        }
        properties {
          timestamps
        }
      }
    }
    mediaEvents(event_triggers: $event_triggers, media_types: $media_types) {
      id
      media_type
      timestamp
      severity
      media_details {
        ... on EventVideo {
          event_trigger
          latitude
          longitude
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<VehicleTrackingSegmentQuery, VehicleTrackingSegmentQueryVariables>;
